(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4913],{

/***/ 61:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QuoteInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestQuote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"quote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quote"}}}],"directives":[]}]}}],"loc":{"start":0,"end":76}};
    doc.loc.source = {"body":"mutation requestQuote($quote: QuoteInput) {\n  requestQuote(quote: $quote)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.requestQuote = oneQuery(doc, "requestQuote");
        


/***/ }),

/***/ 92621:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscribeToPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stripeToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"Argument","name":{"kind":"Name","value":"coupon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coupon"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percent_off"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":361}};
    doc.loc.source = {"body":"mutation subscribeToPlan(\n  $stripeToken: String!\n  $planId: String!\n  $coupon: String\n) {\n  subscribeToPlan(stripeToken: $stripeToken, planId: $planId, coupon: $coupon) {\n    id\n    plan {\n      product {\n        id\n      }\n      interval\n    }\n    current_period_end\n    status\n    discount {\n      coupon {\n        id\n        percent_off\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.subscribeToPlan = oneQuery(doc, "subscribeToPlan");
        


/***/ }),

/***/ 5500:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPricingDataQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionEndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"availableProducts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxUsers"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percent_off"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionEndDate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":621}};
    doc.loc.source = {"body":"query getPricingDataQuery {\n  me {\n    _id\n    type\n    parent\n    subscriptionEndDate\n    group {\n      _id\n      countryCode\n    }\n    availableProducts {\n      id\n      name\n      metadata {\n        maxUsers\n      }\n      plans {\n        id\n        amount\n        currency\n        interval\n      }\n    }\n    subscription {\n      id\n      plan {\n        product {\n          id\n          name\n        }\n        interval\n      }\n      current_period_end\n      status\n      discount {\n        coupon {\n          id\n          percent_off\n        }\n      }\n    }\n    school {\n      _id\n      subscriptionEndDate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.getPricingDataQuery = oneQuery(doc, "getPricingDataQuery");
        


/***/ }),

/***/ 82793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MediaQuery; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92777);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82262);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10748);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45959);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36409);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var MediaQuery = /*#__PURE__*/function (_Component) {
  (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MediaQuery, _Component);

  var _super = _createSuper(MediaQuery);

  function MediaQuery(props) {
    var _this;

    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, MediaQuery);

    _this = _super.call(this, props);
    _this.state = _this.getScreenSpecs();
    _this.updateScreenSpecs = _this.updateScreenSpecs.bind((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this));
    _this.debouncedUpdateScreenSpecs = (0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this.updateScreenSpecs, 200);
    return _this;
  }

  (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(MediaQuery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScreenSpecs();
      window.addEventListener('resize', this.debouncedUpdateScreenSpecs);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedUpdateScreenSpecs);
    }
  }, {
    key: "getScreenSpecs",
    value: function getScreenSpecs() {
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      return {
        screenWidth: screenWidth,
        screenHeight: screenHeight
      };
    }
  }, {
    key: "updateScreenSpecs",
    value: function updateScreenSpecs() {
      var _this$getScreenSpecs = this.getScreenSpecs(),
          screenWidth = _this$getScreenSpecs.screenWidth,
          screenHeight = _this$getScreenSpecs.screenHeight;

      this.setState({
        screenWidth: screenWidth,
        screenHeight: screenHeight
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          screenWidth = _this$state.screenWidth,
          screenHeight = _this$state.screenHeight;
      var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function (child) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, {
          screenWidth: screenWidth,
          screenHeight: screenHeight
        });
      });
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: childrenWithProps
      });
    }
  }]);

  return MediaQuery;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);



/***/ }),

/***/ 65715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IconButton; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/UI/Button/Button.js + 1 modules
var Button = __webpack_require__(93195);
// EXTERNAL MODULE: ./components/UI/Icon/Icon.js
var Icon = __webpack_require__(77032);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
;// CONCATENATED MODULE: ./components/UI/Button/IconButton.styles.js


var contentStyles = function contentStyles(props) {
  switch (props.size) {
    case 'small':
      return (0,styled_components_browser_esm/* css */.iv)(["padding-left:17px;"]);

    case 'regular':
      return (0,styled_components_browser_esm/* css */.iv)(["padding-left:24px;"]);

    case 'large':
      return (0,styled_components_browser_esm/* css */.iv)(["padding-left:33px;"]);

    case 'x-large':
      return (0,styled_components_browser_esm/* css */.iv)(["padding-left:44px;"]);

    default:
      return null;
  }
};

var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IconButtonstyles__Content",
  componentId: "sc-j3574z-0"
})(["font-family:'nzk' !important;", ";"], contentStyles);

var iconContainerStyles = function iconContainerStyles(props) {
  switch (props.size) {
    case 'small':
      return (0,styled_components_browser_esm/* css */.iv)(["left:7px;"]);

    case 'regular':
      return (0,styled_components_browser_esm/* css */.iv)(["left:11px;"]);

    case 'large':
      return (0,styled_components_browser_esm/* css */.iv)(["left:14px;"]);

    case 'x-large':
      return (0,styled_components_browser_esm/* css */.iv)(["left:22px;"]);

    default:
      return null;
  }
};

var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "IconButtonstyles__IconContainer",
  componentId: "sc-j3574z-1"
})(["position:absolute;", ";height:100%;display:flex;flex-direction:column;justify-content:center;"], iconContainerStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/UI/Button/IconButton.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







/* harmony default export */ var IconButton = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
      size: props.size,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, _objectSpread(_objectSpread({}, props), {}, {
        name: props.iconName
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
      size: props.size,
      children: props.children
    })]
  }));
});

/***/ }),

/***/ 53576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54490);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var nonDecimalCurrencies = ['jpy', 'mga', 'bif', 'clp', 'pyg', 'djf', 'rwf', 'gnf', 'ugx', 'vnd', 'vuv', 'xaf', 'kmf', 'xof', 'krw', 'xpf']; // If the currency is zero-decimal, 
// then multiply the amount by 100 to show the correct value
// https://stripe.com/docs/currencies#zero-decimal

var convertAmount = function convertAmount(amount, currency) {
  if (nonDecimalCurrencies.indexOf(currency.toLowerCase()) > -1) {
    return amount * 100;
  }

  return amount;
};

var Currency = function Currency(props) {
  var currency = props.currency,
      amount = props.amount,
      minimumFractionDigits = props.minimumFractionDigits,
      maximumFractionDigits = props.maximumFractionDigits;

  if (nonDecimalCurrencies.indexOf(currency.toLowerCase()) > -1) {
    minimumFractionDigits = 0;
    maximumFractionDigits = 0;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* .FormattedNumber */ .BK, {
    value: convertAmount(amount, currency),
    style: "currency",
    currency: currency,
    minimumFractionDigits: minimumFractionDigits > -1 ? minimumFractionDigits : 2,
    maximumFractionDigits: maximumFractionDigits > -1 ? maximumFractionDigits : 2
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Currency);

/***/ }),

/***/ 41992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92777);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82262);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10748);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45959);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var formsy_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98671);
/* harmony import */ var _FormInput_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86720);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96782);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var SelectInput = /*#__PURE__*/function (_React$Component) {
  (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(SelectInput, _React$Component);

  var _super = _createSuper(SelectInput);

  function SelectInput(props) {
    var _this;

    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, SelectInput);

    _this = _super.call(this, props);
    _this.changeValue = _this.changeValue.bind((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this));
    return _this;
  }

  (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(SelectInput, [{
    key: "changeValue",
    value: function changeValue(val) {
      this.props.setValue(val && val.value);

      if (this.props.onChange) {
        this.props.onChange(val);
      }
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      if (!this.props.isFormSubmitted()) return;

      if (this.props.isRequired() && !this.props.getValue()) {
        return "".concat(this.props.fieldName || 'This field', " is required");
      }

      return this.props.getErrorMessage();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_FormInput_styles__WEBPACK_IMPORTED_MODULE_4__/* .Wrapper */ .im, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormInput_styles__WEBPACK_IMPORTED_MODULE_4__/* .FieldWrapper */ .n2, {
          displayStyle: this.props.displayStyle,
          inputWidth: this.props.inputWidth,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormInput_styles__WEBPACK_IMPORTED_MODULE_4__/* .FieldName */ .Lp, {
            color: this.props.fieldNameColor,
            children: this.props.fieldName
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
          defaultValue: this.props.value,
          options: this.props.options,
          onChange: this.changeValue,
          wrapperStyle: this.props.wrapperStyle
        })]
      });
    }
  }]);

  return SelectInput;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);

/* harmony default export */ __webpack_exports__["Z"] = ((0,formsy_react__WEBPACK_IMPORTED_MODULE_3__/* .withFormsy */ .pd)(SelectInput));

/***/ }),

/***/ 81754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SettingsSelect; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formsy-react/lib/index.js
var lib = __webpack_require__(98671);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
// EXTERNAL MODULE: ./themes/styles/dimensions.js
var dimensions = __webpack_require__(73085);
// EXTERNAL MODULE: ./components/UI/FormInput/FormInput.styles.js
var FormInput_styles = __webpack_require__(86720);
;// CONCATENATED MODULE: ./components/UI/FormInput/Select.styles.js




var selectArrowStyle = function selectArrowStyle(props) {
  return props.disabled || props.noArrow ? null : (0,styled_components_browser_esm/* css */.iv)(["&:after{content:\"\";position:absolute;z-index:2;right:8px;bottom:", ";border-top:6px solid #dddfdf;border-left:6px solid transparent;border-right :6px solid transparent;pointer-events:none;}"], function (props) {
    return props.narrow ? '25px' : '30px';
  });
};

var SelectFieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Selectstyles__SelectFieldWrapper",
  componentId: "sc-11sfaxt-0"
})(["", ";", ""], FormInput_styles/* fieldDisplayStyle */.WC, selectArrowStyle);
var StyledSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
  displayName: "Selectstyles__StyledSelect",
  componentId: "sc-11sfaxt-1"
})(["width:", ";padding:", ";margin-bottom:2px;font-size:", ";font-family:'Libre Baskerville',Baskerville,'Baskerville Old Face','Hoefler Text',Garamond,'Times New Roman',serif;", " color:", ";border-radius:8px;border:2px solid;", ";opacity:", ";-webkit-appearance:none;-moz-appearance:none;"], function (props) {
  return props.inputWidth || '100%';
}, function (props) {
  return props.narrow ? '4px 8px' : '8px';
}, function (props) {
  return props.textSize || dimensions/* fontSize.milli */.JB.milli;
}, FormInput_styles/* backgroundColorStyle */.hn, function (props) {
  return props.color || '#000';
}, FormInput_styles/* borderColorStyle */.wH, function (props) {
  return props.opacity;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/UI/FormInput/SettingsSelect.js








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// MERGE CONFLICTS RESULT: ORIGINALLY CREATED IN SETTINGS







var Select = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Select);

    _this = _super.call(this, props);
    _this.changeValue = _this.changeValue.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(Select, [{
    key: "changeValue",
    value: function changeValue(event) {
      this.props.onChange ? this.props.onChange(event) : null;
      this.props.setValue(event.target.value);
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      if (!this.props.isFormSubmitted()) return;

      if (this.props.isRequired() && !this.props.getValue()) {
        return "".concat(this.props.fieldName || 'This field', " is required");
      }

      return this.props.getErrorMessage();
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      return this.props.options.map(function (option) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
          value: option.value,
          children: option.title
        }, option.title);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormInput_styles/* Wrapper */.im, _objectSpread(_objectSpread({
        className: this.props.className
      }, this.props), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SelectFieldWrapper, {
          displayStyle: this.props.displayStyle,
          fieldMargin: this.props.fieldMargin,
          disabled: this.props.disabled,
          noArrow: this.props.noArrow,
          narrow: this.props.narrow,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormInput_styles/* FieldName */.Lp, {
            color: this.props.fieldNameColor,
            textSize: this.props.fieldNameSize,
            fieldNameMargin: this.props.fieldNameMargin,
            children: this.props.fieldName
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSelect, {
            name: this.props.name,
            color: this.props.inputColor,
            onChange: this.changeValue,
            type: this.props.type || 'text',
            value: this.props.getValue() || '',
            inputWidth: this.props.inputWidth,
            textSize: this.props.textSize,
            backgroundColor: this.props.backgroundColor,
            focusColor: this.props.focusColor,
            backgroundFocusColor: this.props.backgroundFocusColor,
            errorColor: this.props.errorColor,
            noBorder: this.props.noBorder,
            isInvalid: this.getErrorMessage() && true,
            disabled: this.props.disabled,
            opacity: this.props.inputOpacity,
            narrow: this.props.narrow,
            children: this.renderOptions()
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput_styles/* ErrorMessage */.Bc, {
          errorColor: this.props.errorColor,
          children: this.getErrorMessage()
        })]
      }));
    }
  }]);

  return Select;
}(react.Component);

/* harmony default export */ var SettingsSelect = ((0,lib/* withFormsy */.pd)(Select));

/***/ }),

/***/ 60702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormInput_Textarea; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/formsy-react/lib/index.js
var lib = __webpack_require__(98671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/UI/FormInput/FormInput.styles.js
var FormInput_styles = __webpack_require__(86720);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
// EXTERNAL MODULE: ./themes/styles/dimensions.js
var dimensions = __webpack_require__(73085);
;// CONCATENATED MODULE: ./components/UI/FormInput/Textarea.styles.js



var StyledTextarea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "Textareastyles__StyledTextarea",
  componentId: "sc-1p48lpl-0"
})(["width:", ";padding:", ";margin-bottom:2px;font-size:", ";font-family:'Libre Baskerville',Baskerville,'Baskerville Old Face','Hoefler Text',Garamond,'Times New Roman',serif;", " color:", ";border-radius:", ";border:2px solid;", ";border-top:", ";&::placeholder{color:", ";}resize:", ""], function (props) {
  return props.inputWidth || '100%';
}, function (props) {
  return props.narrow ? '4px 8px' : '8px';
}, function (props) {
  return props.textSize || dimensions/* fontSize.milli */.JB.milli;
}, FormInput_styles/* backgroundColorStyle */.hn, function (props) {
  return props.color || '#000';
}, function (props) {
  return props.noRadius ? null : '8px';
}, FormInput_styles/* borderColorStyle */.wH, function (props) {
  return props.topBorderOnly ? '4px solid lightgrey' : null;
}, function (props) {
  return props.placeholderColor || '#dddfdf';
}, function (props) {
  return props.resizable ? 'vertical' : 'none';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/UI/FormInput/Textarea.js







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var Textarea = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Textarea, _React$Component);

  var _super = _createSuper(Textarea);

  function Textarea(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Textarea);

    _this = _super.call(this, props);
    _this.changeValue = _this.changeValue.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(Textarea, [{
    key: "changeValue",
    value: function changeValue(event) {
      this.props.onChange ? this.props.onChange(event) : null;
      this.props.setValue(event.currentTarget.value);
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      if (this.props.validateOnType) {
        return this.props.getErrorMessage();
      }

      if (!this.props.isFormSubmitted()) return;

      if (this.props.isRequired() && !this.props.getValue()) {
        return "".concat(this.props.fieldName || 'This field', " is required");
      }

      return this.props.getErrorMessage();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormInput_styles/* Wrapper */.im, {
        className: this.props.className,
        width: this.props.width,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormInput_styles/* FieldWrapper */.n2, {
          displayStyle: this.props.displayStyle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormInput_styles/* FieldName */.Lp, {
            color: this.props.fieldNameColor,
            textSize: this.props.fieldNameSize,
            children: this.props.fieldName
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTextarea, {
            name: this.props.name,
            placeholder: this.props.placeholder || '',
            placeholderColor: this.props.placeholderColor,
            color: this.props.inputColor,
            onChange: this.changeValue,
            value: this.props.getValue() || '',
            inputWidth: this.props.inputWidth,
            textSize: this.props.textSize,
            rows: this.props.rows,
            resizable: this.props.resizable,
            backgroundColor: this.props.backgroundColor,
            focusColor: this.props.focusColor,
            backgroundFocusColor: this.props.backgroundFocusColor,
            errorColor: this.props.errorColor,
            noBorder: this.props.noBorder,
            isInvalid: this.getErrorMessage() && true,
            disabled: this.props.disabled,
            narrow: this.props.narrow,
            noRadius: this.props.noRadius,
            topBorderOnly: this.props.topBorderOnly
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput_styles/* ErrorMessage */.Bc, {
          errorColor: this.props.errorColor,
          positionRelative: this.props.positionRelative,
          children: this.getErrorMessage()
        })]
      });
    }
  }]);

  return Textarea;
}(react.Component);

/* harmony default export */ var FormInput_Textarea = ((0,lib/* withFormsy */.pd)(Textarea));

/***/ }),

/***/ 61516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; },
/* harmony export */   "n": function() { return /* binding */ WrapperNoUI; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83058);

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Uploaderstyles__Wrapper",
  componentId: "sc-9v5bmu-0"
})([".progress{position:absolute;top:2px;left:2px;height:100%;z-index:-1;border-radius:3px;}.progress-label{text-align:center;font-size:40px;font-weight:bold;line-height:200px;color:white;}.label{color:white;font-size:23px;opacity:0.8;padding:10px;text-align:center;justify-content:center;margin-top:55px;}"]);
var WrapperNoUI = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Uploaderstyles__WrapperNoUI",
  componentId: "sc-9v5bmu-1"
})(["height:100%;width:100%;> div{background-color:rgba(255,255,255,0.3);}"]);

/***/ }),

/***/ 45289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useFileServer; }
/* harmony export */ });
/* unused harmony export FileServer */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var providers_Authentication__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34170);




var FILE_SERVER_URL = 'https://the-file-server.nightzookeeper.com';
var FileServer = {
  upload: function () {
    var _upload = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, token, transforms) {
      var formData, _yield$Axios$post, data;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _context.next = 4;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(FILE_SERVER_URL, "/images").concat(transforms ? "/".concat(transforms) : ''), formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': "Bearer ".concat(token)
                }
              });

            case 4:
              _yield$Axios$post = _context.sent;
              data = _yield$Axios$post.data;
              return _context.abrupt("return", data);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function upload(_x, _x2, _x3) {
      return _upload.apply(this, arguments);
    }

    return upload;
  }(),
  uploadV2: function () {
    var _uploadV = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(file, token, path, transforms) {
      var formData, _yield$Axios$post2, data;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              formData.append('path', path || '/');
              _context2.next = 5;
              return axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(FILE_SERVER_URL, "/v2/images").concat(transforms ? "/".concat(transforms) : ''), formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': "Bearer ".concat(token)
                }
              });

            case 5:
              _yield$Axios$post2 = _context2.sent;
              data = _yield$Axios$post2.data;
              return _context2.abrupt("return", data);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function uploadV2(_x4, _x5, _x6, _x7) {
      return _uploadV.apply(this, arguments);
    }

    return uploadV2;
  }()
};
var useFileServer = function useFileServer() {
  var _useAuthentication = (0,providers_Authentication__WEBPACK_IMPORTED_MODULE_2__/* .useAuthentication */ .J)(),
      token = _useAuthentication.token;

  var upload = /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(file, transforms) {
      var _token$accessToken;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (token) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", null);

            case 2:
              return _context3.abrupt("return", FileServer.upload(file, (_token$accessToken = token.accessToken) === null || _token$accessToken === void 0 ? void 0 : _token$accessToken.value, transforms));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function upload(_x8, _x9) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    upload: upload
  };
};

/***/ }),

/***/ 64913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DashboardSettings; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./providers/CurrentUser/index.ts + 2 modules
var CurrentUser = __webpack_require__(54162);
// EXTERNAL MODULE: ./components/Context/ModalContext.js
var ModalContext = __webpack_require__(64709);
// EXTERNAL MODULE: ./modules/dashboard/Home/components/NavBar/NavBar.js + 1 modules
var NavBar = __webpack_require__(24716);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
// EXTERNAL MODULE: ./node_modules/formsy-react/lib/index.js
var formsy_react_lib = __webpack_require__(98671);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./config.ts
var config = __webpack_require__(39261);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
var FileSaver_min_default = /*#__PURE__*/__webpack_require__.n(FileSaver_min);
;// CONCATENATED MODULE: ./lib/delay.js
function delay(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}
// EXTERNAL MODULE: ./lib/analytics.js
var analytics = __webpack_require__(57837);
// EXTERNAL MODULE: ./components/UI/Button/Button.js + 1 modules
var Button = __webpack_require__(93195);
// EXTERNAL MODULE: ./components/UI/Button/IconButton.js + 1 modules
var IconButton = __webpack_require__(65715);
// EXTERNAL MODULE: ./components/UI/Icon/Icon.js
var Icon = __webpack_require__(77032);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
// EXTERNAL MODULE: ./modules/dashboard/DashboardSettings/DashboardSettings.styles.js
var DashboardSettings_styles = __webpack_require__(42380);
// EXTERNAL MODULE: ./modules/dashboard/Home/Dashboard.global.styles.js
var Dashboard_global_styles = __webpack_require__(3862);
// EXTERNAL MODULE: ./components/UI/FormInput/SettingsSelect.js + 1 modules
var SettingsSelect = __webpack_require__(81754);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/StudentInfoRow/StudentInfoRow.styles.js





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentInfoRowstyles__Wrapper",
  componentId: "sc-13up3wj-0"
})(["display:flex;flex-flow:row wrap;"]);
var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(SettingsSelect/* default */.Z).withConfig({
  displayName: "StudentInfoRowstyles__StyledSelect",
  componentId: "sc-13up3wj-1"
})(["margin-right:20px;"]);
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "StudentInfoRowstyles__StyledButton",
  componentId: "sc-13up3wj-2"
})(["margin-top:4px;"]);
var ClassroomIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentInfoRowstyles__ClassroomIcon",
  componentId: "sc-13up3wj-3"
})(["background-image:url('", "/icons/classroom.png');background-size:cover;background-position:center;height:31px;width:31px;"], "/edu/assets");
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/StudentInfoRow/StudentInfoRow.js










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }














var StudentInfoRow = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(StudentInfoRow, _Component);

  var _super = _createSuper(StudentInfoRow);

  function StudentInfoRow(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, StudentInfoRow);

    _this = _super.call(this, props);
    _this.state = {
      screenWidth: 0,
      isDownloadingInfo: false
    };
    _this.updateScreenWidth = _this.updateScreenWidth.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onInputChange = _this.onInputChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.debouncedInputChange = lodash_debounce_default()(_this.onInputChange, 500);
    return _this;
  }

  (0,createClass/* default */.Z)(StudentInfoRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScreenWidth();
      window.addEventListener('resize', this.updateScreenWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateScreenWidth);
    }
  }, {
    key: "updateScreenWidth",
    value: function updateScreenWidth() {
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.setState({
        screenWidth: screenWidth
      });
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(target) {
      this.props.setStudentState({
        _id: this.props.info._id,
        field: target.name,
        value: target.value
      });
    }
  }, {
    key: "onDownloadStudentInfo",
    value: function onDownloadStudentInfo() {
      var _this2 = this;

      this.setState({
        isDownloadingInfo: true
      });
      var isParent = this.props.isParent;
      var data = {
        template: isParent ? 'child_letter' : 'student_letter',
        data: {
          student: this.props.info
        }
      };
      axios_default()({
        method: 'post',
        url: "https://europe-west1-awesome-caster-213612.cloudfunctions.net/generate-teacher-pdf",
        data: data,
        responseType: 'blob'
      }).then(function (res) {
        FileSaver_min_default().saveAs(new Blob([res.data], {
          type: 'application/pdf'
        }), "NZK-Student-Letters.pdf");

        _this2.setState({
          isDownloadingInfo: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          info = _this$props.info,
          isEditMode = _this$props.isEditMode,
          isParent = _this$props.isParent,
          openParentEmailPopup = _this$props.openParentEmailPopup;
      var screenWidth = this.state.screenWidth;
      var commonProps = {
        placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundColor: isEditMode ? null : Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue,
        inputColor: isEditMode ? null : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
        noBorder: !isEditMode,
        focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
        element: 'button',
        disabled: !isEditMode,
        autoComplete: 'off',
        narrow: true,
        textSize: '15px',
        fieldNameSize: '18px',
        inputOpacity: info.stagedForDeletion ? '0.5' : '1',
        width: screenWidth <= 950 ? '120px' : '140px'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, _objectSpread(_objectSpread({}, commonProps), {}, {
          value: info.name,
          onChange: function onChange(e) {
            return _this3.debouncedInputChange(e.target);
          },
          name: "name",
          placeholder: "First name"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          value: "autofix",
          onChange: function onChange() {},
          name: "username",
          placeholder: "Username",
          hidden: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, _objectSpread(_objectSpread({}, commonProps), {}, {
          value: info.username,
          onChange: function onChange(e) {
            return _this3.debouncedInputChange(e.target);
          },
          name: "username",
          placeholder: "Username",
          customValidator: {
            test: function () {
              var _test = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
                var isValid;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this3.props.isValidUsername(e, info._id);

                      case 2:
                        isValid = _context.sent;
                        return _context.abrupt("return", isValid);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function test(_x) {
                return _test.apply(this, arguments);
              }

              return test;
            }(),
            errorMessage: 'Username taken or invalid',
            preSubmit: true,
            checkOnMount: true,
            isRequired: true
          },
          required: true
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, _objectSpread(_objectSpread({}, commonProps), {}, {
          value: info.password,
          onChange: function onChange(e) {
            return _this3.debouncedInputChange(e.target);
          },
          name: "password",
          placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
          placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
          type: "password",
          validations: "minLength:4",
          validationError: "Password too short"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          value: "autofix",
          onChange: function onChange() {},
          name: "email",
          placeholder: "Email",
          hidden: true
        }), !isParent && /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, _objectSpread(_objectSpread({}, commonProps), {}, {
          value: info.parentEmail,
          onChange: function onChange(e) {
            return _this3.debouncedInputChange(e.target);
          },
          onFocus: openParentEmailPopup,
          name: "parentEmail",
          placeholder: "Parent email",
          width: screenWidth <= 950 ? '120px' : '220px',
          validations: "isEmail",
          validationError: "Email not valid"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSelect, _objectSpread(_objectSpread({}, commonProps), {}, {
          value: info.yearGroup,
          onChange: function onChange(e) {
            return _this3.debouncedInputChange(e.target);
          },
          name: "yearGroup",
          options: [{
            title: 'up to 7',
            value: 1
          }, {
            title: '7-8',
            value: 2
          }, {
            title: '8-9',
            value: 3
          }, {
            title: '9-10',
            value: 4
          }, {
            title: '10-11',
            value: 5
          }, {
            title: '11 and above',
            value: 6
          }],
          noArrow: info.stagedForDeletion
        })), !info.stagedForDeletion && (isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
          element: "button",
          type: "button",
          size: "regular",
          round: true,
          bgColor: isEditMode ? Dashboard_global_styles/* colors.red */.O9.red : this.props.isGoogleGroup ? 'rgba(0,0,0,0)' : Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
          onClick: function onClick() {
            return _this3.props.onRemoveStudent(info._id);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "trash",
            color: "white",
            size: "regular"
          })
        }, 1) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
          element: "button",
          type: "button",
          size: "regular",
          round: true,
          bgColor: this.props.isGoogleGroup ? 'rgba(0,0,0,0)' : Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
          disabled: this.state.isDownloadingInfo,
          onClick: function onClick() {
            return _this3.props.isGoogleGroup ? _this3.props.syncGoogleStudents() : _this3.onDownloadStudentInfo();
          },
          children: this.props.isGoogleGroup ? !info.google && !info.demo ? /*#__PURE__*/(0,jsx_runtime.jsx)(ClassroomIcon, {}) : null : /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "print",
            color: "white",
            size: "regular"
          })
        }, 2))]
      });
    }
  }]);

  return StudentInfoRow;
}(react.Component);


// EXTERNAL MODULE: ./components/UI/FormInput/FormInput.js
var FormInput = __webpack_require__(41102);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/MobileStudentInfoRow/MobileStudentInfoRow.styles.js




var MobileStudentInfoRow_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MobileStudentInfoRowstyles__Wrapper",
  componentId: "sc-6xbu6m-0"
})(["display:flex;flex-flow:row wrap;justify-content:center;"]);
var StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "MobileStudentInfoRowstyles__StyledFormInput",
  componentId: "sc-6xbu6m-1"
})(["margin-left:5px;margin-right:5px;font-size:", ";"], DashboardSettings_styles/* fontSize.small */.JB.small);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/MobileStudentInfoRow/MobileStudentInfoRow.js









function MobileStudentInfoRow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MobileStudentInfoRow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileStudentInfoRow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileStudentInfoRow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function MobileStudentInfoRow_createSuper(Derived) { var hasNativeReflectConstruct = MobileStudentInfoRow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function MobileStudentInfoRow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var MobileStudentInfoRow_StudentInfoRow = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(StudentInfoRow, _Component);

  var _super = MobileStudentInfoRow_createSuper(StudentInfoRow);

  function StudentInfoRow(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, StudentInfoRow);

    _this = _super.call(this, props);
    _this.onInputChange = _this.onInputChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.debouncedInputChange = lodash_debounce_default()(_this.onInputChange, 500);
    return _this;
  }

  (0,createClass/* default */.Z)(StudentInfoRow, [{
    key: "onInputChange",
    value: function onInputChange(target) {
      this.props.setStudentState({
        _id: this.props.info._id,
        field: target.name,
        value: target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          info = _this$props.info,
          isEditMode = _this$props.isEditMode,
          isParent = _this$props.isParent;
      var commonProps = {
        placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundColor: isEditMode ? null : Dashboard_global_styles/* colors.lightPurple */.O9.lightPurple,
        inputColor: isEditMode ? null : Dashboard_global_styles/* colors.white */.O9.white,
        noBorder: !isEditMode,
        focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
        element: 'button',
        disabled: !isEditMode,
        autoComplete: 'off',
        narrow: true,
        textSize: '15px',
        fieldNameSize: '18px',
        inputOpacity: info.stagedForDeletion ? '0.2' : '1'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileStudentInfoRow_styles_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          value: "autofix",
          onChange: function onChange() {},
          name: "username",
          placeholder: "Username",
          hidden: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormInput, MobileStudentInfoRow_objectSpread(MobileStudentInfoRow_objectSpread({}, commonProps), {}, {
          value: info.username,
          onChange: function onChange(e) {
            return _this2.debouncedInputChange(e.target);
          },
          name: "username",
          placeholder: "Username",
          width: "140px",
          customValidator: {
            test: function () {
              var _test = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
                var isValid;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.props.isValidUsername(e, info._id);

                      case 2:
                        isValid = _context.sent;
                        return _context.abrupt("return", isValid);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function test(_x) {
                return _test.apply(this, arguments);
              }

              return test;
            }(),
            errorMessage: 'Username taken or invalid',
            preSubmit: true
          },
          required: true
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormInput, MobileStudentInfoRow_objectSpread(MobileStudentInfoRow_objectSpread({}, commonProps), {}, {
          value: info.password,
          onChange: function onChange(e) {
            return _this2.debouncedInputChange(e.target);
          },
          name: "password",
          placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
          placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.white */.O9.white,
          width: "140px",
          type: "password",
          validations: "minLength:4",
          validationError: "Password too short"
        }))]
      });
    }
  }]);

  return StudentInfoRow;
}(react.Component);


// EXTERNAL MODULE: ./modules/dashboard/DashboardPopup/DashboardPopup.js + 1 modules
var DashboardPopup = __webpack_require__(64558);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/SensitiveInfoPopup/SensitiveInfoPopup.styles.js






var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "SensitiveInfoPopupstyles__Title",
  componentId: "sc-xo1xks-0"
})(["font-size:", ";font-weight:600;color:", ";text-align:center;margin-top:-10px;margin-bottom:20px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var StyledForm = (0,styled_components_browser_esm/* default */.ZP)(formsy_react_lib/* default */.ZP).withConfig({
  displayName: "SensitiveInfoPopupstyles__StyledForm",
  componentId: "sc-xo1xks-1"
})(["display:flex;justify-content:center;"]);
var SensitiveInfoPopup_styles_StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "SensitiveInfoPopupstyles__StyledFormInput",
  componentId: "sc-xo1xks-2"
})(["font-size:", ";"], DashboardSettings_styles/* fontSize.small */.JB.small);
var ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SensitiveInfoPopupstyles__ButtonRow",
  componentId: "sc-xo1xks-3"
})(["display:flex;justify-content:center;margin-bottom:20px;"]);
var Footnote = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "SensitiveInfoPopupstyles__Footnote",
  componentId: "sc-xo1xks-4"
})(["color:", ";font-size:", ";text-align:center;margin-top:0px;"], function (props) {
  return props.color;
}, DashboardSettings_styles/* fontSize.small */.JB.small);
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "SensitiveInfoPopupstyles__Link",
  componentId: "sc-xo1xks-5"
})(["color:", ";font-size:13px;text-align:center;text-decoration:underline;"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/SensitiveInfoPopup/SensitiveInfoPopup.js






function SensitiveInfoPopup_createSuper(Derived) { var hasNativeReflectConstruct = SensitiveInfoPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SensitiveInfoPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var SensitiveInfoPopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(SensitiveInfoPopup, _Component);

  var _super = SensitiveInfoPopup_createSuper(SensitiveInfoPopup);

  function SensitiveInfoPopup() {
    (0,classCallCheck/* default */.Z)(this, SensitiveInfoPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(SensitiveInfoPopup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        isSettings: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: "You are changing sensitive information"
        }), this.props.passwordError ? /*#__PURE__*/(0,jsx_runtime.jsx)(Footnote, {
          color: Dashboard_global_styles/* colors.red */.O9.red,
          children: "Incorrect password - please try again"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Footnote, {
          color: Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal,
          children: "Please enter your ".concat(this.props.isChangingPassword ? 'old' : '', " password")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledForm, {
          id: "password-popup",
          onValidSubmit: this.props.onConfirm,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SensitiveInfoPopup_styles_StyledFormInput, {
            placeholderColor: Dashboard_global_styles/* colors.grey */.O9.grey,
            focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
            backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
            element: 'button',
            narrow: true,
            width: "140px",
            textSize: "15px",
            fieldNameSize: "18px",
            onChange: this.onInputChange,
            name: "password",
            placeholder: "Password",
            type: "password",
            required: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            element: "button",
            type: "submit",
            form: "password-popup",
            bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
            color: "white",
            size: "regular",
            children: "Submit"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.red */.O9.red,
            color: "white",
            size: "regular",
            onClick: this.props.onCancel,
            children: "Cancel"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          href: "https://www.nightzookeeper.com/edu/forgot-password",
          target: "_blank",
          children: "Forgot your ".concat(this.props.isChangingPassword ? 'old' : '', " password?")
        })]
      });
    }
  }]);

  return SensitiveInfoPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/ParentEmailPopup/ParentEmailPopup.styles.js



var ParentEmailPopup_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "ParentEmailPopupstyles__Title",
  componentId: "sc-okvjtz-0"
})(["font-size:", ";font-weight:600;color:", ";text-align:center;margin-top:0px;margin-bottom:20px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ParentEmailPopupstyles__Note",
  componentId: "sc-okvjtz-1"
})(["color:", ";font-size:", ";text-align:center;margin-top:0px;margin-bottom:20px;"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, DashboardSettings_styles/* fontSize.small */.JB.small);
var EmailCopy = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ParentEmailPopupstyles__EmailCopy",
  componentId: "sc-okvjtz-2"
})(["color:", ";font-size:13px;text-align:left;margin-top:0px;margin-bottom:30px;padding-left:15px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var ParentEmailPopup_styles_ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ParentEmailPopupstyles__ButtonRow",
  componentId: "sc-okvjtz-3"
})(["display:flex;justify-content:center;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/ParentEmailPopup/ParentEmailPopup.js






function ParentEmailPopup_createSuper(Derived) { var hasNativeReflectConstruct = ParentEmailPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ParentEmailPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var ParentEmailPopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ParentEmailPopup, _Component);

  var _super = ParentEmailPopup_createSuper(ParentEmailPopup);

  function ParentEmailPopup() {
    (0,classCallCheck/* default */.Z)(this, ParentEmailPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(ParentEmailPopup, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: function onCancel() {
          _this.props.setSeenStatus();

          _this.props.onCancel();
        },
        height: "600px",
        width: "550px",
        isSettings: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ParentEmailPopup_styles_Title, {
          children: "Adding a parent email"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Note, {
          children: "Adding or a parent e-mail to any of your students will send the following information to the parent:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(EmailCopy, {
          children: ["Hello!", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Your child's teacher would love you to see the amazing work they've been doing on Night Zookeeper.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Here's their profile page: https://www.nightzookeeper.com/edu/zoo/profile/child-username", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "You can check in on their progress regularly at the link above.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "If you would like to leave them comments, you need to sign-up for a Commenter account.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Very best wishes,", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "The Night Zookeeper Team", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "* Night Zookeeper is a writing improvement tool. We don't collect any personal information from children. If you have any questions at all about our website please contact us on support@nightzookeeper.com. We will aim to reply within 24 hours. You can review our Terms of Use and Privacy Policy at any time."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ParentEmailPopup_styles_ButtonRow, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            size: "regular",
            width: "105px",
            height: "30px",
            onClick: function onClick() {
              _this.props.setSeenStatus();

              _this.props.onCancel();
            },
            children: "OK"
          })
        })]
      });
    }
  }]);

  return ParentEmailPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/GeneralErrorPopup/GeneralErrorPopup.styles.js




var GeneralErrorPopup_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "GeneralErrorPopupstyles__Title",
  componentId: "sc-1rje0zj-0"
})(["font-size:", ";font-weight:600;color:", ";text-align:center;margin-top:30px;margin-bottom:20px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.pink */.O9.pink);
var GeneralErrorPopup_styles_Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "GeneralErrorPopupstyles__Note",
  componentId: "sc-1rje0zj-1"
})(["color:", ";font-size:", ";text-align:center;margin-top:0px;margin-bottom:60px;"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, DashboardSettings_styles/* fontSize.small */.JB.small);
var GeneralErrorPopup_styles_ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "GeneralErrorPopupstyles__ButtonRow",
  componentId: "sc-1rje0zj-2"
})(["display:flex;justify-content:center;margin-bottom:35px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/GeneralErrorPopup/GeneralErrorPopup.js






function GeneralErrorPopup_createSuper(Derived) { var hasNativeReflectConstruct = GeneralErrorPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function GeneralErrorPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var GeneralErrorPopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(GeneralErrorPopup, _Component);

  var _super = GeneralErrorPopup_createSuper(GeneralErrorPopup);

  function GeneralErrorPopup() {
    (0,classCallCheck/* default */.Z)(this, GeneralErrorPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(GeneralErrorPopup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        isSettings: this.props.isSettings,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup_styles_Title, {
          children: "Whoops!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup_styles_Note, {
          children: "Something went wrong :( Please try again."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup_styles_ButtonRow, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            size: "regular",
            width: "105px",
            height: "30px",
            onClick: this.props.onCancel,
            children: "OK"
          })
        })]
      });
    }
  }]);

  return GeneralErrorPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/StudentList/StudentList.styles.js



var StudentList_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__Wrapper",
  componentId: "sc-1vrivav-0"
})(["margin-bottom:40px;"]);
var TopButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__TopButtonRow",
  componentId: "sc-1vrivav-1"
})(["display:flex;justify-content:flex-end;margin-bottom:10px;> :first-child{margin-right:20px;}"]);
var TitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__TitleRow",
  componentId: "sc-1vrivav-2"
})(["display:flex;flex-flow:row wrap;"]);
var TitleRowElement = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "StudentListstyles__TitleRowElement",
  componentId: "sc-1vrivav-3"
})(["font-size:", ";color:", ";width:", ";margin-top:20px;margin-bottom:20px;@media (max-width:950px){font-size:16px;width:140px;}"], DashboardSettings_styles/* fontSize.medium */.JB.medium, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple, function (props) {
  return props.size === 'large' ? '240px' : props.size === 'small' ? '80px' : '160px';
});
var BottomButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__BottomButtonRow",
  componentId: "sc-1vrivav-4"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var AddButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__AddButtonContainer",
  componentId: "sc-1vrivav-5"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
var AddButtonText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "StudentListstyles__AddButtonText",
  componentId: "sc-1vrivav-6"
})(["font-size:", ";color:", ";vertical-align:middle;padding-left:10px;cursor:pointer;"], DashboardSettings_styles/* fontSize.small */.JB.small, Dashboard_global_styles/* colors.orange */.O9.orange);
var UndoSaveButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__UndoSaveButtonContainer",
  componentId: "sc-1vrivav-7"
})(["display:flex;justify-content:flex-end;align-items:center;"]);
var MobileTopRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__MobileTopRow",
  componentId: "sc-1vrivav-8"
})(["display:flex;justify-content:space-between;align-items:center;width:290px;margin:auto;"]);
var MobileTitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__MobileTitleRow",
  componentId: "sc-1vrivav-9"
})(["display:flex;flex-flow:row wrap;width:290px;margin:auto;"]);
var MobileTitleRowElement = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "StudentListstyles__MobileTitleRowElement",
  componentId: "sc-1vrivav-10"
})(["font-size:", ";color:", ";width:140px;margin:10px auto;margin-right:", ";"], DashboardSettings_styles/* fontSize.small */.JB.small, Dashboard_global_styles/* colors.pink */.O9.pink, function (props) {
  return props.left ? '10px' : '0px';
});
var MobileBottomRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__MobileBottomRow",
  componentId: "sc-1vrivav-11"
})(["display:flex;justify-content:flex-end;width:290px;margin:auto;"]);
var GoogleLoginWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StudentListstyles__GoogleLoginWrapper",
  componentId: "sc-1vrivav-12"
})(["width:195px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/StudentList/StudentList.js











var _templateObject, _templateObject2;

function StudentList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StudentList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StudentList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StudentList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function StudentList_createSuper(Derived) { var hasNativeReflectConstruct = StudentList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function StudentList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }























var StudentList = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(StudentList, _Component);

  var _super = StudentList_createSuper(StudentList);

  function StudentList(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, StudentList);

    _this = _super.call(this, props);
    _this.state = {
      initialState: {},
      students: undefined,
      isEditMode: false,
      hasSeenParentEmailPopup: false
    };
    _this.isValidUsername = _this.isValidUsername.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onAddStudent = _this.onAddStudent.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onRemoveStudent = _this.onRemoveStudent.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.setStudentState = _this.setStudentState.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onSubmit = _this.onSubmit.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.openSensitiveInfoModal = _this.openSensitiveInfoModal.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onDownloadStudentList = _this.onDownloadStudentList.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.openParentEmailPopup = _this.openParentEmailPopup.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.renderMobileBottomButtonRow = _this.renderMobileBottomButtonRow.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(StudentList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.students) {
        var students = this.props.students.filter(function (student) {
          return student.username;
        }).sort(function (a, b) {
          var nameA = a.username.toUpperCase();
          var nameB = b.username.toUpperCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        this.setState({
          initialState: {
            students: students
          },
          students: students
        });
      }
    }
  }, {
    key: "isValidUsername",
    value: function () {
      var _isValidUsername = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(username, userId) {
        var isAlphanumerical, originalUsername, _yield$this$props$cli, data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isAlphanumerical = /^([a-zA-Z0-9]|_|-|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B){3,}$/.test(username);
                originalUsername = (this.state.initialState.students.find(function (student) {
                  return student._id === userId;
                }) || {}).username || this.state.students.find(function (student) {
                  return student._id === userId;
                }).originalUsername;

                if (isAlphanumerical) {
                  _context.next = 5;
                  break;
                }

                this.setValidUsername(userId, false);
                return _context.abrupt("return", false);

              case 5:
                if (!(username === originalUsername)) {
                  _context.next = 8;
                  break;
                }

                this.setValidUsername(userId, true);
                return _context.abrupt("return", true);

              case 8:
                _context.next = 10;
                return this.props.client.query({
                  query: (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        query freeUsername($username: String!) {\n          freeUsername(username: $username)\n        }\n      "]))),
                  variables: {
                    username: username
                  },
                  fetchPolicy: 'network-only'
                });

              case 10:
                _yield$this$props$cli = _context.sent;
                data = _yield$this$props$cli.data;
                this.setValidUsername(userId, data.freeUsername);
                return _context.abrupt("return", data.freeUsername);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isValidUsername(_x, _x2) {
        return _isValidUsername.apply(this, arguments);
      }

      return isValidUsername;
    }()
  }, {
    key: "setValidUsername",
    value: function setValidUsername(id, isValid) {
      this.setState({
        students: this.state.students.map(function (student) {
          if (student._id === id) return StudentList_objectSpread(StudentList_objectSpread({}, student), {}, {
            isValidUsername: isValid
          });
          return student;
        })
      });
    }
  }, {
    key: "allUsernamesValid",
    value: function allUsernamesValid() {
      return this.state.students.every(function (student) {
        return student.isValidUsername !== false;
      });
    }
  }, {
    key: "setStudentState",
    value: function setStudentState(_ref) {
      var _id = _ref._id,
          field = _ref.field,
          value = _ref.value;
      this.setState({
        students: this.state.students.map(function (student) {
          return student._id === _id ? StudentList_objectSpread(StudentList_objectSpread({}, student), {}, (0,defineProperty/* default */.Z)({}, field, value)) : student;
        })
      });
    }
  }, {
    key: "onAddStudent",
    value: function () {
      var _onAddStudent = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _yield$this$props$cli2, data, newUsername;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.client.query({
                  query: (0,lib/* default */.ZP)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n        query generateUsernames($count: Int) {\n          generateUsernames(count: $count)\n        }\n      "]))),
                  variables: {
                    count: 1
                  },
                  fetchPolicy: 'network-only'
                });

              case 2:
                _yield$this$props$cli2 = _context2.sent;
                data = _yield$this$props$cli2.data;
                newUsername = data && data.generateUsernames[0];
                this.setState({
                  students: [].concat((0,toConsumableArray/* default */.Z)(this.state.students), [{
                    _id: Math.floor(Math.random() * 99999999),
                    name: '',
                    username: newUsername || '',
                    originalUsername: newUsername || '',
                    parentEmail: '',
                    yearGroup: this.props.yearGroup,
                    isNew: true
                  }]),
                  isEditMode: true
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onAddStudent() {
        return _onAddStudent.apply(this, arguments);
      }

      return onAddStudent;
    }()
  }, {
    key: "onRemoveStudent",
    value: function onRemoveStudent(studentId) {
      this.setState({
        students: this.state.students.reduce(function (result, student) {
          if (student._id !== studentId) {
            result.push(student);
          } else if (!student.isNew) {
            result.push(StudentList_objectSpread(StudentList_objectSpread({}, student), {}, {
              stagedForDeletion: true
            }));
          }

          return result;
        }, [])
      });
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(auth) {
        var _this2 = this;

        var validationResults, students, changedSensitiveInfo;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                validationResults = this.state.students.map(function (_, i) {
                  _this2.refs["your-class-".concat(i)].submit();

                  return _this2.refs["your-class-".concat(i)].state.isValid;
                });

                if (validationResults.every(function (result) {
                  return result;
                })) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                if (this.allUsernamesValid()) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                students = this.state.students;
                changedSensitiveInfo = this.state.students.some(function (student) {
                  return student.stagedForDeletion;
                });

                if (!changedSensitiveInfo) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", this.openSensitiveInfoModal());

              case 9:
                _context3.prev = 9;
                _context3.next = 12;
                return this.updateStudentDetails();

              case 12:
                _context3.next = 14;
                return this.addStudents();

              case 14:
                this.setState({
                  isEditMode: false
                });
                _context3.next = 17;
                return delay(1000);

              case 17:
                _context3.next = 19;
                return this.refetchData();

              case 19:
                _context3.next = 24;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](9);
                this.props.modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
                  isSettings: true
                }));

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 21]]);
      }));

      function onSubmit(_x3) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "openSensitiveInfoModal",
    value: function openSensitiveInfoModal() {
      var _this3 = this;

      var modal = this.props.modal;
      modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(SensitiveInfoPopup, {
        onConfirm: function onConfirm(_ref2) {
          var password = _ref2.password;
          Promise.all(_this3.state.students.filter(function (student) {
            return student.stagedForDeletion;
          }).map( /*#__PURE__*/function () {
            var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(student) {
              return regenerator_default().wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _this3.props.deleteStudent(student._id, password);

                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x4) {
              return _ref3.apply(this, arguments);
            };
          }())).then( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
            return regenerator_default().wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this3.updateStudentDetails();

                  case 2:
                    _context5.next = 4;
                    return _this3.addStudents();

                  case 4:
                    modal.close();

                    _this3.setState({
                      isEditMode: false
                    });

                    _context5.next = 8;
                    return delay(1000);

                  case 8:
                    _context5.next = 10;
                    return _this3.refetchData();

                  case 10:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })))["catch"](function (e) {
            if (e.graphQLErrors && e.graphQLErrors[0].message === 'Access Denied') {
              return modal.updateProps({
                passwordError: true
              });
            }

            modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
              isSettings: true
            }));
          });
        },
        onCancel: function onCancel() {
          return modal.close();
        }
      }), 'sensitiveInfoPopup');
    }
  }, {
    key: "updateStudentDetails",
    value: function () {
      var _updateStudentDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.props.updateStudentDetails(this.state.students.filter(function (student) {
                  return !student.stagedForDeletion && !student.isNew;
                }).map(function (student) {
                  return {
                    _id: student._id,
                    name: student.name,
                    username: student.username,
                    password: student.password,
                    parentEmail: student.parentEmail,
                    yearGroup: parseInt(student.yearGroup)
                  };
                }));

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6["catch"](0);
                throw _context6.t0;

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function updateStudentDetails() {
        return _updateStudentDetails.apply(this, arguments);
      }

      return updateStudentDetails;
    }()
  }, {
    key: "addStudents",
    value: function () {
      var _addStudents = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
        var studentsToAdd;
        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                studentsToAdd = this.state.students.filter(function (student) {
                  return student.isNew;
                }).map(function (student) {
                  return {
                    name: student.name,
                    username: student.username,
                    password: student.password,
                    parentEmail: student.parentEmail,
                    yearGroup: parseInt(student.yearGroup)
                  };
                });
                _context7.next = 3;
                return this.props.addStudents(studentsToAdd, this.props.loggedInUser._id);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addStudents() {
        return _addStudents.apply(this, arguments);
      }

      return addStudents;
    }()
  }, {
    key: "refetchData",
    value: function () {
      var _refetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
        var _yield$this$props$cli3, data, students;

        return regenerator_default().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.props.client.query({
                  query: this.props.queries[0].query,
                  fetchPolicy: 'network-only'
                });

              case 2:
                _yield$this$props$cli3 = _context8.sent;
                data = _yield$this$props$cli3.data;
                students = data.me.group.students.users.filter(function (student) {
                  return student.username;
                });
                this.setState({
                  initialState: {
                    students: students
                  },
                  students: students
                });

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function refetchData() {
        return _refetchData.apply(this, arguments);
      }

      return refetchData;
    }()
  }, {
    key: "onDownloadStudentList",
    value: function onDownloadStudentList() {
      var _this4 = this;

      this.setState({
        isDownloadingList: true
      });
      var isParent = this.props.isParent;
      var name = this.props.loggedInUser.name;
      var data = {
        template: 'teacher_letter',
        data: StudentList_objectSpread({
          students: this.state.students.filter(function (s) {
            return !s.demo;
          })
        }, isParent ? {
          parent: {
            name: name
          }
        } : {
          teacher: {
            name: name
          }
        })
      };
      axios_default()({
        method: 'post',
        url: "https://europe-west1-awesome-caster-213612.cloudfunctions.net/generate-teacher-pdf",
        data: data,
        responseType: 'blob'
      }).then(function (res) {
        analytics/* default.track */.Z.track("Downloaded student pdf");
        FileSaver_min_default().saveAs(new Blob([res.data], {
          type: 'application/pdf'
        }), "NZK-Student-Letters.pdf");

        _this4.setState({
          isDownloadingList: false
        });
      });
    }
  }, {
    key: "openParentEmailPopup",
    value: function openParentEmailPopup() {
      var _this5 = this;

      if (this.state.hasSeenParentEmailPopup) return;
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(ParentEmailPopup, {
        setSeenStatus: function setSeenStatus() {
          return _this5.setState({
            hasSeenParentEmailPopup: true
          });
        }
      }));
    }
  }, {
    key: "renderTopButtonRow",
    value: function renderTopButtonRow() {
      var _this6 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TopButtonRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          bgColor: this.state.isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
          color: "white",
          disabled: this.state.isEditMode || this.state.isDownloadingList,
          onClick: this.onDownloadStudentList,
          iconName: "print",
          size: "large",
          width: "248px",
          children: this.state.isDownloadingList ? 'Loading...' : 'Print all'
        }), this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            iconName: "cross",
            size: "large",
            onClick: function onClick() {
              return _this6.setState(StudentList_objectSpread(StudentList_objectSpread({}, _this6.state.initialState), {}, {
                isEditMode: false
              }));
            },
            children: "Undo"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            "data-save": true,
            element: "button",
            bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
            color: "white",
            iconName: "check",
            size: "large",
            onClick: this.onSubmit,
            children: "Save"
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          color: "white",
          onClick: function onClick() {
            return _this6.setState({
              isEditMode: true
            });
          },
          iconName: "pencil",
          size: "large",
          children: "Edit"
        })]
      });
    }
  }, {
    key: "renderMobileTopButtonRow",
    value: function renderMobileTopButtonRow() {
      var _this7 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileTopRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* Title */.Dx, {
          children: this.props.isParent ? 'Children' : 'Students'
        }), this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          element: "button",
          bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
          color: "white",
          iconName: "check",
          size: "regular",
          onClick: this.onSubmit,
          children: "Save"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          color: "white",
          onClick: function onClick() {
            return _this7.setState({
              isEditMode: true
            });
          },
          iconName: "pencil",
          size: "regular",
          children: "Edit"
        })]
      });
    }
  }, {
    key: "renderTitleRow",
    value: function renderTitleRow() {
      var isParent = this.props.isParent;
      var columns = [{
        id: 'name',
        title: isParent ? "Child's name" : 'Student Name',
        size: 'regular'
      }, {
        id: 'username',
        title: 'Username',
        size: 'regular'
      }, {
        id: 'password',
        title: 'Password',
        size: 'regular'
      }, {
        id: 'parentEmail',
        title: 'Parent Email',
        size: 'large'
      }, {
        id: 'yearGroup',
        title: 'Age',
        size: 'regular'
      }];
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TitleRow, {
        children: columns.filter(isParent ? function (column) {
          return column.id !== 'parentEmail';
        } : function (column) {
          return column;
        }).map(function (column) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(TitleRowElement, {
            size: column.size,
            children: column.title
          }, column.id);
        })
      });
    }
  }, {
    key: "renderMobileTitleRow",
    value: function renderMobileTitleRow() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileTitleRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MobileTitleRowElement, {
          left: true,
          children: "Username"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileTitleRowElement, {
          children: "Password"
        })]
      });
    }
  }, {
    key: "renderStudents",
    value: function renderStudents() {
      var _this8 = this;

      var screenWidth = this.props.screenWidth;
      return (this.state.students || []).map(function (student, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(formsy_react_lib/* default */.ZP, {
          ref: "your-class-".concat(i),
          children: screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D ? /*#__PURE__*/(0,jsx_runtime.jsx)(StudentInfoRow, {
            info: student,
            isGoogleGroup: _this8.props.isGoogleGroup,
            screenWidth: screenWidth,
            isEditMode: _this8.state.isEditMode,
            isValidUsername: _this8.isValidUsername,
            onRemoveStudent: _this8.onRemoveStudent,
            setStudentState: _this8.setStudentState,
            isParent: _this8.props.isParent,
            onDownloadStudentInfo: _this8.onDownloadStudentInfo,
            openParentEmailPopup: _this8.openParentEmailPopup,
            syncGoogleStudents: _this8.props.syncGoogleStudents
          }, student._id) : /*#__PURE__*/(0,jsx_runtime.jsx)(MobileStudentInfoRow_StudentInfoRow, {
            info: student,
            isEditMode: _this8.state.isEditMode,
            isValidUsername: _this8.isValidUsername,
            setStudentState: _this8.setStudentState
          }, student._id)
        }, "your-class-".concat(i));
      });
    }
  }, {
    key: "renderBottomButtonRow",
    value: function renderBottomButtonRow() {
      var _this9 = this;

      var students = this.state.students;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomButtonRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddButtonContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            element: "button",
            bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
            color: "white",
            size: "regular",
            round: true,
            onClick: this.onAddStudent,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
              name: "plus",
              color: "white",
              size: "regular"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddButtonText, {
            onClick: this.onAddStudent,
            children: this.props.isParent ? 'Add Child' : 'Add Student'
          })]
        }), students && students.length > 6 && /*#__PURE__*/(0,jsx_runtime.jsx)(UndoSaveButtonContainer, {
          children: this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
              bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
              color: "white",
              iconName: "cross",
              size: "regular",
              onClick: function onClick() {
                return _this9.setState(StudentList_objectSpread(StudentList_objectSpread({}, _this9.state.initialState), {}, {
                  isEditMode: false
                }));
              },
              children: "Undo"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
              element: "button",
              bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
              color: "white",
              iconName: "check",
              size: "regular",
              onClick: this.onSubmit,
              children: "Save"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
            color: "white",
            onClick: function onClick() {
              return _this9.setState({
                isEditMode: true
              });
            },
            iconName: "pencil",
            size: "regular",
            children: "Edit"
          })
        })]
      });
    }
  }, {
    key: "renderMobileBottomButtonRow",
    value: function renderMobileBottomButtonRow() {
      var _this10 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(MobileBottomRow, {
        children: this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          element: "button",
          bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
          color: "white",
          iconName: "check",
          size: "regular",
          onClick: this.onSubmit,
          children: "Save"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          color: "white",
          onClick: function onClick() {
            return _this10.setState({
              isEditMode: true
            });
          },
          iconName: "pencil",
          size: "regular",
          children: "Edit"
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(StudentList_styles_Wrapper, {
          children: [this.renderTopButtonRow(), this.renderTitleRow(), this.renderStudents(), this.renderBottomButtonRow()]
        });
      }

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(StudentList_styles_Wrapper, {
        children: [this.renderMobileTopButtonRow(), this.renderMobileTitleRow(), this.renderStudents(), this.renderMobileBottomButtonRow()]
      });
    }
  }]);

  return StudentList;
}(react.Component);


// EXTERNAL MODULE: ./modules/dashboard/DashboardPopup/YesNoPopup/YesNoPopup.js + 1 modules
var YesNoPopup = __webpack_require__(78305);
// EXTERNAL MODULE: ./components/UI/FormInput/Select.js
var Select = __webpack_require__(41992);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/CreateNewClassPopup/CreateNewClassPopup.styles.js






var CreateNewClassPopup_styles_StyledForm = (0,styled_components_browser_esm/* default */.ZP)(formsy_react_lib/* default */.ZP).withConfig({
  displayName: "CreateNewClassPopupstyles__StyledForm",
  componentId: "sc-1010fpp-0"
})(["display:flex;justify-content:center;flex-direction:column;margin-top:-15px;& .InputWrapper:nth-child(2){width:80%;margin:auto;}"]);
var CreateNewClassPopup_styles_StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "CreateNewClassPopupstyles__StyledFormInput",
  componentId: "sc-1010fpp-1"
})(["font-size:", ";margin:auto;&:last-child{margin-bottom:10px;}&.StudentNumber > div:first-child{width:100%;}&.StudentNumber > div:first-child > div{width:100%;white-space:nowrap;padding-right:20px;margin-left:0;}"], DashboardSettings_styles/* fontSize.small */.JB.small);
var CreateNewClassPopup_styles_ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CreateNewClassPopupstyles__ButtonRow",
  componentId: "sc-1010fpp-2"
})(["display:flex;justify-content:center;margin-bottom:35px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/CreateNewClassPopup/CreateNewClassPopup.js






function CreateNewClassPopup_createSuper(Derived) { var hasNativeReflectConstruct = CreateNewClassPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function CreateNewClassPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var CreateNewClassPopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(CreateNewClassPopup, _Component);

  var _super = CreateNewClassPopup_createSuper(CreateNewClassPopup);

  function CreateNewClassPopup(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, CreateNewClassPopup);

    _this = _super.call(this, props);
    _this.state = {
      age: null
    };
    return _this;
  }

  (0,createClass/* default */.Z)(CreateNewClassPopup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        isSettings: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CreateNewClassPopup_styles_StyledForm, {
          id: "password-popup",
          onValidSubmit: this.props.onConfirm,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CreateNewClassPopup_styles_StyledFormInput, {
            fieldName: 'New Class Name',
            fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            placeholderColor: Dashboard_global_styles/* colors.grey */.O9.grey,
            focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
            backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
            element: 'button',
            narrow: true,
            width: "80%",
            textSize: "15px",
            fieldNameSize: "18px",
            onChange: this.onInputChange,
            name: "groupName",
            placeholder: "Enter a class name",
            required: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
            fieldName: 'Age',
            onChange: function onChange(val) {
              _this2.setState({
                age: val.value
              });

              _this2.onInputChange;
            },
            value: this.state.age,
            options: [{
              label: 'up to 7',
              value: 1
            }, {
              label: '7-8',
              value: 2
            }, {
              label: '8-9',
              value: 3
            }, {
              label: '9-10',
              value: 4
            }, {
              label: '10-11',
              value: 5
            }, {
              label: '11 and above',
              value: 6
            }],
            required: true,
            fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            name: "yearGroup",
            wrapperStyle: {
              width: '100%',
              margin: 'auto'
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateNewClassPopup_styles_StyledFormInput, {
            displayStyle: "inline",
            className: "StudentNumber",
            fieldName: 'Number of students',
            fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            placeholderColor: Dashboard_global_styles/* colors.grey */.O9.grey,
            focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
            backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
            element: 'button',
            narrow: true,
            width: "80%",
            textSize: "15px",
            fieldNameSize: "18px",
            onChange: this.onInputChange,
            type: 'number',
            name: "nbStudents",
            placeholder: "0",
            required: true
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CreateNewClassPopup_styles_ButtonRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            element: "button",
            type: "submit",
            form: "password-popup",
            bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
            color: "white",
            size: "regular",
            children: "Create"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.red */.O9.red,
            color: "white",
            size: "regular",
            onClick: this.props.onCancel,
            children: "Cancel"
          })]
        })]
      });
    }
  }]);

  return CreateNewClassPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/ArchiveClass/ArchiveClass.styles.js



var ArchiveWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ArchiveClassstyles__ArchiveWrapper",
  componentId: "sc-tqpgz0-0"
})(["margin-top:40px;"]);
var InfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ArchiveClassstyles__InfoText",
  componentId: "sc-tqpgz0-1"
})(["font-size:", ";color:", ";position:relative;"], DashboardSettings_styles/* fontSize.small */.JB.small, Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal);
var ArchivedClasses = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ArchiveClassstyles__ArchivedClasses",
  componentId: "sc-tqpgz0-2"
})(["font-size:", ";color:", ";position:relative;margin-top:35px;&:hover{cursor:pointer;}"], DashboardSettings_styles/* fontSize.small */.JB.small, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var ArchiveClass_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "ArchiveClassstyles__Title",
  componentId: "sc-tqpgz0-3"
})(["font-size:22px;color:", ";margin-top:0px;margin-bottom:15px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var ArchivedClass = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ArchiveClassstyles__ArchivedClass",
  componentId: "sc-tqpgz0-4"
})(["margin:10px 0;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/components/ArchiveClass/ArchiveClass.js







function ArchiveClass_createSuper(Derived) { var hasNativeReflectConstruct = ArchiveClass_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ArchiveClass_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var ArchiveClass = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ArchiveClass, _Component);

  var _super = ArchiveClass_createSuper(ArchiveClass);

  function ArchiveClass(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ArchiveClass);

    _this = _super.call(this, props);
    _this.createNewClass = _this.createNewClass.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.renderArchivedClasses = _this.renderArchivedClasses.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(ArchiveClass, [{
    key: "createNewClass",
    value: function createNewClass() {
      var _this2 = this;

      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(YesNoPopup/* default */.Z, {
        isSettings: true,
        question: "Are you sure you want to create a new class?",
        footnote: "Creating a new class is commonly done at the start of a school year. You will be able to access your archived classes work still.",
        onCancel: this.props.modal.closeAll,
        onConfirm: function onConfirm() {
          _this2.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(CreateNewClassPopup, {
            onCancel: _this2.props.modal.closeAll,
            onConfirm: function onConfirm(newgroup) {
              newgroup.nbStudents = parseInt(newgroup.nbStudents);

              _this2.props.createNewGroup(newgroup, _this2.props.teacher._id).then(function () {
                location.reload();
              });
            }
          }));
        }
      }));
    }
  }, {
    key: "switchClasses",
    value: function switchClasses(c) {
      var _this3 = this;

      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(YesNoPopup/* default */.Z, {
        isSettings: true,
        question: "Switch to ".concat(c.name, "?"),
        footnote: "You will need to switch back to view your previous class.",
        onCancel: this.props.modal.closeAll,
        onConfirm: function onConfirm() {
          _this3.props.changeActiveGroup(c._id).then(function () {
            location.reload();
          });
        }
      }));
    }
  }, {
    key: "renderArchivedClasses",
    value: function renderArchivedClasses() {
      var _this4 = this;

      var classes = this.props.archivedClasses.slice().reverse().map(function (c, i) {
        var date = new Date(c.createdAt);
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(ArchivedClass, {
          onClick: function onClick() {
            return _this4.switchClasses(c);
          },
          children: [c.name, " - ", c.students.count, " students - ", date.toLocaleDateString() || '', " (Switch back)"]
        }, i);
      });
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(ArchivedClasses, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ArchiveClass_styles_Title, {
          children: "Archived Classes"
        }), classes]
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(ArchiveWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          bgColor: "#88B81D",
          color: "white",
          onClick: this.createNewClass,
          size: "regular",
          children: 'CREATE NEW CLASS'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoText, {
          children: "(Create a new class and manage archived classes)"
        }), this.props.archivedClasses && this.props.archivedClasses.length > 0 && this.renderArchivedClasses()]
      });
    }
  }]);

  return ArchiveClass;
}(react.Component);


// EXTERNAL MODULE: ./components/UI/Loader/Loader.js + 1 modules
var Loader = __webpack_require__(81995);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/YourClass.styles.js



var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourClassstyles__Content",
  componentId: "sc-1lpetnw-0"
})(["max-width:", ";margin:15px auto 0;padding-top:20px;@media (max-width:950px){max-width:", ";}@media (max-width:", "px){margin:0px auto;padding-top:0px;}"], function (props) {
  return props.isParent ? '675px' : '915px';
}, function (props) {
  return props.isParent ? '591px' : '731px';
}, DashboardSettings_styles/* phoneMaxWidth */.D);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourClassstyles__Header",
  componentId: "sc-1lpetnw-1"
})(["padding-top:20px;"]);
var LargeTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "YourClassstyles__LargeTitle",
  componentId: "sc-1lpetnw-2"
})(["font-size:", ";color:", ";margin-top:0px;margin-bottom:15px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var SmallTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "YourClassstyles__SmallTitle",
  componentId: "sc-1lpetnw-3"
})(["font-size:15px;color:", ";margin-top:0px;margin-bottom:15px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var Subtitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "YourClassstyles__Subtitle",
  componentId: "sc-1lpetnw-4"
})(["font-size:", ";font-weight:normal;color:", ";margin-top:0px;margin-bottom:0px;"], DashboardSettings_styles/* fontSize.medium */.JB.medium, Dashboard_global_styles/* colors.white */.O9.white);
var YourClass_styles_InfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "YourClassstyles__InfoText",
  componentId: "sc-1lpetnw-5"
})(["font-size:", ";color:", ";position:relative;margin-left:34px;&:before{content:'i';font-weight:bold;position:absolute;left:-34px;top:-4px;border:1px solid;border-radius:50%;padding:2px 10px;}"], DashboardSettings_styles/* fontSize.small */.JB.small, Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal);
var ClassControlsButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourClassstyles__ClassControlsButton",
  componentId: "sc-1lpetnw-6"
})(["color:#237C64;font-size:15px;margin-top:16px;margin-bottom:16px;"]);
// EXTERNAL MODULE: ./components/UI/Link.js
var UI_Link = __webpack_require__(92327);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/YourClass.js









function YourClass_createSuper(Derived) { var hasNativeReflectConstruct = YourClass_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function YourClass_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









 // import GoogleClassroomSyncModal from './components/GoogleClassroomSyncModal/GoogleClassroomSyncModalContainer'
// import GoogleClassroomUsersSyncModal from './components/GoogleClassroomUsersSyncModal/GoogleClassroomUsersSyncModalContainer'
// import GoogleResyncModal from './components/GoogleResyncModal/GoogleResyncModalContainer'





var YourClass = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(YourClass, _Component);

  var _super = YourClass_createSuper(YourClass);

  function YourClass() {
    (0,classCallCheck/* default */.Z)(this, YourClass);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(YourClass, [{
    key: "shouldComponentUpdate",
    value: // prevent update after failed mutation (due to wrong password)
    function shouldComponentUpdate(nextProps) {
      var currentModalId = this.props.modal.getCurrent().id;

      if (currentModalId === 'sensitiveInfoPopup' && this.props.students) {
        return false;
      }

      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "syncGoogleClass",
    value: function syncGoogleClass() {
      this.props.modal.closeAll(); // this.props.modal.open(
      //   <GoogleClassroomSyncModal
      //     groupId={this.props.groupId}
      //     onExit={() => this.props.modal.closeAll()}
      //     onSuccess={courseId => {
      //       this.syncGoogleStudents(courseId)
      //     }}
      //   />
      // )
    }
  }, {
    key: "syncGoogleStudents",
    value: function syncGoogleStudents(courseId) {
      this.props.modal.closeAll(); // this.props.modal.open(
      //   <GoogleClassroomUsersSyncModal
      //     courseId={this.props.courseId || courseId}
      //     onChangeGoogleGroup={() => {
      //       this.props.modal.closeAll()
      //       this.syncGoogleClass()
      //     }}
      //     onExit={() => this.props.modal.closeAll()}
      //   />
      // )
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.courseId) {// this.syncGoogleStudents(nextProps.courseId)
      }
    }
  }, {
    key: "onGoogleAccountSyncSuccess",
    value: function () {
      var _onGoogleAccountSyncSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(googleRes) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.syncAccountWithGoogle(googleRes.code);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onGoogleAccountSyncSuccess(_x) {
        return _onGoogleAccountSyncSuccess.apply(this, arguments);
      }

      return onGoogleAccountSyncSuccess;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          loading = _this$props.loading,
          screenWidth = _this$props.screenWidth,
          client = _this$props.client,
          queries = _this$props.queries,
          modal = _this$props.modal,
          loggedInUser = _this$props.loggedInUser,
          isParent = _this$props.isParent,
          students = _this$props.students,
          yearGroup = _this$props.yearGroup,
          updateStudentDetails = _this$props.updateStudentDetails,
          addStudents = _this$props.addStudents,
          deleteStudent = _this$props.deleteStudent;

      if (loading) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* LoaderWrapper */.sb, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
            bgColor: "rgba(0,0,0,0)",
            itemColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            itemSize: "90"
          })
        });
      } // if (loggedInUser.isGoogle && !loggedInUser.hasRefreshToken) {
      //   this.props.modal.open(
      //     <GoogleResyncModal
      //       googleEmail={this.props.loggedInUser.googleEmail}
      //       onExit={() => this.props.modal.closeAll()}
      //       onSuccess={() => this.props.modal.closeAll()}
      //     />
      //   )
      // }


      return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
          isParent: isParent,
          children: [screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D && /*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LargeTitle, {
              children: this.props.groupName
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SmallTitle, {
              children: "Add your ".concat(isParent ? 'children' : 'students')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ClassControlsButton, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UI_Link/* default */.Z, {
              to: "/dashboard/control-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                bgColor: Dashboard_global_styles/* colors.pink */.O9.pink,
                children: "Class controls"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "(Limit your students access to features by blocking them here)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StudentList, {
            client: client,
            queries: queries,
            modal: modal,
            screenWidth: screenWidth,
            loggedInUser: loggedInUser,
            isParent: isParent,
            students: students,
            yearGroup: yearGroup,
            updateStudentDetails: updateStudentDetails,
            addStudents: addStudents,
            deleteStudent: deleteStudent,
            isGoogleGroup: this.props.isGoogleGroup,
            onGoogleSyncSuccess: this.onGoogleAccountSyncSuccess.bind(this),
            syncGoogleClass: this.syncGoogleClass.bind(this),
            syncGoogleStudents: this.syncGoogleStudents.bind(this)
          }), screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D && !isParent && /*#__PURE__*/(0,jsx_runtime.jsx)(YourClass_styles_InfoText, {
            children: "Add a parent email next to each child so that they can receive regular updates on the work your children are doing at school on Night Zookeeper."
          }), screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
            children: function children(modal) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(ArchiveClass, {
                modal: modal,
                teacher: _this.props.loggedInUser,
                archivedClasses: _this.props.archivedGroups,
                createNewGroup: _this.props.registerGroup,
                changeActiveGroup: _this.props.changeActiveGroup
              });
            }
          })]
        })
      });
    }
  }]);

  return YourClass;
}(react.Component);

(0,defineProperty/* default */.Z)(YourClass, "defaultProps", {
  modal: {},
  client: {},
  loggedInUser: {},
  archivedGroups: [],
  students: [],
  queries: []
});


// EXTERNAL MODULE: ./components/DataContainer/DataContainer.js
var DataContainer = __webpack_require__(94238);
// EXTERNAL MODULE: ./components/MediaQuery/MediaQuery.js
var MediaQuery = __webpack_require__(82793);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourClass/YourClassContainer.js









var YourClassContainer_templateObject, YourClassContainer_templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function YourClassContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function YourClassContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? YourClassContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : YourClassContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function YourClassContainer_createSuper(Derived) { var hasNativeReflectConstruct = YourClassContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function YourClassContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var queries = [{
  query: (0,lib/* default */.ZP)(YourClassContainer_templateObject || (YourClassContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      {\n        me {\n          _id\n          name\n          parent\n          google {\n            id\n            email\n            hasRefreshToken\n          }\n          group {\n            _id\n            name\n            yearGroup\n            google {\n              id\n            }\n            students(limit: 0, skip: 0) {\n              users {\n                _id\n                google {\n                  id\n                  email\n                }\n                demo\n                username\n                name\n                yearGroup\n                parentEmail\n              }\n            }\n          }\n          archivedGroups {\n            _id\n            name\n            yearGroup\n            createdAt\n            students(limit: 0, skip: 0) {\n              count\n            }\n          }\n        }\n      }\n    "]))),
  props: function props(_ref) {
    var data = _ref.data;

    if (data.loading || data.error) {
      return {
        loading: data.loading,
        error: data.error
      };
    }

    var group = data.me && data.me.group || {};
    return {
      loggedInUser: {
        _id: data.me && data.me._id,
        name: data.me && data.me.name,
        isGoogle: data.me && data.me.google && data.me.google.email && true,
        googleEmail: data.me && data.me.google && data.me.google.email,
        hasRefreshToken: data.me && data.me.google && data.me.google.hasRefreshToken && true
      },
      isGoogleGroup: data.me && data.me.group && data.me.group.google && data.me.group.google.id && true,
      isParent: data.me && data.me.parent,
      groupName: group.name,
      groupId: group._id,
      courseId: group.google && group.google.id,
      yearGroup: group.yearGroup,
      students: group.students && group.students.users,
      archivedGroups: data.me && data.me.archivedGroups
    };
  },
  options: {
    fetchPolicy: 'network-only'
  }
}];
var mutations = [{
  mutation: (0,lib/* default */.ZP)(YourClassContainer_templateObject2 || (YourClassContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation updateUsers($users: [UserInput]) {\n        updateUsers(users: $users) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref2) {
    var mutate = _ref2.mutate;
    return {
      updateStudentDetails: function () {
        var _updateStudentDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(details) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return mutate({
                    variables: {
                      users: details
                    }
                  });

                case 3:
                  _context.next = 8;
                  break;

                case 5:
                  _context.prev = 5;
                  _context.t0 = _context["catch"](0);
                  console.error(_context.t0);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 5]]);
        }));

        function updateStudentDetails(_x) {
          return _updateStudentDetails.apply(this, arguments);
        }

        return updateStudentDetails;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation registerStudents($students: [StudentInput]!, $teacherId: String!) {\n        registerStudents(students: $students, teacherId: $teacherId)\n      }\n    "]))),
  props: function props(_ref3) {
    var mutate = _ref3.mutate;
    return {
      addStudents: function () {
        var _addStudents = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(students, teacherId) {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return mutate({
                    variables: {
                      students: students,
                      teacherId: teacherId
                    }
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function addStudents(_x2, _x3) {
          return _addStudents.apply(this, arguments);
        }

        return addStudents;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation removeStudent($userId: String!, $teacherPassword: String!) {\n        removeStudent(userId: $userId, teacherPassword: $teacherPassword)\n      }\n    "]))),
  props: function props(_ref4) {
    var mutate = _ref4.mutate;
    return {
      deleteStudent: function () {
        var _deleteStudent = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(studentId, teacherPassword) {
          return regenerator_default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return mutate({
                    variables: {
                      userId: studentId,
                      teacherPassword: teacherPassword
                    }
                  });

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function deleteStudent(_x4, _x5) {
          return _deleteStudent.apply(this, arguments);
        }

        return deleteStudent;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation registerGroup($group: GroupInput!, $teacherId: String!) {\n        registerGroup(group: $group, teacherId: $teacherId) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref5) {
    var mutate = _ref5.mutate;
    return {
      registerGroup: function () {
        var _registerGroup = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(group, teacherId) {
          return regenerator_default().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return mutate({
                    variables: {
                      group: group,
                      teacherId: teacherId
                    }
                  });

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function registerGroup(_x6, _x7) {
          return _registerGroup.apply(this, arguments);
        }

        return registerGroup;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation changeActiveGroup($groupId: String) {\n        changeActiveGroup(groupId: $groupId) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref6) {
    var mutate = _ref6.mutate;
    return {
      changeActiveGroup: function () {
        var _changeActiveGroup = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(groupId) {
          return regenerator_default().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return mutate({
                    variables: {
                      groupId: groupId
                    }
                  });

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function changeActiveGroup(_x8) {
          return _changeActiveGroup.apply(this, arguments);
        }

        return changeActiveGroup;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation syncAccountWithGoogle($code: String) {\n        syncAccountWithGoogle(code: $code) {\n          _id\n          google {\n            id\n            email\n          }\n        }\n      }\n    "]))),
  props: function props(_ref7) {
    var mutate = _ref7.mutate;
    return {
      syncAccountWithGoogle: function syncAccountWithGoogle(code) {
        return mutate({
          variables: {
            code: code
          }
        });
      }
    };
  }
}];

var YourClassContainer = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(YourClassContainer, _React$Component);

  var _super = YourClassContainer_createSuper(YourClassContainer);

  function YourClassContainer() {
    (0,classCallCheck/* default */.Z)(this, YourClassContainer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(YourClassContainer, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
        children: function children(modal) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQuery/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(YourClass, YourClassContainer_objectSpread(YourClassContainer_objectSpread({}, _this.props), {}, {
              modal: modal
            }))
          });
        }
      });
    }
  }]);

  return YourClassContainer;
}(react.Component);

/* harmony default export */ var YourClass_YourClassContainer = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DataContainer/* default */.Z, {
    queries: queries,
    mutations: mutations,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(YourClassContainer, YourClassContainer_objectSpread({}, props))
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/PasswordChangedPopup/PasswordChangedPopup.styles.js




var PasswordChangedPopup_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "PasswordChangedPopupstyles__Title",
  componentId: "sc-1oi06fa-0"
})(["font-size:", ";font-weight:600;color:", ";text-align:center;margin-top:40px;margin-bottom:20px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var PasswordChangedPopup_styles_Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "PasswordChangedPopupstyles__Note",
  componentId: "sc-1oi06fa-1"
})(["color:", ";font-size:", ";text-align:center;margin-top:0px;margin-bottom:40px;"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, DashboardSettings_styles/* fontSize.small */.JB.small);
var PasswordChangedPopup_styles_ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PasswordChangedPopupstyles__ButtonRow",
  componentId: "sc-1oi06fa-2"
})(["display:flex;justify-content:center;margin-bottom:35px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/PasswordChangedPopup/PasswordChangedPopup.js






function PasswordChangedPopup_createSuper(Derived) { var hasNativeReflectConstruct = PasswordChangedPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function PasswordChangedPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var PasswordChangedPopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(PasswordChangedPopup, _Component);

  var _super = PasswordChangedPopup_createSuper(PasswordChangedPopup);

  function PasswordChangedPopup() {
    (0,classCallCheck/* default */.Z)(this, PasswordChangedPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(PasswordChangedPopup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        isSettings: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordChangedPopup_styles_Title, {
          children: "Success!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordChangedPopup_styles_Note, {
          children: "Your password has been changed"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordChangedPopup_styles_ButtonRow, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            size: "regular",
            width: "105px",
            height: "30px",
            onClick: this.props.onCancel,
            children: "OK"
          })
        })]
      });
    }
  }]);

  return PasswordChangedPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/components/YourDetailsColumn/YourDetailsColumn.styles.js




var YourDetailsColumn_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourDetailsColumnstyles__Wrapper",
  componentId: "sc-1pjwa81-0"
})(["width:220px;margin-left:160px;@media (max-width:900px){margin-left:40px;}@media (max-width:", "px){margin:auto;margin-bottom:20px;}"], DashboardSettings_styles/* phoneMaxWidth */.D);
var YourDetailsColumn_styles_TitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourDetailsColumnstyles__TitleRow",
  componentId: "sc-1pjwa81-1"
})(["display:flex;align-items:center;justify-content:space-between;"]);
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
  displayName: "YourDetailsColumnstyles__StyledIconButton",
  componentId: "sc-1pjwa81-2"
})(["margin-right:-15px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/components/YourDetailsColumn/YourDetailsColumn.js








function YourDetailsColumn_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function YourDetailsColumn_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? YourDetailsColumn_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : YourDetailsColumn_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function YourDetailsColumn_createSuper(Derived) { var hasNativeReflectConstruct = YourDetailsColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function YourDetailsColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











var YourDetailsColumn = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(YourDetailsColumn, _Component);

  var _super = YourDetailsColumn_createSuper(YourDetailsColumn);

  function YourDetailsColumn(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, YourDetailsColumn);

    _this = _super.call(this, props);
    _this.state = {
      isEditMode: false
    };
    _this.onInputChange = _this.onInputChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(YourDetailsColumn, [{
    key: "onInputChange",
    value: function onInputChange(e) {
      if (e.target.name === 'safeMarket') {
        return this.props.setTeacherState({
          field: e.target.name,
          value: e.target.value === 'On'
        });
      }

      this.props.setTeacherState({
        field: e.target.name,
        value: e.target.value
      });
    }
  }, {
    key: "renderTitleAndButtons",
    value: function renderTitleAndButtons() {
      var _this2 = this;

      var _this$props = this.props,
          screenWidth = _this$props.screenWidth,
          isEditMode = _this$props.isEditMode;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(YourDetailsColumn_styles_TitleRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* Title */.Dx, {
          children: "Your Details"
        }), screenWidth <= DashboardSettings_styles/* phoneMaxWidth */.D && (isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconButton, {
          "data-save": true,
          element: "button",
          type: "submit",
          form: "your-account",
          bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
          color: "white",
          iconName: "check",
          size: "small",
          onClick: function onClick() {
            return _this2.props.setEditMode(false);
          },
          children: "Save"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconButton, {
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          iconName: "pencil",
          color: "white",
          size: "small",
          columnView: true,
          onClick: function onClick() {
            return _this2.props.setEditMode(true);
          },
          children: "Edit"
        }))]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          teacherDetails = _this$props2.teacherDetails,
          isEditMode = _this$props2.isEditMode,
          loading = _this$props2.loading;
      if (loading) return null;
      var commonProps = {
        placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundColor: isEditMode ? null : Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue,
        inputColor: isEditMode ? null : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
        fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
        width: '220px',
        noBorder: !isEditMode,
        focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
        element: 'button',
        disabled: !isEditMode,
        autoComplete: 'off',
        narrow: true,
        textSize: '15px',
        fieldNameSize: '18px'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(YourDetailsColumn_styles_Wrapper, {
        children: [this.renderTitleAndButtons(), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, YourDetailsColumn_objectSpread(YourDetailsColumn_objectSpread({}, commonProps), {}, {
          value: teacherDetails.name,
          onChange: this.onInputChange,
          name: "name",
          fieldName: "Your name",
          placeholder: "Your name",
          required: true
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          value: "autofill",
          onChange: function onChange() {},
          name: "email",
          placeholder: "Email",
          hidden: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, YourDetailsColumn_objectSpread(YourDetailsColumn_objectSpread({}, commonProps), {}, {
          value: teacherDetails.email,
          onChange: this.onInputChange,
          name: "email",
          fieldName: "Email",
          placeholder: "Email",
          required: true,
          validations: "isEmail",
          validationError: "Email not valid"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, YourDetailsColumn_objectSpread(YourDetailsColumn_objectSpread({}, commonProps), {}, {
          value: teacherDetails.password,
          onChange: this.onInputChange,
          name: "password",
          fieldName: "Password",
          placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
          placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
          type: "password",
          validations: "minLength:4",
          validationError: "Password too short"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, YourDetailsColumn_objectSpread(YourDetailsColumn_objectSpread({}, commonProps), {}, {
          value: teacherDetails.twitter,
          onChange: this.onInputChange,
          name: "twitter",
          fieldName: "Twitter",
          placeholder: "Twitter"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, YourDetailsColumn_objectSpread(YourDetailsColumn_objectSpread({}, commonProps), {}, {
          value: teacherDetails.skype,
          onChange: this.onInputChange,
          name: "skype",
          fieldName: "Skype",
          placeholder: "Skype"
        }))]
      });
    }
  }]);

  return YourDetailsColumn;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/relative.js
var relative = __webpack_require__(48272);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl-utils/lib/src/diff.js
var diff = __webpack_require__(34115);
// EXTERNAL MODULE: ./components/UI/FormInput/Textarea.js + 1 modules
var Textarea = __webpack_require__(60702);
// EXTERNAL MODULE: ./components/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(96499);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/components/UploadModal/UploadModal.styles.js

var CancelButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UploadModalstyles__CancelButtonWrapper",
  componentId: "sc-m3ikzf-0"
})(["position:absolute;right:8px;top:8px;"]);
var UploaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UploadModalstyles__UploaderContainer",
  componentId: "sc-m3ikzf-1"
})(["display:flex;align-items:center;justify-content:center;height:100%;color:white;"]);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./components/Uploader/Uploader.styles.js
var Uploader_styles = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(32512);
// EXTERNAL MODULE: ./lib/the-file-server.tsx
var the_file_server = __webpack_require__(45289);
;// CONCATENATED MODULE: ./components/Uploader/Uploader.js








function Uploader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Uploader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Uploader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Uploader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Uploader_createSuper(Derived) { var hasNativeReflectConstruct = Uploader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Uploader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var Uploader = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Uploader, _React$Component);

  var _super = Uploader_createSuper(Uploader);

  function Uploader(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Uploader);

    _this = _super.call(this, props);
    _this.state = {
      progress: 0
    };
    _this.onDrop = _this.onDrop.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(Uploader, [{
    key: "onDrop",
    value: function onDrop(file) {
      var _this2 = this;

      this.props.upload(file).then(function (data) {
        _this2.props.uploadedImage(data.publicUrl);
      })["catch"](function (err) {
        console.log(err);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Uploader_styles/* Wrapper */.i, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "drop-zone",
          style: {
            position: 'relative',
            height: '200px',
            width: '200px',
            cursor: 'pointer'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "progress",
            style: {
              width: "".concat(this.state.progress, "%"),
              background: 'rgba(107, 188, 102, 0.7)'
            },
            children: ' '
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.ZP, {
            accept: {
              'image/*': ['image/jpeg', 'image/png']
            },
            onDrop: this.onDrop,
            children: function children(_ref) {
              var getRootProps = _ref.getRootProps,
                  getInputProps = _ref.getInputProps;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", Uploader_objectSpread(Uploader_objectSpread({}, getRootProps()), {}, {
                style: {
                  height: '100%',
                  width: '100%'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "label",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "uploaderDragOrClick",
                      defaultMessage: "Drag your image here or click to upload"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", Uploader_objectSpread({}, getInputProps()))]
                })
              }));
            }
          })]
        })
      });
    }
  }]);

  return Uploader;
}(react.Component);

/* harmony default export */ var Uploader_Uploader = (function (props) {
  var _useFileServer = (0,the_file_server/* useFileServer */.k)(),
      upload = _useFileServer.upload;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Uploader, Uploader_objectSpread(Uploader_objectSpread({}, props), {}, {
    upload: upload
  }));
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/components/UploadModal/UploadModal.js








function UploadModal_createSuper(Derived) { var hasNativeReflectConstruct = UploadModal_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function UploadModal_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











var UploadModal = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(UploadModal, _Component);

  var _super = UploadModal_createSuper(UploadModal);

  function UploadModal(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, UploadModal);

    _this = _super.call(this, props);
    _this.onCancel = _this.onCancel.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onUploadFinish = _this.onUploadFinish.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(UploadModal, [{
    key: "onCancel",
    value: function onCancel() {
      this.props.onCancel();
    }
  }, {
    key: "onUploadFinish",
    value: function onUploadFinish(url) {
      if (!url) return;
      this.props.handleNewImageUrl(url);
      this.props.onAfterUpload();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onCancel = _this$props.onCancel,
          cancelLabel = _this$props.cancelLabel;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        isOpen: true,
        delayCloseTimeoutMS: 0,
        overlayColor: "rgba(0, 0, 0, 0.8)",
        contentLabel: "create",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CancelButtonWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: "red",
            label: cancelLabel,
            shadow: true,
            round: true,
            size: "large",
            onClick: this.onCancel,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
              name: "cross",
              color: Dashboard_global_styles/* colors.white */.O9.white,
              size: "large"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UploaderContainer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Uploader_Uploader, {
            api: "https://file.nightzookeeper.com/images/upload",
            uploadedImage: this.onUploadFinish
          })
        })]
      });
    }
  }]);

  return UploadModal;
}(react.Component);

(0,defineProperty/* default */.Z)(UploadModal, "defaultProps", {});


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/components/ClassDetailsColumn/ClassDetailsColumn.styles.js




var ClassDetailsColumn_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassDetailsColumnstyles__Wrapper",
  componentId: "sc-1vdm80z-0"
})(["width:220px;margin-left:100px;@media (max-width:900px){margin-left:50px;}@media (max-width:", "px){margin:auto;margin-bottom:20px;}"], DashboardSettings_styles/* phoneMaxWidth */.D);
var InputTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassDetailsColumnstyles__InputTitle",
  componentId: "sc-1vdm80z-1"
})(["font-size:18px;color:", ";margin-left:10px;margin-bottom:4px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var ClassBlogSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassDetailsColumnstyles__ClassBlogSection",
  componentId: "sc-1vdm80z-2"
})(["width:220px;height:86px;padding:8px;margin-bottom:24px;background-color:", ";border-radius:8px;border:2px solid;border-color:", ";"], function (props) {
  return props.isEditMode ? Dashboard_global_styles/* colors.white */.O9.white : Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue;
}, function (props) {
  return props.isEditMode ? '#dddfdf' : 'transparent';
});
var ClassBlogImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassDetailsColumnstyles__ClassBlogImage",
  componentId: "sc-1vdm80z-3"
})(["background-image:", ";background-repeat:no-repeat;background-size:contain;background-position:center;width:200px;height:68px;display:flex;"], function (props) {
  return "url(".concat(props.imageUrl, ")");
});
var ClassDetailsColumn_styles_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassDetailsColumnstyles__StyledButton",
  componentId: "sc-1vdm80z-4"
})(["margin:auto;"]);
var ViewBlogButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassDetailsColumnstyles__ViewBlogButton",
  componentId: "sc-1vdm80z-5"
})(["margin:0 0 24px 10px;"]);
var BattleControlInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassDetailsColumnstyles__BattleControlInfo",
  componentId: "sc-1vdm80z-6"
})(["font-size:14px;font-weight:bold;margin:0 0 10px 10px;color:", ";"], Dashboard_global_styles/* colors.pink */.O9.pink);
var BattleControlText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ClassDetailsColumnstyles__BattleControlText",
  componentId: "sc-1vdm80z-7"
})(["color:", ";font-weight:normal;"], Dashboard_global_styles/* colors.white */.O9.white);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/components/ClassDetailsColumn/ClassDetailsColumn.js








function ClassDetailsColumn_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ClassDetailsColumn_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ClassDetailsColumn_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ClassDetailsColumn_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function ClassDetailsColumn_createSuper(Derived) { var hasNativeReflectConstruct = ClassDetailsColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ClassDetailsColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var ClassDetailsColumn = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ClassDetailsColumn, _Component);

  var _super = ClassDetailsColumn_createSuper(ClassDetailsColumn);

  function ClassDetailsColumn(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ClassDetailsColumn);

    _this = _super.call(this, props);
    _this.onInputChange = _this.onInputChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(ClassDetailsColumn, [{
    key: "onInputChange",
    value: function onInputChange(e) {
      if (e.target.name === 'battleLockedUntil') {
        var now = Date.now();
        var timestamp = {
          off: '1970-01-01T00:00:00.000Z',
          hour: new Date(now + 60 * 60 * 1000).toISOString(),
          day: new Date(now + 24 * 60 * 60 * 1000).toISOString(),
          week: new Date(now + 7 * 24 * 60 * 60 * 1000).toISOString()
        };
        return this.props.setClassState({
          field: e.target.name,
          value: timestamp[e.target.value]
        });
      }

      this.props.setClassState({
        field: e.target.name,
        value: e.target.value
      });
    }
  }, {
    key: "openUploadModal",
    value: function openUploadModal() {
      var _this2 = this;

      var modal = this.props.modal;
      modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(UploadModal, {
        onCancel: function onCancel() {
          return modal.close();
        },
        onAfterUpload: function onAfterUpload() {
          return modal.close();
        },
        handleNewImageUrl: function handleNewImageUrl(url) {
          return _this2.props.setClassState({
            field: 'headerArtwork',
            value: url
          });
        }
      }));
    }
  }, {
    key: "renderBattleControlSection",
    value: function renderBattleControlSection(commonProps) {
      var _this$props = this.props,
          initialClassDetails = _this$props.initialClassDetails,
          isEditMode = _this$props.isEditMode,
          setBattleControlUnlock = _this$props.setBattleControlUnlock;
      var battleLockedUntil = initialClassDetails.battleLockedUntil;
      var now = new Date();
      var expiryTime = new Date(battleLockedUntil);
      var isLocked = now < expiryTime && !this.props.battleControlCustomUnlock;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [!isLocked && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SettingsSelect/* default */.Z, ClassDetailsColumn_objectSpread(ClassDetailsColumn_objectSpread({}, commonProps), {}, {
            value: "off",
            onChange: this.onInputChange,
            name: "battleLockedUntil",
            fieldName: "Battle Control",
            options: [{
              title: 'unlocked',
              value: 'off'
            }, {
              title: 'locked (1 hour)',
              value: 'hour'
            }, {
              title: 'locked (1 day)',
              value: 'day'
            }, {
              title: 'locked (1 week)',
              value: 'week'
            }]
          })), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* InputExplanationText */.Yd, {
            children: "(Disable the battle game to help students focus on their lessons)"
          })]
        }), isLocked && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputTitle, {
            children: "Battle Control"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BattleControlInfo, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BattleControlText, {
              children: 'Currently locked and will unlock '
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(relative/* default */.Z, ClassDetailsColumn_objectSpread({}, (0,diff/* selectUnit */.W)(expiryTime, Date.now())))]
          }), isEditMode && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
            color: "white",
            size: "small",
            onClick: function onClick() {
              return setBattleControlUnlock(true);
            },
            children: "Change"
          })]
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          classDetails = _this$props2.classDetails,
          isEditMode = _this$props2.isEditMode,
          isParent = _this$props2.isParent,
          loading = _this$props2.loading,
          redirectTo = _this$props2.redirectTo;
      if (loading) return null;
      var defaultImage = "".concat("/edu/assets", "/pages/Zoo/ClassBlog/default-banner.jpg");
      var commonProps = {
        placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundColor: isEditMode ? null : Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue,
        inputColor: isEditMode ? null : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
        fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
        width: '220px',
        noBorder: !isEditMode,
        focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
        element: 'button',
        disabled: !isEditMode,
        autoComplete: 'off',
        narrow: true,
        textSize: '15px',
        fieldNameSize: '18px'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClassDetailsColumn_styles_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* Title */.Dx, {
          children: isParent ? 'Team Details' : 'Class Details'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, ClassDetailsColumn_objectSpread(ClassDetailsColumn_objectSpread({}, commonProps), {}, {
          value: classDetails.name,
          onChange: this.onInputChange,
          name: "name",
          fieldName: isParent ? 'Team Name' : 'Class Name',
          placeholder: isParent ? 'Your team name' : 'Your class name',
          required: true
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingsSelect/* default */.Z, ClassDetailsColumn_objectSpread(ClassDetailsColumn_objectSpread({}, commonProps), {}, {
          value: classDetails.yearGroup,
          onChange: this.onInputChange,
          name: "yearGroup",
          fieldName: "Age",
          options: [{
            title: 'up to 7',
            value: 1
          }, {
            title: '7-8',
            value: 2
          }, {
            title: '8-9',
            value: 3
          }, {
            title: '9-10',
            value: 4
          }, {
            title: '10-11',
            value: 5
          }, {
            title: '11 and above',
            value: 6
          }]
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(Textarea/* default */.Z, ClassDetailsColumn_objectSpread(ClassDetailsColumn_objectSpread({}, commonProps), {}, {
          value: classDetails.description,
          onChange: this.onInputChange,
          name: "description",
          fieldName: isParent ? 'Team Description' : 'Class Description',
          placeholder: isParent ? 'Your team description' : 'Your class description',
          rows: "5"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(InputTitle, {
          children: isParent ? 'Team Blog Banner' : 'Class Blog Banner'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ClassBlogSection, {
          isEditMode: this.props.isEditMode,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClassBlogImage, {
            imageUrl: classDetails.headerArtwork || defaultImage,
            children: this.props.isEditMode && /*#__PURE__*/(0,jsx_runtime.jsx)(ClassDetailsColumn_styles_StyledButton, {
              bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
              color: "white",
              size: "regular",
              onClick: function onClick() {
                return _this3.openUploadModal();
              },
              children: "Change"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ViewBlogButton, {
          color: "white",
          size: "small",
          onClick: function onClick() {
            return redirectTo("/zoo/class-blog/".concat(classDetails._id));
          },
          children: "View ".concat(isParent ? 'team' : 'class', " blog")
        }), this.renderBattleControlSection(commonProps)]
      });
    }
  }]);

  return ClassDetailsColumn;
}(react.Component);

(0,defineProperty/* default */.Z)(ClassDetailsColumn, "defaultProps", {
  modal: {},
  initialClassDetails: {},
  classDetails: {}
});

/* harmony default export */ var ClassDetailsColumn_ClassDetailsColumn = (function (props) {
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClassDetailsColumn, ClassDetailsColumn_objectSpread(ClassDetailsColumn_objectSpread({}, props), {}, {
    redirectTo: router.push
  }));
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/YourAccount.styles.js



var YourAccount_styles_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourAccountstyles__Content",
  componentId: "sc-1edkrus-0"
})(["display:flex;justify-content:center;flex-flow:row wrap;max-width:900px;margin:15px auto 25px;padding:20px 0;@media (max-width:", "px){flex-flow:column wrap;margin:0px auto;padding-top:0px;}"], DashboardSettings_styles/* phoneMaxWidth */.D);
var ButtonColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourAccountstyles__ButtonColumn",
  componentId: "sc-1edkrus-1"
})(["display:flex;flex-direction:column;width:125px;margin-top:20px;margin-left:55px;@media (max-width:900px){margin-left:0px;}"]);
var MobileButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "YourAccountstyles__MobileButtons",
  componentId: "sc-1edkrus-2"
})(["display:flex;justify-content:flex-end;width:220px;margin:auto;"]);
var DeleteAccountMessage = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "YourAccountstyles__DeleteAccountMessage",
  componentId: "sc-1edkrus-3"
})(["max-width:900px;margin:auto;padding-left:170px;padding-right:150px;font-size:14px;color:", ";@media (max-width:900px){max-width:615px;padding-left:20px;padding-right:50px;}@media (max-width:", "px){width:220px;padding-left:0px;padding-right:0px;margin-top:20px;font-size:12px;}"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, DashboardSettings_styles/* phoneMaxWidth */.D);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "YourAccountstyles__StyledLink",
  componentId: "sc-1edkrus-4"
})(["color:", ";"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/YourAccount.js










function YourAccount_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function YourAccount_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? YourAccount_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : YourAccount_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function YourAccount_createSuper(Derived) { var hasNativeReflectConstruct = YourAccount_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function YourAccount_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

















var YourAccount = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(YourAccount, _Component);

  var _super = YourAccount_createSuper(YourAccount);

  function YourAccount(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, YourAccount);

    _this = _super.call(this, props);
    _this.state = {
      initialState: {},
      teacherDetails: {},
      classDetails: {},
      isEditMode: false,
      battleControlCustomUnlock: false
    };
    _this.setTeacherState = _this.setTeacherState.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.setClassState = _this.setClassState.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.setBattleControlUnlock = _this.setBattleControlUnlock.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onSubmit = _this.onSubmit.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(YourAccount, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // prevent state refresh after failed mutation (due to wrong password)
      var currentModalId = this.props.modal.getCurrent().id;
      if (currentModalId === 'sensitiveInfoPopup' && this.state.teacherDetails._id) return;
      var teacherDetails = nextProps.teacherDetails,
          classDetails = nextProps.classDetails;

      if (teacherDetails && classDetails) {
        this.setState({
          initialState: {
            teacherDetails: teacherDetails,
            classDetails: classDetails
          },
          teacherDetails: teacherDetails,
          classDetails: classDetails
        });
      }
    }
  }, {
    key: "setTeacherState",
    value: function setTeacherState(_ref) {
      var field = _ref.field,
          value = _ref.value;
      this.setState({
        teacherDetails: YourAccount_objectSpread(YourAccount_objectSpread({}, this.state.teacherDetails), {}, (0,defineProperty/* default */.Z)({}, field, value))
      });
    }
  }, {
    key: "setClassState",
    value: function setClassState(_ref2) {
      var field = _ref2.field,
          value = _ref2.value;
      this.setState({
        classDetails: YourAccount_objectSpread(YourAccount_objectSpread({}, this.state.classDetails), {}, (0,defineProperty/* default */.Z)({}, field, value))
      });
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      if (event.target.type !== 'textarea' && event.which === 13
      /* Enter */
      ) {
        event.preventDefault();
      }
    }
  }, {
    key: "setBattleControlUnlock",
    value: function setBattleControlUnlock() {
      this.setState({
        classDetails: YourAccount_objectSpread(YourAccount_objectSpread({}, this.state.classDetails), {}, {
          battleLockedUntil: '1970-01-01T00:00:00.000Z'
        }),
        battleControlCustomUnlock: true
      });
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _this2 = this;

        var _this$state, teacherDetails, classDetails, classBlogImage, newTeacherDetails;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state = this.state, teacherDetails = _this$state.teacherDetails, classDetails = _this$state.classDetails, classBlogImage = _this$state.classBlogImage;
                newTeacherDetails = Object.keys(this.state.teacherDetails).reduce(function (acc, el) {
                  if (_this2.state.teacherDetails[el] !== _this2.state.initialState.teacherDetails[el]) {
                    return YourAccount_objectSpread(YourAccount_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, el, _this2.state.teacherDetails[el]));
                  }

                  return acc;
                }, {});

                if (!(newTeacherDetails.password || newTeacherDetails.email)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this.openSensitiveInfoModal(newTeacherDetails, classDetails));

              case 4:
                _context.prev = 4;

                if (!Object.keys(newTeacherDetails).length) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return this.props.updateTeacherDetails(newTeacherDetails);

              case 8:
                _context.next = 10;
                return this.updateClassDetails(classDetails);

              case 10:
                this.setState({
                  isEditMode: false
                });
                _context.next = 13;
                return delay(1000);

              case 13:
                _context.next = 15;
                return this.refetchData();

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](4);
                this.props.modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
                  isSettings: true
                }));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 17]]);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "openSensitiveInfoModal",
    value: function openSensitiveInfoModal(teacherDetails, classDetails) {
      var _this3 = this;

      var modal = this.props.modal;
      modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(SensitiveInfoPopup, {
        isChangingPassword: !!teacherDetails.password,
        onConfirm: /*#__PURE__*/function () {
          var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
            var password;
            return regenerator_default().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    password = _ref3.password;
                    _context2.prev = 1;
                    _context2.next = 4;
                    return _this3.props.updateTeacherDetails(teacherDetails, password);

                  case 4:
                    _context2.next = 6;
                    return _this3.updateClassDetails(classDetails);

                  case 6:
                    if (teacherDetails.password) modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordChangedPopup, {}));else modal.close();

                    _this3.setState({
                      isEditMode: false
                    });

                    _context2.next = 10;
                    return delay(1000);

                  case 10:
                    _context2.next = 12;
                    return _this3.refetchData();

                  case 12:
                    _context2.next = 19;
                    break;

                  case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](1);

                    if (!(_context2.t0.graphQLErrors && _context2.t0.graphQLErrors[0].message === 'Access Denied')) {
                      _context2.next = 18;
                      break;
                    }

                    return _context2.abrupt("return", modal.updateProps({
                      passwordError: true
                    }));

                  case 18:
                    modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
                      isSettings: true
                    }));

                  case 19:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[1, 14]]);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(),
        onCancel: function onCancel() {
          return modal.close();
        }
      }), 'sensitiveInfoPopup');
    }
  }, {
    key: "updateClassDetails",
    value: function () {
      var _updateClassDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(classDetails) {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.updateClassDetails({
                  _id: classDetails._id,
                  name: classDetails.name,
                  yearGroup: classDetails.yearGroup,
                  description: classDetails.description,
                  headerArtwork: {
                    url: classDetails.headerArtwork
                  },
                  battleLockedUntil: classDetails.battleLockedUntil
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateClassDetails(_x2) {
        return _updateClassDetails.apply(this, arguments);
      }

      return updateClassDetails;
    }()
  }, {
    key: "refetchData",
    value: function () {
      var _refetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
        var _yield$this$props$cli, data, me, group, teacherDetails, classDetails;

        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.props.client.query({
                  query: this.props.queries[0].query,
                  fetchPolicy: 'network-only'
                });

              case 2:
                _yield$this$props$cli = _context4.sent;
                data = _yield$this$props$cli.data;
                me = data.me;
                group = data.me.group;
                teacherDetails = {
                  name: me.name,
                  email: me.email,
                  twitter: me.twitter,
                  skype: me.skype
                };
                classDetails = {
                  _id: group._id,
                  yearGroup: group.yearGroup,
                  name: group.name,
                  description: group.description,
                  headerArtwork: group.headerArtwork && group.headerArtwork.url,
                  battleLockedUntil: group.battleLockedUntil
                };
                this.setState({
                  initialState: {
                    teacherDetails: teacherDetails,
                    classDetails: classDetails
                  },
                  teacherDetails: teacherDetails,
                  classDetails: classDetails,
                  battleControlCustomUnlock: false
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refetchData() {
        return _refetchData.apply(this, arguments);
      }

      return refetchData;
    }()
  }, {
    key: "renderDesktopButtons",
    value: function renderDesktopButtons() {
      var _this4 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonColumn, {
        children: this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            iconName: "cross",
            size: "regular",
            onClick: function onClick() {
              return _this4.setState(YourAccount_objectSpread(YourAccount_objectSpread({}, _this4.state.initialState), {}, {
                isEditMode: false,
                battleControlCustomUnlock: false
              }));
            },
            children: "Undo"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            "data-save": true,
            element: "button",
            type: "submit",
            form: "your-account",
            bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
            color: "white",
            iconName: "check",
            size: "regular",
            columnView: true,
            children: "Save"
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          iconName: "pencil",
          color: "white",
          size: "regular",
          columnView: true,
          onClick: function onClick() {
            return _this4.setState({
              isEditMode: true
            });
          },
          children: "Edit"
        })
      });
    }
  }, {
    key: "renderMobileButtons",
    value: function renderMobileButtons() {
      var _this5 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(MobileButtons, {
        children: this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          "data-save": true,
          element: "button",
          type: "submit",
          form: "your-account",
          bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
          color: "white",
          iconName: "check",
          size: "regular",
          columnView: true,
          children: "Save"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          iconName: "pencil",
          color: "white",
          size: "regular",
          columnView: true,
          onClick: function onClick() {
            return _this5.setState({
              isEditMode: true
            });
          },
          children: "Edit"
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      if (this.props.loading) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* LoaderWrapper */.sb, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
            bgColor: "rgba(0,0,0,0)",
            itemColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            itemSize: "90"
          })
        });
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(formsy_react_lib/* default */.ZP, {
        id: "your-account",
        onKeyPress: this.onKeyPress,
        onValidSubmit: this.onSubmit,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardSettings_styles/* GradientWrapper */.lM, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(YourAccount_styles_Content, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(YourDetailsColumn, {
              isEditMode: this.state.isEditMode,
              setEditMode: function setEditMode(bool) {
                return _this6.setState({
                  isEditMode: bool
                });
              },
              teacherDetails: this.state.teacherDetails,
              setTeacherState: this.setTeacherState,
              loading: this.props.loading,
              screenWidth: this.props.screenWidth
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ClassDetailsColumn_ClassDetailsColumn, {
              isParent: this.props.isParent,
              isEditMode: this.state.isEditMode,
              setEditMode: function setEditMode(bool) {
                return _this6.setState({
                  isEditMode: bool
                });
              },
              classDetails: this.state.classDetails,
              initialClassDetails: this.state.initialState.classDetails,
              setClassState: this.setClassState,
              battleControlCustomUnlock: this.state.battleControlCustomUnlock,
              setBattleControlUnlock: this.setBattleControlUnlock,
              loading: this.props.loading,
              modal: this.props.modal
            }), this.props.screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D ? this.renderDesktopButtons() : this.renderMobileButtons()]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DeleteAccountMessage, {
            children: ["We are committed to maintaining your privacy. To delete your account completely, please email", /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
              href: "mailto:support@nightzookeeper.com",
              children: " support@nightzookeeper.com"
            }), "."]
          })]
        })
      });
    }
  }]);

  return YourAccount;
}(react.Component);

(0,defineProperty/* default */.Z)(YourAccount, "defaultProps", {
  modal: {
    open: function open() {},
    close: function close() {},
    closeAll: function closeAll() {}
  }
});


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/YourAccount/YourAccountContainer.js




var YourAccountContainer_templateObject, YourAccountContainer_templateObject2, YourAccountContainer_templateObject3;



function YourAccountContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function YourAccountContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? YourAccountContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : YourAccountContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var YourAccountContainer_queries = [{
  query: (0,lib/* default */.ZP)(YourAccountContainer_templateObject || (YourAccountContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      {\n        me {\n          _id\n          name\n          email\n          twitter\n          skype\n          safeMarket\n          parent\n          group {\n            _id\n            yearGroup\n            name\n            description\n            headerArtwork {\n              url\n            }\n            battleLockedUntil\n          }\n        }\n      }\n    "]))),
  props: function props(_ref) {
    var data = _ref.data;

    if (data.loading || data.error) {
      return {
        loading: data.loading,
        error: data.error
      };
    }

    var me = data.me;
    var group = data.me.group;
    return {
      isParent: me.parent,
      teacherDetails: {
        _id: me._id,
        name: me.name,
        email: me.email,
        twitter: me.twitter,
        skype: me.skype,
        safeMarket: me.safeMarket
      },
      classDetails: {
        _id: group._id,
        yearGroup: group.yearGroup,
        name: group.name,
        description: group.description,
        headerArtwork: group.headerArtwork && group.headerArtwork.url,
        battleLockedUntil: group.battleLockedUntil
      }
    };
  },
  options: {
    fetchPolicy: 'network-only'
  }
}];
var YourAccountContainer_mutations = [{
  mutation: (0,lib/* default */.ZP)(YourAccountContainer_templateObject2 || (YourAccountContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation updateMe($user: UserInput, $userPassword: String) {\n        updateMe(user: $user, userPassword: $userPassword) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref2) {
    var mutate = _ref2.mutate;
    return {
      updateTeacherDetails: function () {
        var _updateTeacherDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(details, userPassword) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return mutate({
                    variables: {
                      user: YourAccountContainer_objectSpread({}, details),
                      userPassword: userPassword
                    }
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function updateTeacherDetails(_x, _x2) {
          return _updateTeacherDetails.apply(this, arguments);
        }

        return updateTeacherDetails;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(YourAccountContainer_templateObject3 || (YourAccountContainer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation updateGroup($group: UpdateGroupInput) {\n        updateGroup(group: $group) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref3) {
    var mutate = _ref3.mutate;
    return {
      updateClassDetails: function () {
        var _updateClassDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(details) {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return mutate({
                    variables: {
                      group: YourAccountContainer_objectSpread(YourAccountContainer_objectSpread({}, details), {}, {
                        yearGroup: parseInt(details.yearGroup)
                      })
                    }
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function updateClassDetails(_x3) {
          return _updateClassDetails.apply(this, arguments);
        }

        return updateClassDetails;
      }()
    };
  }
}];

var YourAccountContainer = function YourAccountContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
    children: function children(modal) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQuery/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(YourAccount, YourAccountContainer_objectSpread(YourAccountContainer_objectSpread({}, props), {}, {
          modal: modal
        }))
      });
    }
  });
};

/* harmony default export */ var YourAccount_YourAccountContainer = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DataContainer/* default */.Z, {
    queries: YourAccountContainer_queries,
    mutations: YourAccountContainer_mutations,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(YourAccountContainer, YourAccountContainer_objectSpread({}, props))
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/EmailErrorPopup/EmailErrorPopup.styles.js




var EmailErrorPopup_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "EmailErrorPopupstyles__Title",
  componentId: "sc-1u8gcq0-0"
})(["font-size:", ";font-weight:600;color:", ";text-align:center;margin-top:0px;margin-bottom:20px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var EmailErrorPopup_styles_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "EmailErrorPopupstyles__Subtitle",
  componentId: "sc-1u8gcq0-1"
})(["color:", ";font-size:", ";font-weight:bold;text-align:center;margin-bottom:10px;margin-top:0px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple, DashboardSettings_styles/* fontSize.small */.JB.small);
var EmailList = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "EmailErrorPopupstyles__EmailList",
  componentId: "sc-1u8gcq0-2"
})(["color:", ";font-size:", ";text-align:center;margin-top:0px;white-space:nowrap;overflow:scroll;"], Dashboard_global_styles/* colors.blue */.O9.blue, DashboardSettings_styles/* fontSize.small */.JB.small);
var EmailErrorPopup_styles_Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "EmailErrorPopupstyles__Note",
  componentId: "sc-1u8gcq0-3"
})(["color:", ";font-size:", ";text-align:center;margin-top:0px;"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, DashboardSettings_styles/* fontSize.small */.JB.small);
var EmailErrorPopup_styles_ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EmailErrorPopupstyles__ButtonRow",
  componentId: "sc-1u8gcq0-4"
})(["display:flex;justify-content:center;margin-bottom:35px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/EmailErrorPopup/EmailErrorPopup.js






function EmailErrorPopup_createSuper(Derived) { var hasNativeReflectConstruct = EmailErrorPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function EmailErrorPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var EmailErrorPopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(EmailErrorPopup, _Component);

  var _super = EmailErrorPopup_createSuper(EmailErrorPopup);

  function EmailErrorPopup() {
    (0,classCallCheck/* default */.Z)(this, EmailErrorPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(EmailErrorPopup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        isSettings: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EmailErrorPopup_styles_Title, {
          children: "Whoops!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailErrorPopup_styles_Subtitle, {
          children: "The following e-mail addresses could not be added to your school:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailList, {
          children: this.props.emails.join(', ')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailErrorPopup_styles_Note, {
          children: "Please make sure that all your teachers have an existing Night Zookeeper account"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailErrorPopup_styles_ButtonRow, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            size: "regular",
            width: "105px",
            height: "30px",
            onClick: this.props.onCancel,
            children: "OK"
          })
        })]
      });
    }
  }]);

  return EmailErrorPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/components/SchoolDetailsColumn/SchoolDetailsColumn.styles.js




var SchoolDetailsColumn_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolDetailsColumnstyles__Wrapper",
  componentId: "sc-66pecn-0"
})(["width:280px;margin-right:40px;@media (max-width:950px){width:unset;}"]);
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(DashboardSettings_styles/* Title */.Dx).withConfig({
  displayName: "SchoolDetailsColumnstyles__StyledTitle",
  componentId: "sc-66pecn-1"
})(["display:inline-block;"]);
var SchoolDetailsColumn_styles_StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "SchoolDetailsColumnstyles__StyledFormInput",
  componentId: "sc-66pecn-2"
})(["margin-right:10px;"]);
var UpgradePromo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolDetailsColumnstyles__UpgradePromo",
  componentId: "sc-66pecn-3"
})(["margin-top:25px;"]);
var UpgradeMessage = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "SchoolDetailsColumnstyles__UpgradeMessage",
  componentId: "sc-66pecn-4"
})(["color:", ";font-size:", ";margin-top:0px;margin-bottom:10px;"], Dashboard_global_styles/* colors.orange */.O9.orange, DashboardSettings_styles/* fontSize.small */.JB.small);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/components/SchoolDetailsColumn/SchoolDetailsColumn.js








function SchoolDetailsColumn_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SchoolDetailsColumn_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SchoolDetailsColumn_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SchoolDetailsColumn_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SchoolDetailsColumn_createSuper(Derived) { var hasNativeReflectConstruct = SchoolDetailsColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SchoolDetailsColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var SchoolDetailsColumn = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(SchoolDetailsColumn, _Component);

  var _super = SchoolDetailsColumn_createSuper(SchoolDetailsColumn);

  function SchoolDetailsColumn(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, SchoolDetailsColumn);

    _this = _super.call(this, props);
    _this.state = {
      screenWidth: 0
    };
    _this.onInputChange = _this.onInputChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.updateScreenWidth = _this.updateScreenWidth.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(SchoolDetailsColumn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScreenWidth();
      window.addEventListener('resize', this.updateScreenWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateScreenWidth);
    }
  }, {
    key: "updateScreenWidth",
    value: function updateScreenWidth() {
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.setState({
        screenWidth: screenWidth
      });
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(e) {
      this.props.setSchoolState({
        field: e.target.name,
        value: e.target.value
      });
    }
  }, {
    key: "renderUpgradePromo",
    value: function renderUpgradePromo() {
      var _this$props = this.props,
          subscriptionStatus = _this$props.subscriptionStatus,
          subscriptionEndDate = _this$props.subscriptionEndDate;
      if (!['trial', 'expired'].includes(subscriptionStatus)) return null;
      var now = new Date().getTime();
      var daysLeft = Math.ceil((subscriptionEndDate - now) / (1000 * 3600 * 24));
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(UpgradePromo, {
        children: [subscriptionStatus === 'trial' && /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeMessage, {
          children: "Your free trial ends in ".concat(daysLeft, " days")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UI_Link/* default */.Z, {
          to: "/dashboard/settings/subscription",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.red */.O9.red,
            color: Dashboard_global_styles/* colors.yellow */.O9.yellow,
            size: "regular",
            children: "Upgrade"
          })
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          info = _this$props2.info,
          isEditMode = _this$props2.isEditMode,
          subscriptionStatus = _this$props2.subscriptionStatus;
      var screenWidth = this.state.screenWidth;
      var commonProps = {
        placeholderColor: isEditMode ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundColor: isEditMode ? null : Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue,
        inputColor: isEditMode ? null : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
        fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
        noBorder: !isEditMode,
        focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
        element: 'button',
        disabled: !isEditMode,
        autoComplete: 'off',
        narrow: true,
        textSize: '15px',
        fieldNameSize: '18px',
        width: screenWidth <= 950 ? '180px' : '220px'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(SchoolDetailsColumn_styles_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          children: "School Details"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolDetailsColumn_styles_StyledFormInput, SchoolDetailsColumn_objectSpread(SchoolDetailsColumn_objectSpread({}, commonProps), {}, {
          value: info.name,
          onChange: this.onInputChange,
          name: "name",
          fieldName: "School Name",
          placeholder: "School name",
          required: true
        })), subscriptionStatus !== 'trial' && /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolDetailsColumn_styles_StyledFormInput, SchoolDetailsColumn_objectSpread(SchoolDetailsColumn_objectSpread({}, commonProps), {}, {
          value: info.twitter,
          onChange: this.onInputChange,
          name: "twitter",
          fieldName: "School Twitter",
          placeholder: "School twitter"
        })), this.renderUpgradePromo()]
      });
    }
  }]);

  return SchoolDetailsColumn;
}(react.Component);

(0,defineProperty/* default */.Z)(SchoolDetailsColumn, "defaultProps", {
  info: {},
  setSchoolState: function setSchoolState() {},
  subscriptionStatus: '',
  subscriptionEndDate: ''
});


;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/UpgradePopup/UpgradePopup.styles.js




var UpgradePopup_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "UpgradePopupstyles__Title",
  componentId: "sc-12538xd-0"
})(["font-size:", ";font-weight:600;color:", ";text-align:center;margin-top:20px;margin-bottom:20px;"], DashboardSettings_styles/* fontSize.xLarge */.JB.xLarge, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var UpgradePopup_styles_Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "UpgradePopupstyles__Subtitle",
  componentId: "sc-12538xd-1"
})(["color:", ";font-size:", ";text-align:center;margin-bottom:20px;margin-top:0px;"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, DashboardSettings_styles/* fontSize.small */.JB.small);
var UpgradePopup_styles_ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "UpgradePopupstyles__ButtonRow",
  componentId: "sc-12538xd-2"
})(["display:flex;justify-content:center;margin-bottom:35px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardPopup/UpgradePopup/UpgradePopup.js






function UpgradePopup_createSuper(Derived) { var hasNativeReflectConstruct = UpgradePopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function UpgradePopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var UpgradePopup = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(UpgradePopup, _Component);

  var _super = UpgradePopup_createSuper(UpgradePopup);

  function UpgradePopup() {
    (0,classCallCheck/* default */.Z)(this, UpgradePopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(UpgradePopup, [{
    key: "render",
    value: function render() {
      var subscriptionStatus = this.props.subscriptionStatus;
      var titles = {
        trial: 'Upgrade your account',
        stripe: 'Upgrade to a custom plan',
        custom: 'Upgrade your custom plan',
        expired: 'Renew your subscription'
      };
      var subtitles = {
        trial: 'Upgrade your account to add more teachers to your school! Press the button below to learn more.',
        stripe: 'Upgrade to a custom plan to add more teachers to your school! Press the button below to learn more.',
        custom: 'Upgrade your custom plan to add more teachers to your school! Press the button below to learn more.',
        expired: 'Renew your subscription to add more teachers to your school! Press the button below to learn more.'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        isSettings: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UpgradePopup_styles_Title, {
          children: titles[subscriptionStatus]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradePopup_styles_Subtitle, {
          children: subtitles[subscriptionStatus]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradePopup_styles_ButtonRow, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
            color: "white",
            size: "regular",
            onClick: function onClick() {
              return window.open('/edu/dashboard/settings/subscription', '_self');
            },
            children: "Learn more"
          })
        })]
      });
    }
  }]);

  return UpgradePopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/components/TeacherInfoRow/TeacherInfoRow.styles.js



var TeacherInfoRow_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeacherInfoRowstyles__Wrapper",
  componentId: "sc-1lsgass-0"
})(["display:flex;flex-flow:row wrap;width:520px;@media (max-width:950px){width:unset;}"]);
var TeacherInfoRow_styles_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "TeacherInfoRowstyles__StyledButton",
  componentId: "sc-1lsgass-1"
})(["margin-top:", ";"], function (props) {
  return props.isFirstRow ? '27px' : '5px';
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/components/TeacherInfoRow/TeacherInfoRow.js








function TeacherInfoRow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TeacherInfoRow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TeacherInfoRow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TeacherInfoRow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function TeacherInfoRow_createSuper(Derived) { var hasNativeReflectConstruct = TeacherInfoRow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function TeacherInfoRow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var TeacherInfoRow = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(TeacherInfoRow, _Component);

  var _super = TeacherInfoRow_createSuper(TeacherInfoRow);

  function TeacherInfoRow(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, TeacherInfoRow);

    _this = _super.call(this, props);
    _this.onInputChange = _this.onInputChange.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(TeacherInfoRow, [{
    key: "onInputChange",
    value: function onInputChange(e) {
      this.props.setTeacherState({
        _id: this.props.info._id,
        field: e.target.name,
        value: e.target.value
      });
    }
  }, {
    key: "shouldShowDeleteButton",
    value: function shouldShowDeleteButton(info) {
      if (!this.props.isEditMode) return false;
      if (info.stagedForDeletion) return false;
      if (this.props.isLoggedInUser) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          screenWidth = _this$props.screenWidth,
          info = _this$props.info,
          isEditMode = _this$props.isEditMode,
          isFirstRow = _this$props.isFirstRow,
          onRemoveTeacher = _this$props.onRemoveTeacher;
      var commonProps = {
        placeholderColor: isEditMode && info.isNew ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundColor: isEditMode && info.isNew ? null : Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue,
        inputColor: isEditMode && info.isNew ? null : Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple,
        fieldNameColor: Dashboard_global_styles/* colors.pink */.O9.pink,
        noBorder: !(isEditMode && info.isNew),
        focusColor: Dashboard_global_styles/* colors.orange */.O9.orange,
        backgroundFocusColor: Dashboard_global_styles/* colors.lightOrange */.O9.lightOrange,
        element: 'button',
        narrow: true,
        textSize: '15px',
        fieldNameSize: '18px',
        inputOpacity: info.stagedForDeletion ? '0.5' : '1',
        disabled: !(isEditMode && info.isNew),
        autoComplete: 'off',
        width: screenWidth <= 950 ? '180px' : '220px'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TeacherInfoRow_styles_Wrapper, {
        children: [!info.isNew && /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, TeacherInfoRow_objectSpread(TeacherInfoRow_objectSpread({}, commonProps), {}, {
          value: info.name,
          onChange: this.onInputChange,
          name: "name",
          fieldName: isFirstRow ? 'Name' : null,
          placeholder: "Teacher name"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* StyledFormInput */.YL, TeacherInfoRow_objectSpread(TeacherInfoRow_objectSpread({}, commonProps), {}, {
          value: info.email,
          onChange: this.onInputChange,
          name: "email",
          fieldName: isFirstRow ? 'Email' : null,
          placeholder: "Teacher email",
          alignedRight: info.isNew,
          required: true,
          validations: "isEmail",
          validationError: "Email not valid"
        })), this.shouldShowDeleteButton(info) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return onRemoveTeacher(info._id);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TeacherInfoRow_styles_StyledButton, {
            element: "button",
            type: "button",
            size: "regular",
            round: true,
            bgColor: Dashboard_global_styles/* colors.red */.O9.red,
            isFirstRow: isFirstRow,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
              name: "trash",
              color: "white",
              size: "regular"
            })
          })
        })]
      });
    }
  }]);

  return TeacherInfoRow;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/components/TeachersColumn/TeachersColumn.styles.js



var TeachersColumn_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeachersColumnstyles__Wrapper",
  componentId: "sc-1xh7a5j-0"
})([""]);
var TeachersColumn_styles_BottomButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TeachersColumnstyles__BottomButtonRow",
  componentId: "sc-1xh7a5j-1"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
var TeachersColumn_styles_AddButtonText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TeachersColumnstyles__AddButtonText",
  componentId: "sc-1xh7a5j-2"
})(["font-size:", ";color:", ";vertical-align:middle;padding-left:10px;cursor:pointer;"], DashboardSettings_styles/* fontSize.small */.JB.small, function (props) {
  return props.disabled ? Dashboard_global_styles/* colors.grey */.O9.grey : Dashboard_global_styles/* colors.orange */.O9.orange;
});
var HelperText = (0,styled_components_browser_esm/* default */.ZP)(TeachersColumn_styles_AddButtonText).withConfig({
  displayName: "TeachersColumnstyles__HelperText",
  componentId: "sc-1xh7a5j-3"
})(["font-size:14px;color:", ";width:400px;@media (max-width:950px){width:265px;}"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/components/TeachersColumn/TeachersColumn.js






function TeachersColumn_createSuper(Derived) { var hasNativeReflectConstruct = TeachersColumn_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function TeachersColumn_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }














var TeachersColumn = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(TeachersColumn, _Component);

  var _super = TeachersColumn_createSuper(TeachersColumn);

  function TeachersColumn() {
    (0,classCallCheck/* default */.Z)(this, TeachersColumn);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(TeachersColumn, [{
    key: "getNumberOfTeachers",
    value: function getNumberOfTeachers() {
      return this.props.teachers.filter(function (teacher) {
        return !teacher.isNew && !teacher.stagedForDeletion;
      }).length;
    }
  }, {
    key: "renderTeachers",
    value: function renderTeachers() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQuery/* default */.Z, {
        children: this.props.teachers.map(function (teacher, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(TeacherInfoRow, {
            info: teacher,
            isFirstRow: i === 0,
            isEditMode: _this.props.isEditMode,
            isLoggedInUser: _this.props.loggedInUser === teacher._id,
            numberOfTeachers: _this.getNumberOfTeachers(),
            onRemoveTeacher: _this.props.onRemoveTeacher,
            setTeacherState: _this.props.setTeacherState
          }, teacher._id);
        })
      });
    }
  }, {
    key: "renderBottomButtonRow",
    value: function renderBottomButtonRow(modal) {
      var _this2 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TeachersColumn_styles_BottomButtonRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          element: "button",
          bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
          color: "white",
          size: "regular",
          round: true,
          onClick: function onClick() {
            return _this2.canAddMoreTeachers() ? _this2.props.onAddTeacher() : modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradePopup, {
              subscriptionStatus: _this2.props.subscriptionStatus
            }));
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "plus",
            color: "white",
            size: "regular"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TeachersColumn_styles_AddButtonText, {
          onClick: function onClick() {
            return _this2.canAddMoreTeachers() ? _this2.props.onAddTeacher() : modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradePopup, {
              subscriptionStatus: _this2.props.subscriptionStatus
            }));
          },
          children: "Add Teacher"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(HelperText, {
          children: this.getAvailableTeachersText()
        })]
      });
    }
  }, {
    key: "canAddMoreTeachers",
    value: function canAddMoreTeachers() {
      var subscriptionStatus = this.props.subscriptionStatus;
      if (subscriptionStatus !== 'custom') return false;
      if (this.props.allowedTeachers === 5) return true;
      var availTeachers = this.props.allowedTeachers && this.props.allowedTeachers - this.props.teachers.length;
      return availTeachers > 0;
    }
  }, {
    key: "getAvailableTeachersText",
    value: function getAvailableTeachersText() {
      if (this.props.subscriptionStatus === 'trial') {
        return 'Please upgrade to add more teachers to your school';
      }

      if (this.props.subscriptionStatus === 'stripe') {
        return 'Please upgrade to a custom plan to add more teachers to your school';
      }

      if (this.props.subscriptionStatus === 'expired') {
        return 'Please renew your subscription to add more teachers to your school';
      } // If allowedTeachers is 5, can add as many as they like


      if (this.props.allowedTeachers === 5) return 'All teachers need an existing Night Zookeeper account';
      var availTeachers = this.props.allowedTeachers && this.props.allowedTeachers - this.props.teachers.length;

      if (availTeachers > 0) {
        return "You can add ".concat(availTeachers, " more teacher").concat(availTeachers > 1 ? 's' : '', " on your current plan.\n      All teachers need an existing Night Zookeeper account");
      }

      return 'You have reached the maximum number of teachers for your plan';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TeachersColumn_styles_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* Title */.Dx, {
          children: "Teachers"
        }), this.renderTeachers(), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
          children: function children(modal) {
            return _this3.renderBottomButtonRow(modal);
          }
        })]
      });
    }
  }]);

  return TeachersColumn;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(54490);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/ReferralContent/ReferralContent.styles.js




var ReferralContent_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ReferralContentstyles__Wrapper",
  componentId: "sc-1j7q3y6-0"
})(["max-width:830px;margin:auto;padding:20px 0;@media (max-width:", "px){padding:20px 15px;};@media (max-width:", "px){padding:0 15px;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu, DashboardSettings_styles/* phoneMaxWidth */.D);

var titleStyle = function titleStyle(props) {
  switch (props.type) {
    case 'main':
      return (0,styled_components_browser_esm/* css */.iv)(["color:", ";margin:60px 0 30px;justify-content:center;@media (max-width:", "px){margin:20px 0 30px;};"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple, DashboardSettings_styles/* phoneMaxWidth */.D);

    case 'sub':
      return (0,styled_components_browser_esm/* css */.iv)(["color:", ";margin:0;text-align:left;"], Dashboard_global_styles/* colors.pink */.O9.pink);

    default:
      return (0,styled_components_browser_esm/* css */.iv)(["color:", ";margin:60px 0 30px;justify-content:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);
  }
};

var ReferralContent_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "ReferralContentstyles__Title",
  componentId: "sc-1j7q3y6-1"
})(["display:flex;font-size:24px;", ";"], titleStyle);
var TextImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ReferralContentstyles__TextImageWrapper",
  componentId: "sc-1j7q3y6-2"
})(["display:flex;padding-bottom:", ";"], function (props) {
  return props.textImageStyle;
});
var Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ReferralContentstyles__Image",
  componentId: "sc-1j7q3y6-3"
})(["background-image:url(", "/pages/Dashboard/images/girl-watching-video.jpg);background-size:contain;background-repeat:no-repeat;min-width:400px;@media (max-width:", "px){min-width:250px;};@media (max-width:", "px){display:none;};"], "/edu/assets", DashboardSettings_styles/* ipadPortraitMaxWidth */.xu, DashboardSettings_styles/* phoneMaxWidth */.D);
var InfoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ReferralContentstyles__InfoSection",
  componentId: "sc-1j7q3y6-4"
})(["display:flex;flex-direction:column;margin-left:60px;@media (max-width:", "px){min-width:250px;margin-left:30px;};@media (max-width:", "px){margin-left:0;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu, DashboardSettings_styles/* phoneMaxWidth */.D);
var Info = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ReferralContentstyles__Info",
  componentId: "sc-1j7q3y6-5"
})(["margin:20px 0 0;color:", ";"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var ReferralContent_styles_Link = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ReferralContentstyles__Link",
  componentId: "sc-1j7q3y6-6"
})(["margin:0;color:", ";"], Dashboard_global_styles/* colors.blue */.O9.blue);
var ButtonTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ReferralContentstyles__ButtonTextContainer",
  componentId: "sc-1j7q3y6-7"
})(["display:flex;align-items:center;justify-content:space-between;"]);

var smallPrintStyle = function smallPrintStyle(props) {
  switch (props.type) {
    case 'smallBlue':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;"]);

    case 'smallRed':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:11px;color:", ";margin:0 0 0 10px;"], Dashboard_global_styles/* colors.red */.O9.red);

    case 'regularYellow':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;color:", ";text-align:center;margin-top:-20px;"], Dashboard_global_styles/* colors.yellow */.O9.yellow);

    case 'regularBlue':
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;position:relative;margin-left:34px;&:before{content:'i';font-weight:bold;position:absolute;left:-34px;top:-4px;border:1px solid;border-radius:50%;padding:2px 9px;}"]);

    default:
      return (0,styled_components_browser_esm/* css */.iv)(["font-size:11px;"]);
  }
};

var SmallPrint = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ReferralContentstyles__SmallPrint",
  componentId: "sc-1j7q3y6-8"
})(["color:", ";", ";"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, smallPrintStyle);
// EXTERNAL MODULE: ./themes/styles/dimensions.js
var dimensions = __webpack_require__(73085);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/SchoolStatusBanner/SchoolStatusBanner.styles.js



var Text = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "SchoolStatusBannerstyles__Text",
  componentId: "sc-htqdjy-0"
})(["display:flex;font-size:24px;color:", ";margin:60px 0 30px;justify-content:center;@media (max-width:", "px){font-size:16px;};"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple, dimensions/* phoneMaxWidth */.D);
var NumberItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "SchoolStatusBannerstyles__NumberItem",
  componentId: "sc-htqdjy-1"
})(["color:", ";"], Dashboard_global_styles/* colors.blue */.O9.blue);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/SchoolStatusBanner/SchoolStatusBanner.js







function SchoolStatusBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SchoolStatusBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SchoolStatusBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SchoolStatusBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SchoolStatusBanner_createSuper(Derived) { var hasNativeReflectConstruct = SchoolStatusBanner_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SchoolStatusBanner_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var messages = (0,react_intl_lib/* defineMessages */.vU)({
  teacherNumber: {
    id: 'dashboard.referrals.teacherNumber',
    defaultMessage: 'teachers in your school'
  },
  teacherNumberSingle: {
    id: 'dashboard.referrals.teacherNumberSingle',
    defaultMessage: 'teacher in your school'
  },
  numberToGo: {
    id: 'dashboard.referrals.numberToGo',
    defaultMessage: 'more to go'
  },
  smallPrintText: {
    id: 'dashboard.referrals.schoolSmallPrintText',
    defaultMessage: 'You need at least 6 total subscribing teachers in your school to claim this offer. Max £100 vouchers per school.'
  }
});

var SchoolStatusBanner = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(SchoolStatusBanner, _Component);

  var _super = SchoolStatusBanner_createSuper(SchoolStatusBanner);

  function SchoolStatusBanner() {
    (0,classCallCheck/* default */.Z)(this, SchoolStatusBanner);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(SchoolStatusBanner, [{
    key: "render",
    value: function render() {
      var teachers = this.props.teachers;
      var numberToGo = teachers && 6 - teachers.length || 6;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text, {
          type: "main",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NumberItem, {
            children: teachers.length || 0
          }), "\xA0", teachers.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, SchoolStatusBanner_objectSpread({}, messages.teacherNumberSingle)) : /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, SchoolStatusBanner_objectSpread({}, messages.teacherNumber)), "\xA0=\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(NumberItem, {
            children: numberToGo
          }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, SchoolStatusBanner_objectSpread({}, messages.numberToGo)), "*"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SmallPrint, {
          type: "regularBlue",
          children: ["*", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, SchoolStatusBanner_objectSpread({}, messages.smallPrintText))]
        })]
      });
    }
  }]);

  return SchoolStatusBanner;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/VoucherOffer/VoucherOffer.styles.js



var VoucherOffer_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "VoucherOfferstyles__Wrapper",
  componentId: "sc-7svl9l-0"
})(["max-width:900px;margin:15px auto 0;padding:20px 0;@media (max-width:", "px){padding:20px 15px;};@media (max-width:", "px){padding:0 15px;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu, DashboardSettings_styles/* phoneMaxWidth */.D);

var VoucherOffer_styles_titleStyle = function titleStyle(props) {
  switch (props.type) {
    case 'main':
      return (0,styled_components_browser_esm/* css */.iv)(["color:", ";margin:20px 0 30px;justify-content:center;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);

    case 'sub':
      return (0,styled_components_browser_esm/* css */.iv)(["color:", ";margin:0;text-align:left;"], Dashboard_global_styles/* colors.pink */.O9.pink);

    default:
      return (0,styled_components_browser_esm/* css */.iv)(["color:", ";margin:0 0 30px;justify-content:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);
  }
};

var VoucherOffer_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "VoucherOfferstyles__Title",
  componentId: "sc-7svl9l-1"
})(["display:flex;font-size:24px;", ";"], VoucherOffer_styles_titleStyle);
var ImageTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "VoucherOfferstyles__ImageTextWrapper",
  componentId: "sc-7svl9l-2"
})(["display:flex;flex-flow:row;"]);
var AmazonImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "VoucherOfferstyles__AmazonImage",
  componentId: "sc-7svl9l-3"
})(["background-image:url(", "/pages/Dashboard/images/amazon-logo.jpg);background-size:contain;background-repeat:no-repeat;min-width:400px;min-height:200px;@media (max-width:", "px){min-width:250px;min-height:125px;};@media (max-width:", "px){display:none;};"], "/edu/assets", DashboardSettings_styles/* ipadPortraitMaxWidth */.xu, DashboardSettings_styles/* phoneMaxWidth */.D);
var VoucherOffer_styles_InfoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "VoucherOfferstyles__InfoSection",
  componentId: "sc-7svl9l-4"
})(["display:flex;flex-direction:column;margin-left:60px;@media (max-width:", "px){margin-left:0;};"], DashboardSettings_styles/* phoneMaxWidth */.D);
var Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "VoucherOfferstyles__Paragraph",
  componentId: "sc-7svl9l-5"
})(["color:", ";font-size:14px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/VoucherOffer/VoucherOffer.js







function VoucherOffer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VoucherOffer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VoucherOffer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VoucherOffer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function VoucherOffer_createSuper(Derived) { var hasNativeReflectConstruct = VoucherOffer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function VoucherOffer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var VoucherOffer_messages = (0,react_intl_lib/* defineMessages */.vU)({
  voucherTitle: {
    id: 'dashboard.referrals.voucherTitle',
    defaultMessage: 'Earn £100 in Amazon vouchers'
  },
  voucherSubTitle: {
    id: 'dashboard.referrals.voucherSubTitle',
    defaultMessage: 'Reach 6 subscribing teachers in your school'
  },
  voucherText: {
    id: 'dashboard.referrals.voucherText',
    defaultMessage: 'To take advantage of this offer, you must become the Night Zookeeper ambassador for your school.'
  },
  applyNow: {
    id: 'dashboard.referrals.applyNow',
    defaultMessage: 'Apply now'
  },
  ambassadorThanks: {
    id: 'dashboard.referrals.ambassadorThanks',
    defaultMessage: 'Thanks for your interest in becoming a Night Zookeeper ambassador! A member of our team will be in touch with you soon.'
  }
});

var VoucherOffer = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(VoucherOffer, _Component);

  var _super = VoucherOffer_createSuper(VoucherOffer);

  function VoucherOffer() {
    (0,classCallCheck/* default */.Z)(this, VoucherOffer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(VoucherOffer, [{
    key: "render",
    value: // static defaultProps = {
    //   ambassador: false
    // }
    function render() {
      var _this$props = this.props,
          teachers = _this$props.teachers,
          direction = _this$props.direction,
          ambassador = _this$props.ambassador,
          sendAmbassadorEmail = _this$props.sendAmbassadorEmail,
          ambassadorEmailSent = _this$props.ambassadorEmailSent;
      var ambassadorStatus = ambassadorEmailSent || ambassador ? /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
        color: "yellow",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, VoucherOffer_objectSpread({}, VoucherOffer_messages.ambassadorThanks))
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
          color: "pink",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, VoucherOffer_objectSpread({}, VoucherOffer_messages.voucherText))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          bgColor: Dashboard_global_styles/* colors.blue */.O9.blue,
          color: Dashboard_global_styles/* colors.white */.O9.white,
          size: "regular",
          width: "50%",
          type: "submit",
          onClick: sendAmbassadorEmail,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, VoucherOffer_objectSpread({}, VoucherOffer_messages.applyNow))
        })]
      });
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
        direction: direction,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VoucherOffer_styles_Wrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VoucherOffer_styles_Title, {
            type: "main",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, VoucherOffer_objectSpread({}, VoucherOffer_messages.voucherTitle))
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ImageTextWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AmazonImage, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(VoucherOffer_styles_InfoSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VoucherOffer_styles_Title, {
                type: "sub",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, VoucherOffer_objectSpread({}, VoucherOffer_messages.voucherSubTitle))
              }), ambassadorStatus]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolStatusBanner, {
            teachers: teachers
          })]
        })
      });
    }
  }]);

  return VoucherOffer;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/Blurb/Blurb.styles.js



var Blurb_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Blurbstyles__Wrapper",
  componentId: "sc-1s5odnd-0"
})(["max-width:900px;margin:0 auto;@media (max-width:", "px){padding:0 15px;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
var Blurb_styles_TextImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Blurbstyles__TextImageWrapper",
  componentId: "sc-1s5odnd-1"
})(["display:flex;flex-flow:row;padding:20px 0;"]);
var Blurb_styles_Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "Blurbstyles__Title",
  componentId: "sc-1s5odnd-2"
})(["font-size:24px;margin-top:0;color:", ";"], Dashboard_global_styles/* colors.blue */.O9.blue);
var Blurb_styles_Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Blurbstyles__Image",
  componentId: "sc-1s5odnd-3"
})(["background-image:url(", "/pages/Dashboard/images/girl-with-ipad.jpg);background-size:contain;background-repeat:no-repeat;min-width:400px;height:250px;margin-right:60px;@media (max-width:", "px){min-width:250px;height:156px;};"], "/edu/assets", DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/Blurb/Blurb.js


function Blurb_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Blurb_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Blurb_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Blurb_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Blurb_messages = (0,react_intl_lib/* defineMessages */.vU)({
  encourageToSubscribe: {
    id: 'dashboard.referrals.encourageToSubscribe',
    defaultMessage: 'Night Zookeeper has a huge impact on writing attainment when you build a large audience for your students. Encourage other teachers to subscribe and create a fantastic writing community in your school today!'
  }
});

var Blurb = function Blurb(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
    direction: props.direction,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Blurb_styles_Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Blurb_styles_TextImageWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blurb_styles_Image, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Blurb_styles_Title, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Blurb_objectSpread({}, Blurb_messages.encourageToSubscribe))
        })]
      })
    })
  });
};

/* harmony default export */ var Blurb_Blurb = (Blurb);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/Ambassador/Ambassador.styles.js



var Ambassador_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ambassadorstyles__Wrapper",
  componentId: "sc-18c8w6k-0"
})(["max-width:900px;margin:0 auto;@media (max-width:", "px){padding:0 15px;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
var Ambassador_styles_TextImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ambassadorstyles__TextImageWrapper",
  componentId: "sc-18c8w6k-1"
})(["display:flex;flex-flow:row;padding:20px 0;"]);
var TextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ambassadorstyles__TextWrapper",
  componentId: "sc-18c8w6k-2"
})(["display:flex;flex-direction:column;width:400px;margin-right:60px;"]);
var Ambassador_styles_Title = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
  displayName: "Ambassadorstyles__Title",
  componentId: "sc-18c8w6k-3"
})(["font-size:24px;margin:0;color:", ";"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Ambassadorstyles__List",
  componentId: "sc-18c8w6k-4"
})(["list-style-position:outside;padding-left:15px;"]);
var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Ambassadorstyles__ListItem",
  componentId: "sc-18c8w6k-5"
})(["margin:10px 0 0;color:", ";:last-of-type{margin-bottom:20px;}"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var Ambassador_styles_Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ambassadorstyles__Image",
  componentId: "sc-18c8w6k-6"
})(["background-image:url(", "/pages/Dashboard/images/giraffe-teacher.jpg);background-size:contain;background-repeat:no-repeat;min-width:400px;@media (max-width:", "px){min-width:250px;margin-left:30px;};"], "/edu/assets", DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
var Ambassador_styles_Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Ambassadorstyles__Paragraph",
  componentId: "sc-18c8w6k-7"
})(["color:", ";margin:0;font-size:14px;"], Dashboard_global_styles/* colors.blue */.O9.blue);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/Ambassador/Ambassador.js







function Ambassador_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Ambassador_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Ambassador_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Ambassador_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Ambassador_createSuper(Derived) { var hasNativeReflectConstruct = Ambassador_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Ambassador_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var Ambassador_messages = (0,react_intl_lib/* defineMessages */.vU)({
  ambassadorHelp: {
    id: 'dashboard.referrals.ambassadorHelp',
    defaultMessage: 'How you can help as a Night Zookeeper Ambassador'
  },
  presentMeetings: {
    id: 'dashboard.referrals.presentMeetings',
    defaultMessage: 'Present Night Zookeeper at team and staff meetings'
  },
  shareReport: {
    id: 'dashboard.referrals.shareReport',
    defaultMessage: 'Share your class report with your colleagues and senior leaders in your school'
  },
  sharePosts: {
    id: 'dashboard.referrals.sharePosts',
    defaultMessage: 'Share posts about Night Zookeeper on social media'
  },
  supportColleagues: {
    id: 'dashboard.referrals.supportColleagues',
    defaultMessage: 'Support your colleagues to get started on the website'
  },
  applyAmbassador: {
    id: 'dashboard.referrals.applyAmbassador',
    defaultMessage: 'Apply to become an ambassador'
  },
  ambassadorThanks: {
    id: 'dashboard.referrals.ambassadorThanks',
    defaultMessage: 'Thanks for your interest in becoming a Night Zookeeper ambassador! A member of our team will be in touch with you soon.'
  }
});

var Ambassador = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Ambassador, _Component);

  var _super = Ambassador_createSuper(Ambassador);

  function Ambassador() {
    (0,classCallCheck/* default */.Z)(this, Ambassador);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Ambassador, [{
    key: "render",
    value: // static defaultProps = {
    //   buttonClicked: false,
    //   ambassador: false
    // }
    function render() {
      var _this$props = this.props,
          direction = _this$props.direction,
          ambassador = _this$props.ambassador,
          sendAmbassadorEmail = _this$props.sendAmbassadorEmail,
          ambassadorEmailSent = _this$props.ambassadorEmailSent;
      var ambassadorStatus = ambassadorEmailSent || ambassador ? /*#__PURE__*/(0,jsx_runtime.jsx)(Ambassador_styles_Paragraph, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.ambassadorThanks))
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        bgColor: Dashboard_global_styles/* colors.blue */.O9.blue,
        color: Dashboard_global_styles/* colors.white */.O9.white,
        size: "small",
        onClick: sendAmbassadorEmail,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.applyAmbassador))
      });
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
        direction: direction,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Ambassador_styles_Wrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Ambassador_styles_TextImageWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ambassador_styles_Title, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.ambassadorHelp))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(List, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ListItem, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.presentMeetings))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.shareReport))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.sharePosts))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Ambassador_objectSpread({}, Ambassador_messages.supportColleagues))
                })]
              }), ambassadorStatus]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ambassador_styles_Image, {})]
          })
        })
      });
    }
  }]);

  return Ambassador;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/Downloads/Downloads.styles.js



var Downloads_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Downloadsstyles__Wrapper",
  componentId: "sc-fy7eu9-0"
})(["max-width:900px;margin:0 auto;display:flex;flex-direction:column;@media (max-width:", "px){padding:0 15px;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
var Downloads_styles_Info = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Downloadsstyles__Info",
  componentId: "sc-fy7eu9-1"
})(["margin:", ";color:", ";"], function (props) {
  return props.halfWidth ? '0' : '20px 0 0';
}, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var Downloads_styles_Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Downloadsstyles__Link",
  componentId: "sc-fy7eu9-2"
})(["margin:20px 0 0;color:", ";font-weight:600;cursor:pointer;:last-child{margin-bottom:40px;}"], Dashboard_global_styles/* colors.blue */.O9.blue);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/Downloads/Downloads.js


function Downloads_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Downloads_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Downloads_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Downloads_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Downloads_messages = (0,react_intl_lib/* defineMessages */.vU)({
  downloads: {
    id: 'dashboard.referrals.downloads',
    defaultMessage: 'Downloads to help you spread the word'
  },
  presentation: {
    id: 'dashboard.referrals.presentation',
    defaultMessage: 'Presentation slides'
  },
  headteacherLetter: {
    id: 'dashboard.referrals.headteacherLetter',
    defaultMessage: 'Email this letter to your school leader'
  },
  classReport: {
    id: 'dashboard.referrals.classReport',
    defaultMessage: 'Your class report'
  },
  shareVideo: {
    id: 'dashboard.referrals.shareVideo',
    defaultMessage: 'Share this 80-second video'
  }
});

var Downloads = function Downloads(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
    direction: props.direction,
    noBg: props.noBg,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Downloads_styles_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_styles_Info, {
        halfWidth: props.halfWidth,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Downloads_objectSpread({}, Downloads_messages.downloads))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_styles_Link, {
        href: "https://www.dropbox.com/s/ega69xivui4a11c/Night%20Zookeeper%20Teacher%20Presentation%20Slides.pdf?dl=0",
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Downloads_objectSpread({}, Downloads_messages.presentation))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_styles_Link, {
        href: "https://docs.google.com/document/d/1CXU9xYkCLwZZxkocOB3ds9Mshz9EhCrQs-OnWsJWxNo/edit",
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Downloads_objectSpread({}, Downloads_messages.headteacherLetter))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_styles_Link, {
        href: "https://vimeo.com/201653717",
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, Downloads_objectSpread({}, Downloads_messages.shareVideo))
      })]
    })
  });
};

/* harmony default export */ var Downloads_Downloads = (Downloads);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/SchoolAccount.styles.js

var FormContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolAccountstyles__FormContent",
  componentId: "sc-wlb97-0"
})(["max-width:950px;margin:15px auto 20px;padding-top:20px;display:flex;justify-content:center;flex-flow:row wrap;"]);
var SchoolAccount_styles_ButtonColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolAccountstyles__ButtonColumn",
  componentId: "sc-wlb97-1"
})(["display:flex;justify-content:flex-end;width:220px;margin-top:20px;margin-left:-195px;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/SchoolAccount.js











function SchoolAccount_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SchoolAccount_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SchoolAccount_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SchoolAccount_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SchoolAccount_createSuper(Derived) { var hasNativeReflectConstruct = SchoolAccount_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SchoolAccount_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





















var SchoolAccount = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(SchoolAccount, _Component);

  var _super = SchoolAccount_createSuper(SchoolAccount);

  function SchoolAccount(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, SchoolAccount);

    _this = _super.call(this, props);
    _this.state = {
      initialState: {},
      schoolDetails: props.schoolDetails || undefined,
      teachers: props.teachers || [],
      subscriptionDetails: props.subscriptionDetails || {},
      isEditMode: false,
      ambassadorEmailSent: false
    };
    _this.setSchoolState = _this.setSchoolState.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.setTeacherState = _this.setTeacherState.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onAddTeacher = _this.onAddTeacher.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onRemoveTeacher = _this.onRemoveTeacher.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onSubmit = _this.onSubmit.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.sendAmbassadorEmail = _this.sendAmbassadorEmail.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(SchoolAccount, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // prevent state refresh after failed mutation (due to wrong password)
      var currentModalId = this.props.modal.getCurrent().id;
      if (currentModalId === 'sensitiveInfoPopup' && this.state.schoolDetails) return;
      var schoolDetails = nextProps.schoolDetails,
          teachers = nextProps.teachers,
          subscriptionDetails = nextProps.subscriptionDetails;

      if (schoolDetails && teachers && subscriptionDetails) {
        this.setState({
          initialState: {
            schoolDetails: schoolDetails,
            teachers: teachers
          },
          schoolDetails: schoolDetails,
          teachers: teachers,
          subscriptionDetails: subscriptionDetails
        });
      }
    }
  }, {
    key: "subscriptionStatus",
    value: function subscriptionStatus() {
      var schoolDetails = this.state.schoolDetails;
      var _this$state$subscript = this.state.subscriptionDetails,
          subscription = _this$state$subscript.subscription,
          subscriptionEndDate = _this$state$subscript.subscriptionEndDate;
      var now = new Date().getTime();
      if (schoolDetails && !schoolDetails._id && subscriptionEndDate >= now) return 'trial';
      if (subscription && subscription.current_period_end * 1000 >= now) return 'stripe';
      if (subscriptionEndDate >= now) return 'custom';
      return 'expired';
    }
  }, {
    key: "setSchoolState",
    value: function setSchoolState(_ref) {
      var field = _ref.field,
          value = _ref.value;
      this.setState({
        schoolDetails: SchoolAccount_objectSpread(SchoolAccount_objectSpread({}, this.state.schoolDetails), {}, (0,defineProperty/* default */.Z)({}, field, value))
      });
    }
  }, {
    key: "setTeacherState",
    value: function setTeacherState(_ref2) {
      var _id = _ref2._id,
          field = _ref2.field,
          value = _ref2.value;
      var targetTeacher = this.state.teachers.find(function (teacher) {
        return teacher._id === _id;
      });
      this.setState({
        teachers: this.state.teachers.map(function (teacher) {
          return teacher._id === _id ? SchoolAccount_objectSpread(SchoolAccount_objectSpread({}, targetTeacher), {}, (0,defineProperty/* default */.Z)({}, field, value)) : teacher;
        })
      });
    }
  }, {
    key: "onAddTeacher",
    value: function onAddTeacher() {
      this.setState({
        teachers: [].concat((0,toConsumableArray/* default */.Z)(this.state.teachers), [{
          _id: Math.floor(Math.random() * 99999999),
          name: '',
          email: '',
          isNew: true
        }]),
        isEditMode: true
      });
    }
  }, {
    key: "onRemoveTeacher",
    value: function onRemoveTeacher(teacherId) {
      this.setState({
        teachers: this.state.teachers.reduce(function (result, teacher) {
          if (teacher._id !== teacherId) {
            result.push(teacher);
          } else if (!teacher.isNew) {
            result.push(SchoolAccount_objectSpread(SchoolAccount_objectSpread({}, teacher), {}, {
              stagedForDeletion: true
            }));
          }

          return result;
        }, [])
      });
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var changedSensitiveInfo;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                changedSensitiveInfo = this.state.teachers.some(function (teacher) {
                  return teacher.stagedForDeletion;
                });

                if (!changedSensitiveInfo) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", this.openSensitiveInfoModal());

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return this.updateSchoolDetails();

              case 6:
                _context.next = 8;
                return this.addTeachers();

              case 8:
                this.setState({
                  isEditMode: false
                });
                _context.next = 11;
                return delay(1000);

              case 11:
                _context.next = 13;
                return this.refetchData();

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);
                this.props.modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
                  isSettings: true
                }));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 15]]);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      if (event.which === 13
      /* Enter */
      ) {
        event.preventDefault();
      }
    }
  }, {
    key: "openSensitiveInfoModal",
    value: function openSensitiveInfoModal() {
      var _this2 = this;

      var modal = this.props.modal;
      modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(SensitiveInfoPopup, {
        onConfirm: function onConfirm(_ref3) {
          var password = _ref3.password;
          Promise.all(_this2.state.teachers.filter(function (teacher) {
            return teacher.stagedForDeletion;
          }).map( /*#__PURE__*/function () {
            var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(teacher) {
              return regenerator_default().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this2.props.deleteTeacher(teacher._id, _this2.state.schoolDetails._id, password);

                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x) {
              return _ref4.apply(this, arguments);
            };
          }())).then( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
            return regenerator_default().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this2.updateSchoolDetails();

                  case 2:
                    _context3.next = 4;
                    return _this2.addTeachers();

                  case 4:
                    modal.close();

                    _this2.setState({
                      isEditMode: false
                    });

                    _context3.next = 8;
                    return delay(1000);

                  case 8:
                    _context3.next = 10;
                    return _this2.refetchData();

                  case 10:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })))["catch"](function (e) {
            if (e.graphQLErrors && e.graphQLErrors[0].message === 'Access Denied') {
              return modal.updateProps({
                passwordError: true
              });
            }

            modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
              isSettings: true
            }));
          });
        },
        onCancel: function onCancel() {
          return modal.close();
        }
      }), 'sensitiveInfoPopup');
    }
  }, {
    key: "updateSchoolDetails",
    value: function () {
      var _updateSchoolDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.subscriptionStatus() === 'trial')) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return this.props.updateTrialSchoolDetails({
                  schoolName: this.state.schoolDetails.name
                });

              case 3:
                return _context4.abrupt("return");

              case 4:
                _context4.next = 6;
                return this.props.updateSchoolDetails({
                  _id: this.state.schoolDetails._id,
                  name: this.state.schoolDetails.name,
                  twitter: this.state.schoolDetails.twitter
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateSchoolDetails() {
        return _updateSchoolDetails.apply(this, arguments);
      }

      return updateSchoolDetails;
    }()
  }, {
    key: "addTeachers",
    value: function () {
      var _addTeachers = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        var _this3 = this;

        var addTeacherResults, notFoundErrors;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Promise.all(this.state.teachers.filter(function (teacher) {
                  return teacher.isNew;
                }).map( /*#__PURE__*/function () {
                  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(teacher) {
                    return regenerator_default().wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return _this3.props.addTeacher(teacher.email, _this3.state.schoolDetails._id);

                          case 3:
                            _context5.next = 10;
                            break;

                          case 5:
                            _context5.prev = 5;
                            _context5.t0 = _context5["catch"](0);

                            if (!(_context5.t0.graphQLErrors && _context5.t0.graphQLErrors[0].message === 'User Not Found')) {
                              _context5.next = 9;
                              break;
                            }

                            return _context5.abrupt("return", teacher.email);

                          case 9:
                            _this3.props.modal.forceOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(GeneralErrorPopup, {
                              isSettings: true
                            }));

                          case 10:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[0, 5]]);
                  }));

                  return function (_x2) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 2:
                addTeacherResults = _context6.sent;
                notFoundErrors = addTeacherResults.filter(function (result) {
                  return result;
                });

                if (notFoundErrors.length) {
                  this.props.modal.shyOpen( /*#__PURE__*/(0,jsx_runtime.jsx)(EmailErrorPopup, {
                    emails: notFoundErrors
                  }));
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addTeachers() {
        return _addTeachers.apply(this, arguments);
      }

      return addTeachers;
    }()
  }, {
    key: "refetchData",
    value: function () {
      var _refetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
        var _yield$this$props$cli, data, school, schoolDetails, teachers;

        return regenerator_default().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.props.client.query({
                  query: this.props.queries[0].query,
                  fetchPolicy: 'network-only'
                });

              case 2:
                _yield$this$props$cli = _context7.sent;
                data = _yield$this$props$cli.data;
                school = data.me.school || {};
                schoolDetails = {
                  _id: school._id,
                  name: school.name || data.me.schoolName,
                  twitter: school.twitter
                };
                teachers = school.teachers || [{
                  _id: data.me._id,
                  name: data.me.name,
                  email: data.me.email
                }];
                this.setState({
                  initialState: {
                    schoolDetails: schoolDetails,
                    teachers: teachers
                  },
                  schoolDetails: schoolDetails,
                  teachers: teachers
                });

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function refetchData() {
        return _refetchData.apply(this, arguments);
      }

      return refetchData;
    }()
  }, {
    key: "renderVoucherSection",
    value: function renderVoucherSection() {
      var teachers = this.state.initialState.teachers || [];

      if (teachers.length < 6) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VoucherOffer, {
            teachers: teachers,
            direction: "darkLeft",
            ambassador: this.props.ambassador,
            sendAmbassadorEmail: this.sendAmbassadorEmail,
            ambassadorEmailSent: this.state.ambassadorEmailSent
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Blurb_Blurb, {
            direction: "darkRight"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ambassador, {
            direction: "darkLeft",
            ambassador: this.props.ambassador,
            sendAmbassadorEmail: this.sendAmbassadorEmail,
            ambassadorEmailSent: this.state.ambassadorEmailSent
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_Downloads, {
            direction: "darkRight"
          })]
        });
      }

      return null;
    }
  }, {
    key: "sendAmbassadorEmail",
    value: function sendAmbassadorEmail() {
      var _this4 = this;

      this.props.ambassadorSignUp().then(function () {
        _this4.setState({
          ambassadorEmailSent: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$state = this.state,
          schoolDetails = _this$state.schoolDetails,
          teachers = _this$state.teachers,
          isEditMode = _this$state.isEditMode,
          subscriptionDetails = _this$state.subscriptionDetails;
      var _this$props = this.props,
          updateSchoolDetails = _this$props.updateSchoolDetails,
          loading = _this$props.loading,
          loggedInUser = _this$props.loggedInUser;

      if (loading) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* LoaderWrapper */.sb, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
            bgColor: "rgba(0,0,0,0)",
            itemColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            itemSize: "90"
          })
        });
      }

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(formsy_react_lib/* default */.ZP, {
        onKeyPress: this.onKeyPress,
        onValidSubmit: this.onSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormContent, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SchoolDetailsColumn, {
            subscriptionStatus: this.subscriptionStatus(),
            subscriptionEndDate: this.state.subscriptionDetails.subscriptionEndDate,
            isEditMode: isEditMode,
            info: schoolDetails,
            setSchoolState: this.setSchoolState
          }), teachers && [/*#__PURE__*/(0,jsx_runtime.jsx)(TeachersColumn, {
            isEditMode: isEditMode,
            loggedInUser: loggedInUser,
            subscriptionStatus: this.subscriptionStatus(),
            allowedTeachers: subscriptionDetails.licence,
            teachers: teachers,
            onAddTeacher: this.onAddTeacher,
            onRemoveTeacher: this.onRemoveTeacher,
            setTeacherState: this.setTeacherState
          }, 'teachers-column'), /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolAccount_styles_ButtonColumn, {
            children: this.state.isEditMode ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                bgColor: Dashboard_global_styles/* colors.lightBlue */.O9.lightBlue,
                color: "white",
                iconName: "cross",
                size: "regular",
                onClick: function onClick() {
                  return _this5.setState(SchoolAccount_objectSpread(SchoolAccount_objectSpread({}, _this5.state.initialState), {}, {
                    isEditMode: false
                  }));
                },
                children: "Undo"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "data-save": true,
                element: "button",
                type: "submit",
                bgColor: Dashboard_global_styles/* colors.grassGreen */.O9.grassGreen,
                color: "white",
                iconName: "check",
                size: "regular",
                children: "Save"
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
              bgColor: Dashboard_global_styles/* colors.orange */.O9.orange,
              iconName: "pencil",
              color: "white",
              size: "regular",
              onClick: function onClick() {
                return _this5.setState({
                  isEditMode: true
                });
              },
              children: "Edit"
            })
          }, 'button-column')]]
        }), this.renderVoucherSection()]
      });
    }
  }]);

  return SchoolAccount;
}(react.Component);

SchoolAccount.defaultProps = {
  modal: {
    open: function open() {},
    close: function close() {},
    closeAll: function closeAll() {}
  }
};
/* harmony default export */ var SchoolAccount_SchoolAccount = (SchoolAccount);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/SchoolAccount/SchoolAccountContainer.js









var SchoolAccountContainer_templateObject, SchoolAccountContainer_templateObject2, SchoolAccountContainer_templateObject3, SchoolAccountContainer_templateObject4, SchoolAccountContainer_templateObject5, SchoolAccountContainer_templateObject6;

function SchoolAccountContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SchoolAccountContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SchoolAccountContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SchoolAccountContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SchoolAccountContainer_createSuper(Derived) { var hasNativeReflectConstruct = SchoolAccountContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SchoolAccountContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var SchoolAccountContainer_queries = [{
  query: (0,lib/* default */.ZP)(SchoolAccountContainer_templateObject || (SchoolAccountContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      {\n        me {\n          _id\n          name\n          email\n          schoolName\n          subscription {\n            id\n            current_period_end\n          }\n          subscriptionEndDate\n          school {\n            _id\n            name\n            twitter\n            teachers {\n              _id\n              name\n              email\n            }\n            licence\n          }\n          ambassador\n        }\n      }\n    "]))),
  props: function props(_ref) {
    var data = _ref.data;

    if (data.loading || data.error) {
      return {
        loading: data.loading,
        error: data.error
      };
    }

    var school = data.me.school || {};
    return {
      loggedInUser: data.me._id,
      schoolDetails: {
        _id: school._id,
        name: school.name || data.me.schoolName,
        twitter: school.twitter
      },
      teachers: school.teachers || [{
        _id: data.me._id,
        name: data.me.name,
        email: data.me.email
      }],
      subscriptionDetails: {
        subscription: data.me.subscription,
        subscriptionEndDate: data.me.subscriptionEndDate,
        licence: school.licence
      },
      ambassador: data.me.ambassador,
      isSubscribed: data.me.isSubscribe
    };
  },
  options: {
    fetchPolicy: 'network-only'
  }
}];
var SchoolAccountContainer_mutations = [{
  mutation: (0,lib/* default */.ZP)(SchoolAccountContainer_templateObject2 || (SchoolAccountContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation updateSchool($school: UpdateSchoolInput) {\n        updateSchool(school: $school) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref2) {
    var mutate = _ref2.mutate;
    return {
      updateSchoolDetails: function () {
        var _updateSchoolDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(details) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return mutate({
                    variables: {
                      school: details
                    }
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function updateSchoolDetails(_x) {
          return _updateSchoolDetails.apply(this, arguments);
        }

        return updateSchoolDetails;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(SchoolAccountContainer_templateObject3 || (SchoolAccountContainer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation updateMe($user: UserInput) {\n        updateMe(user: $user) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref3) {
    var mutate = _ref3.mutate;
    return {
      updateTrialSchoolDetails: function () {
        var _updateTrialSchoolDetails = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(details) {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return mutate({
                    variables: {
                      user: details
                    }
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function updateTrialSchoolDetails(_x2) {
          return _updateTrialSchoolDetails.apply(this, arguments);
        }

        return updateTrialSchoolDetails;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(SchoolAccountContainer_templateObject4 || (SchoolAccountContainer_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation deleteTeacherFromSchool($teacherId: String!, $schoolId: String!, $userPassword: String!) {\n        deleteTeacherFromSchool(teacherId: $teacherId, schoolId: $schoolId, userPassword: $userPassword) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref4) {
    var mutate = _ref4.mutate;
    return {
      deleteTeacher: function () {
        var _deleteTeacher = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(teacherId, schoolId, userPassword) {
          return regenerator_default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return mutate({
                    variables: {
                      teacherId: teacherId,
                      schoolId: schoolId,
                      userPassword: userPassword
                    }
                  });

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function deleteTeacher(_x3, _x4, _x5) {
          return _deleteTeacher.apply(this, arguments);
        }

        return deleteTeacher;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(SchoolAccountContainer_templateObject5 || (SchoolAccountContainer_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation addTeacherToSchool($email: String!, $schoolId: String!) {\n        addTeacherToSchool(email: $email, schoolId: $schoolId) {\n          _id\n        }\n      }\n    "]))),
  props: function props(_ref5) {
    var mutate = _ref5.mutate;
    return {
      addTeacher: function () {
        var _addTeacher = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(email, schoolId) {
          return regenerator_default().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return mutate({
                    variables: {
                      email: email,
                      schoolId: schoolId
                    }
                  });

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function addTeacher(_x6, _x7) {
          return _addTeacher.apply(this, arguments);
        }

        return addTeacher;
      }()
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(SchoolAccountContainer_templateObject6 || (SchoolAccountContainer_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation ambassadorMutation {\n        ambassador\n      }\n    "]))),
  props: function props(_ref6) {
    var mutate = _ref6.mutate;
    return {
      ambassadorSignUp: mutate
    };
  }
}];

var SchoolAccountContainer = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SchoolAccountContainer, _React$Component);

  var _super = SchoolAccountContainer_createSuper(SchoolAccountContainer);

  function SchoolAccountContainer() {
    (0,classCallCheck/* default */.Z)(this, SchoolAccountContainer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(SchoolAccountContainer, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
        children: function children(modal) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolAccount_SchoolAccount, SchoolAccountContainer_objectSpread(SchoolAccountContainer_objectSpread({}, _this.props), {}, {
            modal: modal
          }));
        }
      });
    }
  }]);

  return SchoolAccountContainer;
}(react.Component);

/* harmony default export */ var SchoolAccount_SchoolAccountContainer = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DataContainer/* default */.Z, {
    queries: SchoolAccountContainer_queries,
    mutations: SchoolAccountContainer_mutations,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolAccountContainer, SchoolAccountContainer_objectSpread({}, props))
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/DiscountStatusBanner/DiscountStatusBanner.styles.js



var DiscountStatusBanner_styles_Text = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "DiscountStatusBannerstyles__Text",
  componentId: "sc-xhdmz4-0"
})(["display:flex;font-size:24px;color:", ";margin:0 0 30px;justify-content:center;@media (max-width:", "px){font-size:22px;};"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple, DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
var BlueText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DiscountStatusBannerstyles__BlueText",
  componentId: "sc-xhdmz4-1"
})(["color:", ";"], Dashboard_global_styles/* colors.blue */.O9.blue);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/DiscountStatusBanner/DiscountStatusBanner.js







function DiscountStatusBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DiscountStatusBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DiscountStatusBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DiscountStatusBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function DiscountStatusBanner_createSuper(Derived) { var hasNativeReflectConstruct = DiscountStatusBanner_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function DiscountStatusBanner_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var DiscountStatusBanner_messages = (0,react_intl_lib/* defineMessages */.vU)({
  yourDiscount: {
    id: 'dashboard.referrals.yourDiscount',
    defaultMessage: 'Your referral discount'
  },
  monthlyDiscount: {
    id: 'dashboard.referrals.monthlyDiscount',
    defaultMessage: 'off your monthly subscription'
  },
  yearlyDiscount: {
    id: 'dashboard.referrals.yearlyDiscount',
    defaultMessage: 'off next years subscription'
  },
  trialDiscount: {
    id: 'dashboard.referrals.trialDiscount',
    defaultMessage: 'off your individual subscription'
  },
  smallPrintText: {
    id: 'dashboard.referrals.smallPrintText',
    defaultMessage: 'Your status will update above as soon as your colleagues and friends register for a free trial on nightzookeeper.com.'
  },
  congratulations: {
    id: 'dashboard.referrals.congratulations',
    defaultMessage: 'Congratulations!'
  },
  freeMonthlyAccess: {
    id: 'dashboard.referrals.freeMonthlyAccess',
    defaultMessage: 'You have referred 10 friends. Your account will be free for six months.'
  },
  freeYearAccess: {
    id: 'dashboard.referrals.freeYearAccess',
    defaultMessage: 'Your subscription next year is free.'
  },
  sixMonthAccess: {
    id: 'dashboard.referrals.sixMonthAccess',
    defaultMessage: 'The above discount will be applied to your account for 6 months. Your status will update every time you refer a new friend.'
  }
});

var DiscountStatusBanner = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(DiscountStatusBanner, _Component);

  var _super = DiscountStatusBanner_createSuper(DiscountStatusBanner);

  function DiscountStatusBanner() {
    (0,classCallCheck/* default */.Z)(this, DiscountStatusBanner);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DiscountStatusBanner, [{
    key: "getCongratulationsMessage",
    value: function getCongratulationsMessage() {
      return this.props.subscriptionType === 'monthly' || !this.props.isSubscribed ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.freeMonthlyAccess)) : /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.freeYearAccess));
    }
  }, {
    key: "getSmallPrintMessage",
    value: function getSmallPrintMessage() {
      return this.props.subscriptionType === 'monthly' || !this.props.isSubscribed ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.sixMonthAccess)) : /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.smallPrintText));
    }
  }, {
    key: "getSubscriptionTypeMessage",
    value: function getSubscriptionTypeMessage() {
      switch (this.props.subscriptionType) {
        case 'monthly':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.monthlyDiscount));

        case 'yearly':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.yearlyDiscount));

        default:
          return /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.trialDiscount));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          subscriptionType = _this$props.subscriptionType,
          discountPercentage = _this$props.discountPercentage;
      var displayDiscount = discountPercentage && "".concat(discountPercentage, "%") || '0%';
      var displayAsterisk = discountPercentage !== 100 && '*';
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DiscountStatusBanner_styles_Text, {
          type: "main",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.yourDiscount)), displayAsterisk, "\xA0=\xA0", discountPercentage === 100 ? /*#__PURE__*/(0,jsx_runtime.jsx)(BlueText, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, DiscountStatusBanner_objectSpread({}, DiscountStatusBanner_messages.congratulations))
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BlueText, {
              children: displayDiscount
            }), "\xA0", this.getSubscriptionTypeMessage()]
          })]
        }), discountPercentage === 100 ? /*#__PURE__*/(0,jsx_runtime.jsx)(SmallPrint, {
          type: "regularYellow",
          children: this.getCongratulationsMessage()
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(SmallPrint, {
          type: "regularBlue",
          children: ["*", this.getSmallPrintMessage()]
        })]
      });
    }
  }]);

  return DiscountStatusBanner;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/ReferralContent/ReferralContent.js








function ReferralContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReferralContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReferralContent_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReferralContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function ReferralContent_createSuper(Derived) { var hasNativeReflectConstruct = ReferralContent_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ReferralContent_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }














var ReferralContent_messages = (0,react_intl_lib/* defineMessages */.vU)({
  teacherTitleMessage: {
    id: 'dashboard.referrals.teacherTitle',
    defaultMessage: 'Earn discounts for referring teachers'
  },
  teacherSubTitleMessage: {
    id: 'dashboard.referrals.teacherSubTitle',
    defaultMessage: 'Get 10% off for every friend or colleague that signs up'
  },
  parentTitleMessage: {
    id: 'dashboard.referrals.parentTitle',
    defaultMessage: 'Earn discounts for referring friends'
  },
  parentSubTitleMessage: {
    id: 'dashboard.referrals.parentSubTitle',
    defaultMessage: 'Get 10% off for every friend that signs up'
  },
  schoolTitleMessage: {
    id: 'dashboard.referrals.schoolTitle',
    defaultMessage: 'Share Night Zookeeper with teachers in other schools'
  },
  schoolSubTitleMessage: {
    id: 'dashboard.referrals.schoolSubTitle',
    defaultMessage: 'Give your friends 10% off Night Zookeeper'
  },
  shareLink: {
    id: 'dashboard.referrals.shareLink',
    defaultMessage: 'Copy and share your link'
  },
  smallinfoText: {
    id: 'dashboard.referrals.smallInfoText',
    defaultMessage: 'Your friends will receive 10% off their Night Zookeeper subscription.'
  },
  submitEmails: {
    id: 'dashboard.referrals.submitEmails',
    defaultMessage: 'Or submit their emails below'
  },
  userExists: {
    id: 'dashboard.referrals.userExists',
    defaultMessage: 'One or more of these emails are already signed up! Why not refer someone else?'
  }
});

var ReferralContent = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(ReferralContent, _Component);

  var _super = ReferralContent_createSuper(ReferralContent);

  function ReferralContent(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ReferralContent);

    _this = _super.call(this, props);
    _this.state = {
      emailExists: false
    };
    _this.handleSubmit = _this.handleSubmit.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(ReferralContent, [{
    key: "handleSubmit",
    value: function handleSubmit(emailString) {
      var _this2 = this;

      this.setState({
        emailExists: false
      });
      var emailArray = emailString.email ? emailString.email.replace(/\s/g, '').split(',') : [];
      emailArray.map(function (email) {
        _this2.props.freeEmail(_this2.props.client, email).then(function (result) {
          if (!result) _this2.setState({
            emailExists: true
          });
        });
      });
      this.props.sendReferral(emailArray);
      this.refs.form.reset();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          parent = _this$props.parent,
          subscriptionType = _this$props.subscriptionType,
          referralId = _this$props.referralId,
          sendReferral = _this$props.sendReferral,
          discountPercentage = _this$props.discountPercentage,
          isSubscribed = _this$props.isSubscribed,
          teachers = _this$props.teachers,
          screenWidth = _this$props.screenWidth;
      var textImageStyle = !isSubscribed || teachers.length < 2 ? '60px' : '0';
      return /*#__PURE__*/(0,jsx_runtime.jsx)(formsy_react_lib/* default */.ZP, {
        onValidSubmit: this.handleSubmit,
        ref: "form",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
          direction: "darkRight",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ReferralContent_styles_Wrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReferralContent_styles_Title, {
              type: "main",
              children: parent ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.parentTitleMessage)) : !isSubscribed || teachers.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.teacherTitleMessage)) : /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.schoolTitleMessage))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextImageWrapper, {
              textImageStyle: textImageStyle,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(InfoSection, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReferralContent_styles_Title, {
                  type: "sub",
                  children: parent ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.parentSubTitleMessage)) : !isSubscribed || teachers.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.teacherSubTitleMessage)) : /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.schoolSubTitleMessage))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Info, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.shareLink))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReferralContent_styles_Link, {
                  children: "www.nightzookeeper.com/edu/dashboard/register?referral=".concat(referralId)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Info, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.submitEmails))
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                  name: "email",
                  width: "100%",
                  value: "",
                  placeholder: "Enter email addresses separated by commas",
                  textSize: dimensions/* fontSize.milli */.JB.milli,
                  validations: {
                    matchRegexp: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(,[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/
                  },
                  validationErrors: {
                    matchRegexp: 'Please enter valid email addresses separated by commas'
                  },
                  required: true
                }), this.state.emailExists ? /*#__PURE__*/(0,jsx_runtime.jsx)(SmallPrint, {
                  type: "smallRed",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.userExists))
                }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonTextContainer, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallPrint, {
                    type: "smallBlue",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ReferralContent_objectSpread({}, ReferralContent_messages.smallinfoText))
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    element: "button",
                    bgColor: Dashboard_global_styles/* colors.blue */.O9.blue,
                    color: Dashboard_global_styles/* colors.white */.O9.white,
                    size: "small",
                    children: "Submit"
                  })]
                })]
              })]
            }), screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D ? (!isSubscribed || teachers.length < 2) && /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountStatusBanner, {
              isSubscribed: isSubscribed,
              subscriptionType: subscriptionType,
              discountPercentage: discountPercentage
            }) : null]
          })
        })
      });
    }
  }]);

  return ReferralContent;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/ThanksFooter/ThanksFooter.styles.js



var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThanksFooterstyles__ContentWrapper",
  componentId: "sc-1qtak1z-0"
})(["display:flex;max-width:830px;margin:auto;padding:20px 0;@media (max-width:", "px){padding:20px 15px;};"], DashboardSettings_styles/* ipadPortraitMaxWidth */.xu);
var MainTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThanksFooterstyles__MainTextWrapper",
  componentId: "sc-1qtak1z-1"
})(["width:400px;"]);
var ThanksFooter_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "ThanksFooterstyles__Title",
  componentId: "sc-1qtak1z-2"
})(["display:flex;font-size:24px;color:", ";margin:0 0 30px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var ThanksFooter_styles_InfoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThanksFooterstyles__InfoSection",
  componentId: "sc-1qtak1z-3"
})(["display:flex;flex-direction:column;margin-left:60px;"]);
var ThanksFooter_styles_Info = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ThanksFooterstyles__Info",
  componentId: "sc-1qtak1z-4"
})(["margin:0 0 20px;color:", ";"], Dashboard_global_styles/* colors.pink */.O9.pink);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/components/ThanksFooter/ThanksFooter.js


function ThanksFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ThanksFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ThanksFooter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ThanksFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ThanksFooter_messages = (0,react_intl_lib/* defineMessages */.vU)({
  thanksTitle: {
    id: 'dashboard.referrals.thanksTitle',
    defaultMessage: 'Thanks for helping to spread the word about Night Zookeeper!'
  },
  thanksText: {
    id: 'dashboard.referrals.thanksText',
    defaultMessage: 'Our aim is to encourage as many children around the world to fall in love with writing. Every time you share, more children have the opportunity to fall in love with writing.'
  }
});

var ThanksFooter = function ThanksFooter() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* GradientWrapper */.lM, {
    direction: "darkLeft",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MainTextWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ThanksFooter_styles_Title, {
          type: "main",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ThanksFooter_objectSpread({}, ThanksFooter_messages.thanksTitle))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThanksFooter_styles_Info, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, ThanksFooter_objectSpread({}, ThanksFooter_messages.thanksText))
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThanksFooter_styles_InfoSection, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_Downloads, {
          halfWidth: true,
          noBg: true
        })
      })]
    })
  });
};

/* harmony default export */ var ThanksFooter_ThanksFooter = (ThanksFooter);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/Referrals.js








function Referrals_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Referrals_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Referrals_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Referrals_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Referrals_createSuper(Derived) { var hasNativeReflectConstruct = Referrals_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Referrals_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var Referrals = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Referrals, _Component);

  var _super = Referrals_createSuper(Referrals);

  function Referrals(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Referrals);

    _this = _super.call(this, props);
    _this.state = {
      ambassadorEmailSent: false
    };
    _this.sendAmbassadorEmail = _this.sendAmbassadorEmail.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(Referrals, [{
    key: "sendAmbassadorEmail",
    value: function sendAmbassadorEmail() {
      var _this2 = this;

      this.props.ambassadorSignUp().then(function () {
        _this2.setState({
          ambassadorEmailSent: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$teachers = _this$props.teachers,
          teachers = _this$props$teachers === void 0 ? [] : _this$props$teachers,
          isSubscribed = _this$props.isSubscribed,
          ambassadorSignUp = _this$props.ambassadorSignUp,
          ambassador = _this$props.ambassador,
          loading = _this$props.loading,
          screenWidth = _this$props.screenWidth;

      if (loading) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* LoaderWrapper */.sb, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
            bgColor: "rgba(0,0,0,0)",
            itemColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            itemSize: "90"
          })
        });
      }

      var hasTwoToFiveTeachers = isSubscribed && teachers.length > 1 && teachers.length < 6;
      var hasMoreThanFiveTeachers = isSubscribed && teachers.length >= 6;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [hasTwoToFiveTeachers ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VoucherOffer, {
            direction: "darkRight",
            sendAmbassadorEmail: this.sendAmbassadorEmail,
            ambassadorEmailSent: this.state.ambassadorEmailSent,
            teachers: teachers,
            ambassador: ambassador
          }), screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blurb_Blurb, {
              direction: "darkLeft"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ambassador, {
              direction: "darkRight",
              sendAmbassadorEmail: this.sendAmbassadorEmail,
              ambassadorEmailSent: this.state.ambassadorEmailSent,
              ambassador: ambassador,
              teachers: teachers
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Downloads_Downloads, {
              direction: "darkLeft"
            })]
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ReferralContent, Referrals_objectSpread({}, this.props)), hasMoreThanFiveTeachers && screenWidth > DashboardSettings_styles/* phoneMaxWidth */.D && /*#__PURE__*/(0,jsx_runtime.jsx)(ThanksFooter_ThanksFooter, {})]
      });
    }
  }]);

  return Referrals;
}(react.Component);


// EXTERNAL MODULE: ./components/Loadable/Loadable.js
var Loadable = __webpack_require__(51999);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Referrals/ReferralsContainer.js




var ReferralsContainer_templateObject, ReferralsContainer_templateObject2, ReferralsContainer_templateObject3, ReferralsContainer_templateObject4;

function ReferralsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReferralsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReferralsContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReferralsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ReferralsContainer_queries = [{
  query: (0,lib/* default */.ZP)(ReferralsContainer_templateObject || (ReferralsContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      {\n        me {\n          _id\n          parent\n          type\n          ambassador\n          school {\n            _id\n            teachers {\n              _id\n            }\n          }\n          subscription {\n            id\n            plan {\n              \n              interval\n            }\n            start\n            discount {\n              coupon {\n                id\n                percent_off\n              }\n            }\n          }\n          referrer {\n            _id\n          }\n          referral {\n            _id\n            users {\n              _id\n            }\n          }\n          isSubscribe\n        }\n      }\n    "]))),
  props: function props(_ref) {
    var data = _ref.data;

    if (data.loading || data.error) {
      return {
        loading: data.loading,
        error: data.error
      };
    }

    var currentSubscription = data.me.subscription || false;
    return {
      loading: data.loading,
      error: data.error,
      parent: data.me.parent,
      subscriptionType: currentSubscription.plan && currentSubscription.plan.interval || '',
      startDate: currentSubscription.start || 0,
      referralId: data.me.referral._id,
      teachers: data.me.school ? data.me.school.teachers : [],
      ambassador: data.me.ambassador || false,
      discountPercentage: currentSubscription.discount ? currentSubscription.discount.coupon ? currentSubscription.discount.coupon.percent_off : null : null,
      isSubscribed: data.me.isSubscribe
    };
  },
  options: {
    fetchPolicy: 'network-only'
  }
}];
var ReferralsContainer_mutations = [{
  mutation: (0,lib/* default */.ZP)(ReferralsContainer_templateObject2 || (ReferralsContainer_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation referMutation($emails: [String]!) {\n        refer(emails: $emails)\n      }\n    "]))),
  props: function props(_ref2) {
    var mutate = _ref2.mutate;
    return {
      sendReferral: function sendReferral(emails) {
        return mutate({
          variables: {
            emails: emails
          }
        });
      }
    };
  }
}, {
  mutation: (0,lib/* default */.ZP)(ReferralsContainer_templateObject3 || (ReferralsContainer_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      mutation ambassadorMutation {\n        ambassador\n      }\n    "]))),
  props: function props(_ref3) {
    var mutate = _ref3.mutate;
    return {
      ambassadorSignUp: mutate
    };
  }
}];

var freeEmail = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, email) {
    var _yield$client$query, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.query({
              query: (0,lib/* default */.ZP)(ReferralsContainer_templateObject4 || (ReferralsContainer_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      query freeEmail($email: String!) {\n        freeEmail(email: $email)\n      }\n    "]))),
              variables: {
                email: email
              },
              fetchPolicy: 'network-only'
            });

          case 2:
            _yield$client$query = _context.sent;
            data = _yield$client$query.data;
            return _context.abrupt("return", data.freeEmail);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function freeEmail(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

var ReferralsContainer = function ReferralsContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MediaQuery/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Referrals, ReferralsContainer_objectSpread(ReferralsContainer_objectSpread({}, props), {}, {
      freeEmail: freeEmail
    }))
  });
};

/* harmony default export */ var Referrals_ReferralsContainer = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DataContainer/* default */.Z, {
    queries: ReferralsContainer_queries,
    mutations: ReferralsContainer_mutations,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReferralsContainer, ReferralsContainer_objectSpread({}, props))
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/TopBanner.js





var TopBanner_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopBanner__Wrapper",
  componentId: "sc-bskuem-0"
})(["", ";p{text-align:center;}"], Dashboard_global_styles/* fonts.libreBaskerville */.Rq.libreBaskerville);
var TopBanner_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopBanner__Content",
  componentId: "sc-bskuem-1"
})(["padding:30px 50px;margin:0 auto;height:334px;width:860px;background-position:center;background-repeat:no-repeat;background-size:contain;background-image:url(\"", "/pages/Dashboard/images/payment-banner-01.jpg\");"], "/edu/assets");
var TopBanner_Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopBanner__Text",
  componentId: "sc-bskuem-2"
})(["width:300px;font-size:40px;"]);
var UpgradeLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopBanner__UpgradeLabel",
  componentId: "sc-bskuem-3"
})(["margin-top:35px;color:", ";font-size:25px;"], Dashboard_global_styles/* colors.pink */.O9.pink);

var TopBanner = function TopBanner(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TopBanner_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TopBanner_Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TopBanner_Text, {
        children: ["Engage your ", props.parent ? 'children' : 'students', " and inspire a love of writing"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeLabel, {
        children: "Upgrade now"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Please email ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "mailto:teachers@nightzookeeper.com",
        children: "teachers@nightzookeeper.com"
      }), " to request a quote."]
    })]
  });
};

TopBanner.defaultProps = {
  parent: false
};
/* harmony default export */ var components_TopBanner = (TopBanner);
// EXTERNAL MODULE: ./components/UI/Currency.js
var Currency = __webpack_require__(53576);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SelectPaymentPlan.js








var SelectPaymentPlan_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlan__Wrapper",
  componentId: "sc-1tg3h8m-0"
})(["background-color:", ";display:flex;justify-content:center;flex-wrap:wrap;", ";padding:20px 0;"], Dashboard_global_styles/* colors.light2 */.O9.light2, Dashboard_global_styles/* fonts.libreBaskerville */.Rq.libreBaskerville);
var SelectPaymentPlan_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlan__Title",
  componentId: "sc-1tg3h8m-1"
})(["color:", ";width:100%;text-align:center;font-size:28px;margin:20px 0px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var Options = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlan__Options",
  componentId: "sc-1tg3h8m-2"
})(["display:flex;padding-left:40px;"]);
var Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlan__Option",
  componentId: "sc-1tg3h8m-3"
})(["position:relative;background-color:white;padding:30px 70px 50px 70px;border-radius:12px;margin-right:40px;"]);
var Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlan__Price",
  componentId: "sc-1tg3h8m-4"
})(["font-size:45px;color:", ";width:100%;text-align:center;margin-bottom:20px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var SaveMoneyChip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlan__SaveMoneyChip",
  componentId: "sc-1tg3h8m-5"
})(["position:absolute;top:0;right:-20px;height:90px;width:90px;border-radius:50%;background-color:", ";color:", ";> div{width:100%;text-align:center;}& div:nth-child(1){margin-top:20px;font-size:18px;}& div:nth-child(2){font-weight:bold;font-size:24px;}"], Dashboard_global_styles/* colors.yellow */.O9.yellow, Dashboard_global_styles/* colors.pink */.O9.pink);
/* harmony default export */ var SelectPaymentPlan = (function (props) {
  var plans = props.plans;
  var savedAmount = plans.filter(function (p) {
    return p.interval === 'month';
  })[0].amount * 12 - plans.filter(function (p) {
    return p.interval === 'year';
  })[0].amount;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectPaymentPlan_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentPlan_Title, {
      children: "Select your payment plan"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Options, {
      children: (0,toConsumableArray/* default */.Z)(plans).sort(function (a, b) {
        return a.amount - b.amount;
      }).map(function (p, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Option, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Price, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
              amount: p.amount / 100,
              currency: p.currency
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return props.onSubmit(p);
            },
            children: p.interval === 'month' ? 'Monthly' : 'Yearly'
          }), p.interval === 'year' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(SaveMoneyChip, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "Save"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
                amount: savedAmount / 100,
                currency: p.currency
              })
            })]
          }) : null]
        }, i);
      })
    })]
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/EngageSection.js





var EngageSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__Wrapper",
  componentId: "sc-oi066y-0"
})(["", ";padding:30px 0 0px 0;"], Dashboard_global_styles/* fonts.libreBaskerville */.Rq.libreBaskerville);
var FirstSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__FirstSection",
  componentId: "sc-oi066y-1"
})([""]);
var SecondSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__SecondSection",
  componentId: "sc-oi066y-2"
})(["background-color:", ";"], Dashboard_global_styles/* colors.light2 */.O9.light2);
var EngageSection_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__Title",
  componentId: "sc-oi066y-3"
})(["color:", ";font-size:39px;margin:30px 0px;text-align:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var Illustrations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__Illustrations",
  componentId: "sc-oi066y-4"
})(["max-width:860px;margin:15px auto;width:100%;display:flex;flex-wrap:wrap;justify-content:space-around;"]);
var Illustration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__Illustration",
  componentId: "sc-oi066y-5"
})(["width:340px;text-align:center;margin-top:20px;"]);
var EngageSection_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "EngageSection__Image",
  componentId: "sc-oi066y-6"
})(["width:90%;"]);
var IllustrationTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__IllustrationTitle",
  componentId: "sc-oi066y-7"
})(["color:", ";font-size:20px;margin-top:10px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var EngagementLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EngageSection__EngagementLabel",
  componentId: "sc-oi066y-8"
})(["max-width:860px;margin:40px auto 0 auto;text-align:center;color:", ";font-size:28px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var FIRST_SECTION = [{
  image: 'payment-images-01.jpg',
  text: 'Thousands of interactive lessons'
}, {
  image: 'payment-images-02.jpg',
  text: 'Regular Global Competitions'
}];
var OTHER_SECTION = [{
  image: 'payment-images-03.jpg',
  text: 'Home and individual blogs'
}, {
  image: 'payment-images-04.jpg',
  text: 'Shareable progress report'
}];

var EngageSection = function EngageSection(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(EngageSection_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FirstSection, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EngageSection_Title, {
        children: "Subscribing gives you access to"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Illustrations, {
        children: FIRST_SECTION.map(function (s, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Illustration, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EngageSection_Image, {
              src: "".concat("/edu/assets", "/pages/Dashboard/images/").concat(s.image)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(IllustrationTitle, {
              children: s.text
            })]
          }, "first-".concat(i));
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecondSection, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Illustrations, {
        children: OTHER_SECTION.map(function (s, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Illustration, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EngageSection_Image, {
              src: "".concat("/edu/assets", "/pages/Dashboard/images/").concat(s.image)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(IllustrationTitle, {
              children: s.text
            })]
          }, "second-".concat(i));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EngagementLabel, {
        children: "Join thousands of parents and teachers around the world dedicated to developing a love of writing!"
      })]
    })]
  });
};

EngageSection.defaultProps = {
  parent: false
};
/* harmony default export */ var components_EngageSection = (EngageSection);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SelectPlan.js






var SelectPlan_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPlan__Wrapper",
  componentId: "sc-1hpgf1e-0"
})(["background-color:", ";display:flex;justify-content:center;flex-wrap:wrap;", ";padding:20px 0;"], Dashboard_global_styles/* colors.light2 */.O9.light2, Dashboard_global_styles/* fonts.libreBaskerville */.Rq.libreBaskerville);
var SelectPlan_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPlan__Title",
  componentId: "sc-1hpgf1e-1"
})(["color:", ";width:100%;text-align:center;font-size:28px;margin:20px 0px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var SelectPlan_Options = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPlan__Options",
  componentId: "sc-1hpgf1e-2"
})(["max-width:800px;margin:0 auto;display:flex;padding-left:30px;justify-content:center;flex-wrap:wrap;> div{margin-right:30px;margin-bottom:30px;}"]);
/* harmony default export */ var SelectPlan = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectPlan_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectPlan_Title, {
      children: props.isSubscribed ? 'Upgrade your subscription' : 'Select your plan'
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectPlan_Options, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "large",
        onClick: function onClick() {
          return props.onSelectOneClass();
        },
        children: "One class"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "large",
        onClick: function onClick() {
          return props.onSelectMultipleClasses();
        },
        children: "Multiple classes"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "large",
        onClick: function onClick() {
          return props.onSelectWholeSchool();
        },
        children: "Whole school"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "large",
        onClick: function onClick() {
          return props.onSelectMultipleSchools();
        },
        children: "Multiple schools"
      })]
    })]
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/Selector.js




var Selector_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Selector__Wrapper",
  componentId: "sc-1erjnzo-0"
})(["margin:0 auto;width:300px;max-height:150px;overflow:auto;background-color:white;border-radius:8px;& > div{border-bottom:1px solid #ebebeb;}& > :last-child{border-bottom:none;}"]);
var Selector_Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Selector__Option",
  componentId: "sc-1erjnzo-1"
})(["display:flex;justify-content:space-between;padding:10px 16px;cursor:pointer;"]);
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Selector__Label",
  componentId: "sc-1erjnzo-2"
})([""]);
var Selector_Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Selector__Info",
  componentId: "sc-1erjnzo-3"
})([""]);
/* harmony default export */ var Selector = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Selector_Wrapper, {
    children: props.options.map(function (o, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Selector_Option, {
        onClick: function onClick() {
          return props.onSelect(o);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: o.label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Selector_Info, {
          children: o.info
        })]
      }, i);
    })
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/ClassSizePopup.js






function ClassSizePopup_createSuper(Derived) { var hasNativeReflectConstruct = ClassSizePopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ClassSizePopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var ClassSizePopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassSizePopup__Title",
  componentId: "sc-8pcm8g-0"
})(["color:", ";font-size:28px;text-align:center;margin-bottom:15px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var SelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassSizePopup__SelectButton",
  componentId: "sc-8pcm8g-1"
})(["margin-top:15px;"]);
var SizeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassSizePopup__SizeButton",
  componentId: "sc-8pcm8g-2"
})(["margin-top:15px;"]);
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassSizePopup__ConfirmButton",
  componentId: "sc-8pcm8g-3"
})(["margin-top:60px;"]);
var ClassSizePopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassSizePopup__Content",
  componentId: "sc-8pcm8g-4"
})(["text-align:center;"]);
var SelectedChoice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassSizePopup__SelectedChoice",
  componentId: "sc-8pcm8g-5"
})(["font-size:28px;color:", ";margin:10px 0 25px 0;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var PLANS = [{
  nbStudents: '1-14',
  title: 'Small'
}, {
  nbStudents: '15-35',
  title: 'Medium'
}, {
  nbStudents: '35+',
  title: 'Large'
}];

var ClassSizePopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ClassSizePopup, _React$Component);

  var _super = ClassSizePopup_createSuper(ClassSizePopup);

  function ClassSizePopup(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ClassSizePopup);

    _this = _super.call(this, props);
    _this.state = {
      selecting: false,
      selected: false
    };
    var products = props.products.slice().sort(function (x, y) {
      return x.metadata.maxUsers - y.metadata.maxUsers;
    });
    _this.products = products.map(function (p, i) {
      var nbStudents;

      if (i === 0) {
        nbStudents = "1-".concat(p.metadata.maxUsers);
      } else {
        nbStudents = "".concat(products[i - 1].metadata.maxUsers + 1, "-").concat(p.metadata.maxUsers);
      }

      return {
        product: p,
        nbStudents: nbStudents,
        title: p.name
      };
    });
    return _this;
  }

  (0,createClass/* default */.Z)(ClassSizePopup, [{
    key: "selectClassSize",
    value: function selectClassSize(o) {
      this.setState({
        selected: true,
        selecting: false,
        choice: o
      });
    }
  }, {
    key: "onSelectAction",
    value: function onSelectAction() {
      this.setState({
        selecting: true
      });
    }
  }, {
    key: "renderNotSelectedView",
    value: function renderNotSelectedView() {
      return [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SelectButton, {
          block: false,
          onClick: this.onSelectAction.bind(this),
          children: "Select"
        })
      }, '1'), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmButton, {
          disabled: true,
          children: "Confirm"
        })
      }, '2')];
    }
  }, {
    key: "renderSelectingContent",
    value: function renderSelectingContent() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Selector, {
        options: this.products.map(function (p) {
          return {
            product: p.product,
            label: "".concat(p.nbStudents, " students"),
            info: p.title
          };
        }),
        onSelect: this.selectClassSize.bind(this)
      });
    }
  }, {
    key: "renderSelectedContent",
    value: function renderSelectedContent() {
      var _this2 = this;

      var choice = this.state.choice;
      return [/*#__PURE__*/(0,jsx_runtime.jsx)(SizeButton, {
        onClick: this.onSelectAction.bind(this),
        children: choice.info
      }, '1'), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectedChoice, {
        children: choice.label
      }, '2'), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        bgColor: Dashboard_global_styles/* colors.success */.O9.success,
        onClick: function onClick() {
          return _this2.props.onSubmit(_this2.state.choice.product);
        },
        children: "Confirm"
      }, '3')];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ClassSizePopup_Title, {
          children: "What size is your class?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ClassSizePopup_Content, {
          children: [!this.state.selecting && !this.state.selected && this.renderNotSelectedView(), this.state.selecting && this.renderSelectingContent(), !this.state.selecting && this.state.selected && this.renderSelectedContent()]
        })]
      });
    }
  }]);

  return ClassSizePopup;
}(react.Component);


;// CONCATENATED MODULE: ./data/static/country-currency.json
var country_currency_namespaceObject = JSON.parse('{"GB":"GBP","US":"USD","NZ":"NZK","AU":"AUD","CA":"CAD","JP":"JPY","AT":"EU","BE":"EU","CY":"EU","EE":"EU","FI":"EU","FR":"EU","DE":"EU","GR":"EU","IE":"EU","IT":"EU","LU":"EU","MT":"EU","NL":"EU","PO":"EU","SK":"EU","SI":"EU","ES":"EU"}');
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/ClassesNumberPopup.js







function ClassesNumberPopup_createSuper(Derived) { var hasNativeReflectConstruct = ClassesNumberPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ClassesNumberPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var ClassesNumberPopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassesNumberPopup__Title",
  componentId: "sc-1gx0db2-0"
})(["color:", ";font-size:28px;text-align:center;margin-bottom:15px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var ClassesNumberPopup_SelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassesNumberPopup__SelectButton",
  componentId: "sc-1gx0db2-1"
})(["margin-top:15px;"]);
var ClassesNumberPopup_SizeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassesNumberPopup__SizeButton",
  componentId: "sc-1gx0db2-2"
})(["margin-top:15px;"]);
var ClassesNumberPopup_ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "ClassesNumberPopup__ConfirmButton",
  componentId: "sc-1gx0db2-3"
})(["margin-top:60px;"]);
var ClassesNumberPopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassesNumberPopup__Content",
  componentId: "sc-1gx0db2-4"
})(["text-align:center;"]);
var ClassesNumberPopup_SelectedChoice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassesNumberPopup__SelectedChoice",
  componentId: "sc-1gx0db2-5"
})(["font-size:28px;color:", ";margin:10px 0 5px 0;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var PricePerClass = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClassesNumberPopup__PricePerClass",
  componentId: "sc-1gx0db2-6"
})(["color:", ";margin-bottom:5px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var ClassesNumberPopup_PLANS = [{
  nbClasses: 1,
  prices: {
    'gbp': '£230.00',
    'usd': '$300.00',
    'nzd': '$400.00',
    'aud': '$400.00',
    'eu': '€260.00'
  }
}, {
  nbClasses: 2,
  prices: {
    'gbp': '£437.00',
    'usd': '$570.00',
    'nzd': '$760.00',
    'aud': '$760.00',
    'eu': '€494.00'
  }
}, {
  nbClasses: 3,
  prices: {
    'gbp': '£655.50',
    'usd': '$855.00',
    'nzd': '$1,140.00',
    'aud': '$1,140.00',
    'eu': '€741.00'
  }
}, {
  nbClasses: 4,
  prices: {
    'gbp': '£874.00',
    'usd': '$1,140.00',
    'nzd': '$1,520.00',
    'aud': '$1,520.00',
    'eu': '€988.00'
  }
}, {
  nbClasses: 5,
  prices: {
    'gbp': '£1,092.50',
    'usd': '$1,425.00',
    'nzd': '$1,900.00',
    'aud': '$1,900.00',
    'eu': '€1,235.00'
  }
}, {
  nbClasses: 6,
  prices: {
    'gbp': '£1,311.00',
    'usd': '$1,710.00',
    'nzd': '$2,280.00',
    'aud': '$2,280.00',
    'eu': '€1,482.00'
  }
}, {
  nbClasses: 7,
  prices: {
    'gbp': '£1,529.50',
    'usd': '$1,995.00',
    'nzd': '$2,660.00',
    'aud': '$2,660.00',
    'eu': '€1,729.00'
  }
}, {
  nbClasses: 8,
  prices: {
    'gbp': '£1,748.00',
    'usd': '$2,280.00',
    'nzd': '$3,040.00',
    'aud': '$3,040.00',
    'eu': '€1,976.00'
  }
}, {
  nbClasses: 9,
  prices: {
    'gbp': '£1,966.50',
    'usd': '$2,565.00',
    'nzd': '$3,420.00',
    'aud': '$3,420.00',
    'eu': '€2,223.00'
  }
}, {
  nbClasses: 10,
  prices: {
    'gbp': '£2,185.00',
    'usd': '$2,850.00',
    'nzd': '$3,800.00',
    'aud': '$3,800.00',
    'eu': '€2,470.00'
  }
}, {
  nbClasses: 11,
  prices: {
    'gbp': '£2,403.50',
    'usd': '$3,135.00',
    'nzd': '$4,180.00',
    'aud': '$4,180.00',
    'eu': '€2,717.00'
  }
}, {
  nbClasses: 12,
  prices: {
    'gbp': '£2,622.00',
    'usd': '$3,420.00',
    'nzd': '$4,560.00',
    'aud': '$4,560.00',
    'eu': '€2,964.00'
  }
}, {
  nbClasses: 13,
  prices: {
    'gbp': '£2,840.50',
    'usd': '$3,705.00',
    'nzd': '$4,940.00',
    'aud': '$4,940.00',
    'eu': '€3,211.00'
  }
}, {
  nbClasses: 14,
  prices: {
    'gbp': '£3,059.00',
    'usd': '$3,990.00',
    'nzd': '$5,320.00',
    'aud': '$5,320.00',
    'eu': '€3,458.00'
  }
}, {
  nbClasses: 15,
  prices: {
    'gbp': '£3,277.50',
    'usd': '$4,275.00',
    'nzd': '$5,700.00',
    'aud': '$5,700.00',
    'eu': '€3,705.00'
  }
}, {
  nbClasses: 16,
  prices: {
    'gbp': '£3,496.00',
    'usd': '$4,560.00',
    'nzd': '$6,080.00',
    'aud': '$6,080.00',
    'eu': '€3,952.00'
  }
}, {
  nbClasses: 17,
  prices: {
    'gbp': '£3,714.50',
    'usd': '$4,845.00',
    'nzd': '$6,460.00',
    'aud': '$6,460.00',
    'eu': '€4,199.00'
  }
}, {
  nbClasses: 18,
  prices: {
    'gbp': '£3,933.00',
    'usd': '$5,130.00',
    'nzd': '$6,840.00',
    'aud': '$6,840.00',
    'eu': '€4,446.00'
  }
}, {
  nbClasses: 19,
  prices: {
    'gbp': '£4,151.50',
    'usd': '$5,415.00',
    'nzd': '$7,220.00',
    'aud': '$7,220.00',
    'eu': '€4,693.00'
  }
}, {
  nbClasses: 20,
  prices: {
    'gbp': '£4,370.00',
    'usd': '$5,700.00',
    'nzd': '$7,600.00',
    'aud': '$7,600.00',
    'eu': '€4,940.00'
  }
}];

var ClassesNumberPopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ClassesNumberPopup, _React$Component);

  var _super = ClassesNumberPopup_createSuper(ClassesNumberPopup);

  function ClassesNumberPopup(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ClassesNumberPopup);

    _this = _super.call(this, props);
    _this.state = {
      selecting: false,
      selected: false
    };
    _this.onSelectAction = _this.onSelectAction.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.selectNbClasses = _this.selectNbClasses.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.onSelectAction = _this.onSelectAction.bind((0,assertThisInitialized/* default */.Z)(_this));
    _this.requestInvoice = _this.requestInvoice.bind((0,assertThisInitialized/* default */.Z)(_this));
    return _this;
  }

  (0,createClass/* default */.Z)(ClassesNumberPopup, [{
    key: "selectNbClasses",
    value: function selectNbClasses(o) {
      this.setState({
        selected: true,
        selecting: false,
        choice: o
      });
    }
  }, {
    key: "onSelectAction",
    value: function onSelectAction() {
      this.setState({
        selecting: true
      });
    }
  }, {
    key: "renderNotSelectedView",
    value: function renderNotSelectedView() {
      return [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClassesNumberPopup_SelectButton, {
          block: false,
          onClick: this.onSelectAction,
          children: "Select"
        })
      }, '1'), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClassesNumberPopup_ConfirmButton, {
          disabled: true,
          children: "Request Invoice"
        })
      }, '2')];
    }
  }, {
    key: "renderSelectingContent",
    value: function renderSelectingContent() {
      var currency;

      if (!country_currency_namespaceObject[this.props.countryCode]) {
        currency = 'usd';
      } else {
        currency = country_currency_namespaceObject[this.props.countryCode].toLowerCase();
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(Selector, {
        options: ClassesNumberPopup_PLANS.map(function (p) {
          return {
            plan: p,
            label: "".concat(p.nbClasses, " Class").concat(p.nbClasses > 1 ? 'es' : ''),
            info: "".concat(p.prices[currency])
          };
        }),
        onSelect: this.selectNbClasses
      });
    }
  }, {
    key: "requestInvoice",
    value: function requestInvoice() {
      this.props.onSubmit([{
        title: 'Type',
        answer: 'Multiple classes'
      }, {
        title: 'Number of classes',
        answer: "".concat(this.state.choice.plan.nbClasses)
      }]);
    }
  }, {
    key: "renderSelectedContent",
    value: function renderSelectedContent() {
      var choice = this.state.choice;
      return [/*#__PURE__*/(0,jsx_runtime.jsx)(ClassesNumberPopup_SizeButton, {
        onClick: this.onSelectAction,
        children: choice.label
      }, '1'), /*#__PURE__*/(0,jsx_runtime.jsx)(ClassesNumberPopup_SelectedChoice, {
        children: choice.info
      }, '2'), /*#__PURE__*/(0,jsx_runtime.jsxs)(PricePerClass, {
        children: ["Only ", choice.info[0], parseInt(choice.info.substring(1, choice.info.length).replace(',', '')) / choice.plan.nbClasses, " per class"]
      }, '3'), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        bgColor: Dashboard_global_styles/* colors.success */.O9.success,
        onClick: this.requestInvoice,
        children: "Request Invoice"
      }, '4')];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ClassesNumberPopup_Title, {
          children: "How many classes do you need?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ClassesNumberPopup_Content, {
          children: [!this.state.selecting && !this.state.selected && this.renderNotSelectedView(), this.state.selecting && this.renderSelectingContent(), !this.state.selecting && this.state.selected && this.renderSelectedContent()]
        })]
      });
    }
  }]);

  return ClassesNumberPopup;
}(react.Component);

/* harmony default export */ var components_ClassesNumberPopup = (ClassesNumberPopup);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SchoolsNumberPopup.js






function SchoolsNumberPopup_createSuper(Derived) { var hasNativeReflectConstruct = SchoolsNumberPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SchoolsNumberPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var SchoolsNumberPopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolsNumberPopup__Title",
  componentId: "sc-1wdrzxj-0"
})(["color:", ";font-size:28px;text-align:center;margin-bottom:15px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var SchoolsNumberPopup_SelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "SchoolsNumberPopup__SelectButton",
  componentId: "sc-1wdrzxj-1"
})(["margin-top:15px;"]);
var SchoolsNumberPopup_SizeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "SchoolsNumberPopup__SizeButton",
  componentId: "sc-1wdrzxj-2"
})(["margin-top:15px;"]);
var SchoolsNumberPopup_ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "SchoolsNumberPopup__ConfirmButton",
  componentId: "sc-1wdrzxj-3"
})(["margin-top:60px;"]);
var SchoolsNumberPopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolsNumberPopup__Content",
  componentId: "sc-1wdrzxj-4"
})(["text-align:center;"]);
var SchoolsNumberPopup_SelectedChoice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SchoolsNumberPopup__SelectedChoice",
  componentId: "sc-1wdrzxj-5"
})(["font-size:28px;color:", ";margin:10px 0 5px 0;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var SchoolsNumberPopup_PLANS = Array(20).fill({}).map(function (c, i) {
  return {
    nbSchools: i + 1
  };
});

var SchoolsNumberPopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SchoolsNumberPopup, _React$Component);

  var _super = SchoolsNumberPopup_createSuper(SchoolsNumberPopup);

  function SchoolsNumberPopup(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, SchoolsNumberPopup);

    _this = _super.call(this, props);
    _this.state = {
      selecting: false,
      selected: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(SchoolsNumberPopup, [{
    key: "selectNbClasses",
    value: function selectNbClasses(o) {
      this.setState({
        selected: true,
        selecting: false,
        choice: o
      });
    }
  }, {
    key: "onSelectAction",
    value: function onSelectAction() {
      this.setState({
        selecting: true
      });
    }
  }, {
    key: "renderNotSelectedView",
    value: function renderNotSelectedView() {
      return [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolsNumberPopup_SelectButton, {
          block: false,
          onClick: this.onSelectAction.bind(this),
          children: "Select"
        })
      }, '1'), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolsNumberPopup_ConfirmButton, {
          disabled: true,
          children: "Request Invoice"
        })
      }, '2')];
    }
  }, {
    key: "renderSelectingContent",
    value: function renderSelectingContent() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Selector, {
        options: SchoolsNumberPopup_PLANS.map(function (p) {
          return {
            plan: p,
            label: "".concat(p.nbSchools, " School").concat(p.nbSchools > 1 ? 's' : ''),
            info: ""
          };
        }),
        onSelect: this.selectNbClasses.bind(this)
      });
    }
  }, {
    key: "requestInvoice",
    value: function requestInvoice() {
      this.props.onSubmit([{
        title: 'Type',
        answer: 'Multiple schools'
      }, {
        title: 'Number of schools',
        answer: "".concat(this.state.choice.nbSchools)
      }]);
    }
  }, {
    key: "renderSelectedContent",
    value: function renderSelectedContent() {
      var choice = this.state.choice;
      return [/*#__PURE__*/(0,jsx_runtime.jsx)(SchoolsNumberPopup_SizeButton, {
        onClick: this.onSelectAction.bind(this),
        children: choice.label
      }, '1'), /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolsNumberPopup_SelectedChoice, {
        children: choice.info
      }, '2'), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        bgColor: Dashboard_global_styles/* colors.success */.O9.success,
        onClick: this.requestInvoice.bind(this),
        children: "Request Invoice"
      }, '3')];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SchoolsNumberPopup_Title, {
          children: "How many schools do you need?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SchoolsNumberPopup_Content, {
          children: [!this.state.selecting && !this.state.selected && this.renderNotSelectedView(), this.state.selecting && this.renderSelectingContent(), !this.state.selecting && this.state.selected && this.renderSelectedContent()]
        })]
      });
    }
  }]);

  return SchoolsNumberPopup;
}(react.Component);


// EXTERNAL MODULE: ./node_modules/react-stripe-elements/es/index.js
var react_stripe_elements_es = __webpack_require__(32558);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/Checkout/CheckoutForm.styles.js




var CheckoutForm_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__Wrapper",
  componentId: "sc-il2npc-0"
})(["", ";position:relative;background-image:linear-gradient( to right,", " 0%,", " 100% );padding:50px 25px 35px 25px;max-width:430px;margin:auto auto;border-radius:20px;"], Dashboard_global_styles/* fonts.libreBaskerville */.Rq.libreBaskerville, Dashboard_global_styles/* colors.mediumPurple */.O9.mediumPurple, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var ButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__ButtonsContainer",
  componentId: "sc-il2npc-1"
})(["display:flex;justify-content:center;flex:1;margin-top:20px;"]);
var CardDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__CardDetails",
  componentId: "sc-il2npc-2"
})(["margin-top:30px;margin-bottom:30px;padding:8px 12px;"]);
var Heading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__Heading",
  componentId: "sc-il2npc-3"
})(["font-size:24px;text-align:center;margin-bottom:25px;"]);
var CheckoutForm_styles_Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CheckoutFormstyles__Title",
  componentId: "sc-il2npc-4"
})(["color:", ";"], Dashboard_global_styles/* colors.pink */.O9.pink);
var MessageText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CheckoutFormstyles__MessageText",
  componentId: "sc-il2npc-5"
})(["color:", ";"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var CheckoutForm_styles_Price = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CheckoutFormstyles__Price",
  componentId: "sc-il2npc-6"
})(["color:", ";padding-left:10px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var PriceStrikethrough = (0,styled_components_browser_esm/* default */.ZP)(CheckoutForm_styles_Price).withConfig({
  displayName: "CheckoutFormstyles__PriceStrikethrough",
  componentId: "sc-il2npc-7"
})(["text-decoration:line-through;"]);
var DiscountMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__DiscountMessage",
  componentId: "sc-il2npc-8"
})(["color:", ";font-size:15px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var Coupon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__Coupon",
  componentId: "sc-il2npc-9"
})(["display:flex;align-items:center;"]);
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "CheckoutFormstyles__Input",
  componentId: "sc-il2npc-10"
})(["flex-grow:1;height:30px;margin-right:20px;border-radius:5px;border:1px solid #aaa;padding:4px 8px;"]);
var CheckoutForm_styles_StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "CheckoutFormstyles__StyledFormInput",
  componentId: "sc-il2npc-11"
})(["margin-right:20px;margin-bottom:-10px;"]);
var DismissButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  displayName: "CheckoutFormstyles__DismissButton",
  componentId: "sc-il2npc-12"
})(["position:absolute;top:10px;right:10px;"]);
var Message = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__Message",
  componentId: "sc-il2npc-13"
})(["display:flex;justify-content:center;flex-wrap:wrap;color:", ";font-size:22px;text-align:center;& :first-child{width:100%;margin-bottom:20px;}"], Dashboard_global_styles/* colors.white */.O9.white);
var StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "CheckoutFormstyles__StyledLabel",
  componentId: "sc-il2npc-14"
})(["margin-bottom:20px;font-size:14px;margin-right:20px;"]);
var CardDetailsRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__CardDetailsRow",
  componentId: "sc-il2npc-15"
})(["display:flex;"]);
var CardDetailsElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__CardDetailsElement",
  componentId: "sc-il2npc-16"
})(["background-color:white;padding:6px 12px;border-radius:9px;margin-top:2px;margin-right:20px;box-shadow:1px 1px 3px rgba(0,0,0,0.2);"]);
var CardDetailsNumber = (0,styled_components_browser_esm/* default */.ZP)(CardDetailsElement).withConfig({
  displayName: "CheckoutFormstyles__CardDetailsNumber",
  componentId: "sc-il2npc-17"
})(["width:202px;"]);
var SecurityCode = (0,styled_components_browser_esm/* default */.ZP)(CardDetailsElement).withConfig({
  displayName: "CheckoutFormstyles__SecurityCode",
  componentId: "sc-il2npc-18"
})(["width:64px;"]);
var ExpiryDate = (0,styled_components_browser_esm/* default */.ZP)(CardDetailsElement).withConfig({
  displayName: "CheckoutFormstyles__ExpiryDate",
  componentId: "sc-il2npc-19"
})(["width:95px;"]);
var PostalCode = (0,styled_components_browser_esm/* default */.ZP)(CardDetailsElement).withConfig({
  displayName: "CheckoutFormstyles__PostalCode",
  componentId: "sc-il2npc-20"
})(["width:116px;"]);
var FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CheckoutFormstyles__FormContainer",
  componentId: "sc-il2npc-21"
})(["width:361px;margin:0 auto;"]);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/Checkout/CheckoutForm.js








function CheckoutForm_createSuper(Derived) { var hasNativeReflectConstruct = CheckoutForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function CheckoutForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var CheckoutForm = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(CheckoutForm, _React$Component);

  var _super = CheckoutForm_createSuper(CheckoutForm);

  function CheckoutForm(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, CheckoutForm);

    _this = _super.call(this, props);
    _this.state = {
      message: null,
      loading: false,
      error: false,
      success: false,
      couponCode: null,
      couponDiscount: null,
      errorMessage: undefined
    };
    return _this;
  }

  (0,createClass/* default */.Z)(CheckoutForm, [{
    key: "onSuccess",
    value: function onSuccess() {
      this.props.onSuccess();
      this.setState({
        success: true,
        error: false,
        loading: false,
        errorMessage: undefined
      });
    }
  }, {
    key: "onRetry",
    value: function onRetry() {
      this.setState({
        success: false,
        error: false,
        loading: false,
        errorMessage: undefined
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      this.setState({
        success: false,
        error: false,
        loading: true,
        errorMessage: undefined
      });
    }
  }, {
    key: "onError",
    value: function onError(e) {
      this.setState({
        success: false,
        error: true,
        loading: false,
        errorMessage: e.code && e.type ? e.message : undefined
      });
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Message, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MessageText, {
          children: this.state.errorMessage || 'An error occurred!'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          bgColor: "red",
          color: "white",
          width: "calc(50% - 10px)",
          onClick: this.props.onCancel,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          color: "white",
          width: "calc(50% - 10px)",
          onClick: this.onRetry.bind(this),
          children: "Retry"
        })]
      });
    }
  }, {
    key: "renderSuccessMessage",
    value: function renderSuccessMessage() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Message, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MessageText, {
          children: "Thank you for subscribing!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          bgColor: "red",
          color: "white",
          size: "regular",
          onClick: function onClick() {
            window.location = '/edu/dashboard/classroom';
          },
          children: "Go back"
        })]
      });
    }
  }, {
    key: "renderLoadingMessage",
    value: function renderLoadingMessage() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
        bgColor: "rgba(0,0,0,0)",
        itemColor: Dashboard_global_styles/* colors.pink */.O9.pink,
        itemSize: "60"
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this2 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContainer, {
        children: [this.props.parent && /*#__PURE__*/(0,jsx_runtime.jsx)(formsy_react_lib/* default */.ZP, {
          onValidSubmit: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
            var couponDiscount;
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this2.props.getDiscount(_this2.state.couponCode);

                  case 2:
                    couponDiscount = _context.sent;
                    if (couponDiscount) _this2.setState({
                      couponDiscount: couponDiscount
                    });

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Coupon, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutForm_styles_StyledFormInput, {
              value: this.state.couponCode,
              onChange: function onChange(e) {
                return _this2.setState({
                  couponCode: e.target.value
                });
              },
              name: "coupon",
              validations: "isExisty",
              placeholder: "Coupon",
              width: "250px"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              element: "button",
              bgColor: this.state.couponDiscount ? Dashboard_global_styles/* colors.success */.O9.success : undefined,
              color: "white",
              children: this.state.couponDiscount ? 'Applied' : 'Apply'
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardDetails, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CardDetailsRow, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
              children: ["Card number", /*#__PURE__*/(0,jsx_runtime.jsx)(CardDetailsNumber, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_stripe_elements_es/* CardNumberElement */.Ke, {
                  style: {
                    base: {
                      fontSize: '18px'
                    }
                  }
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
              children: ["Expiration", /*#__PURE__*/(0,jsx_runtime.jsx)(ExpiryDate, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_stripe_elements_es/* CardExpiryElement */.Oh, {
                  style: {
                    base: {
                      fontSize: '18px'
                    }
                  }
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardDetailsRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
              children: ["Security Code", /*#__PURE__*/(0,jsx_runtime.jsx)(SecurityCode, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_stripe_elements_es/* CardCVCElement */._e, {
                  style: {
                    base: {
                      fontSize: '18px'
                    }
                  }
                })
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonsContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: this.handleCheckoutFormSubmit.bind(this),
            color: "white",
            bgColor: Dashboard_global_styles/* colors.success */.O9.success,
            children: "Confirm"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: this.props.onCancel,
            color: "white",
            bgColor: "red",
            children: "Cancel"
          })]
        })]
      });
    }
  }, {
    key: "handleCheckoutFormSubmit",
    value: function handleCheckoutFormSubmit(e) {
      var _this3 = this;

      var coupon = this.state.couponCode ? this.state.couponCode : undefined;
      this.onSubmit();

      if (this.props.stripe) {
        this.props.stripe.createToken().then(function (payload) {
          if (payload.error) {
            return _this3.onError(payload.error);
          }

          _this3.props.handleStripeToken(_this3.props.plan, payload.token, coupon).then(function (response) {
            _this3.onSuccess();
          })["catch"](function (e) {
            _this3.onError(e);
          });
        });
      } else {
        // this.props.handleError()
        console.log('Stripe is not defined.');
      }
    }
  }, {
    key: "renderPlanAmount",
    value: function renderPlanAmount() {
      var discountPercentage = this.props.subscription && this.props.subscription.discountPercentage || 0;
      var couponDiscount = this.state.couponDiscount || 0;

      if (discountPercentage || couponDiscount) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PriceStrikethrough, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
              amount: this.props.plan.amount / 100,
              currency: this.props.plan.currency
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutForm_styles_Price, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
              amount: (this.props.plan.amount - this.props.plan.amount * ((discountPercentage + couponDiscount) / 100)) / 100,
              currency: this.props.plan.currency
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountMessage, {
            children: "Your discount has been applied!"
          })]
        });
      } else return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutForm_styles_Price, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
          amount: this.props.plan.amount / 100,
          currency: this.props.plan.currency
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          product = _this$props.product,
          plan = _this$props.plan;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Heading, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CheckoutForm_styles_Title, {
            children: ["One ", product.name, " Paid", ' ', plan.interval === 'year' ? 'yearly' : 'monthly']
          }), this.renderPlanAmount()]
        }), this.state.loading ? this.renderLoadingMessage() : null, this.state.error ? this.renderErrorMessage() : null, this.state.success ? this.renderSuccessMessage() : null, !this.state.success && !this.state.error ? this.renderForm() : null]
      });
    }
  }]);

  return CheckoutForm;
}(react.Component);

/* harmony default export */ var Checkout_CheckoutForm = ((0,react_stripe_elements_es/* injectStripe */.kv)(CheckoutForm));
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/Checkout/CheckoutFormPopup.js






function CheckoutFormPopup_createSuper(Derived) { var hasNativeReflectConstruct = CheckoutFormPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function CheckoutFormPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var FAKE_PLAN = {
  name: 'Plan'
};
var FAKE_PRODUCT = {
  name: 'Product'
};

var CheckoutFormPopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(CheckoutFormPopup, _React$Component);

  var _super = CheckoutFormPopup_createSuper(CheckoutFormPopup);

  function CheckoutFormPopup(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, CheckoutFormPopup);

    _this = _super.call(this, props);
    _this.state = {
      stripe: null
    };
    return _this;
  }

  (0,createClass/* default */.Z)(CheckoutFormPopup, [{
    key: "_setStripe",
    value: function _setStripe() {
      this.setState({
        stripe: window.Stripe(config/* default.stripeAPIKey */.Z.stripeAPIKey)
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.Stripe) {
        this.setState({
          stripe: window.Stripe(config/* default.stripeAPIKey */.Z.stripeAPIKey)
        });
      } else {
        document.querySelector('#stripe-js').addEventListener('load', this._setStripe.bind(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.querySelector('#stripe-js').removeEventListener('load', this._setStripe.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(react_stripe_elements_es/* StripeProvider */.vw, {
        stripe: this.state.stripe,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_stripe_elements_es/* Elements */.eK, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardPopup/* default */.Z, {
            onCancel: this.props.onCancel,
            height: "auto",
            width: "auto",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkout_CheckoutForm, {
              plan: this.props.plan,
              parent: this.props.parent,
              product: this.props.product,
              handleStripeToken: this.props.handleStripeToken,
              onSuccess: this.props.onSuccess.bind(this),
              onCancel: this.props.onCancel // onCancel={this.onCheckoutFormCancelled.bind(this)}
              ,
              subscription: this.props.subscription,
              getDiscount: this.props.getDiscount
            })
          })
        })
      });
    }
  }]);

  return CheckoutFormPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SelectPaymentPlanPopup.js






function SelectPaymentPlanPopup_createSuper(Derived) { var hasNativeReflectConstruct = SelectPaymentPlanPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SelectPaymentPlanPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var SelectPaymentPlanPopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlanPopup__Title",
  componentId: "sc-1kodtkz-0"
})(["color:", ";font-size:28px;text-align:center;margin-bottom:15px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var SelectPaymentPlanPopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlanPopup__Content",
  componentId: "sc-1kodtkz-1"
})(["display:flex;text-align:center;justify-content:space-between;"]);
var SelectPaymentPlanPopup_Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlanPopup__Option",
  componentId: "sc-1kodtkz-2"
})(["margin-top:20px;"]);
var SelectPaymentPlanPopup_Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlanPopup__Price",
  componentId: "sc-1kodtkz-3"
})(["font-size:30px;color:", ";margin:8px 0 10px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var SelectPaymentPlanPopup_Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentPlanPopup__Label",
  componentId: "sc-1kodtkz-4"
})(["color:", ";"], Dashboard_global_styles/* colors.pink */.O9.pink);
var SelectPaymentPlanPopup_PLANS = [{
  nbStudents: '1-14',
  title: 'Small'
}, {
  nbStudents: '15-35',
  title: 'Medium'
}, {
  nbStudents: '35+',
  title: 'Large'
}];

var SelectPaymentPlanPopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SelectPaymentPlanPopup, _React$Component);

  var _super = SelectPaymentPlanPopup_createSuper(SelectPaymentPlanPopup);

  function SelectPaymentPlanPopup(props) {
    (0,classCallCheck/* default */.Z)(this, SelectPaymentPlanPopup);

    return _super.call(this, props);
  }

  (0,createClass/* default */.Z)(SelectPaymentPlanPopup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var plans = this.props.plans;

      if (!plans) {
        return null;
      }

      var yearlyPlan = plans.filter(function (p) {
        return p.interval === 'year';
      })[0];
      var monthlyPlan = plans.filter(function (p) {
        return p.interval === 'month';
      })[0];
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentPlanPopup_Title, {
          children: "How would you like to pay?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentPlanPopup_Content, {
          children: plans.slice().sort(function (x, y) {
            return x.amount - y.amount;
          }).map(function (p, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectPaymentPlanPopup_Option, {
              onClick: function onClick() {
                return _this.props.onSelect(p);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                children: p.interval === 'month' ? 'Monthly' : 'Yearly'
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentPlanPopup_Price, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
                  amount: p.amount / 100,
                  currency: p.currency
                })
              }), p.interval === 'year' && /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectPaymentPlanPopup_Label, {
                children: ["Save", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
                  amount: (monthlyPlan.amount * 12 - yearlyPlan.amount) / 100,
                  currency: monthlyPlan.currency
                })]
              })]
            }, i);
          })
        })]
      });
    }
  }]);

  return SelectPaymentPlanPopup;
}(react.Component);


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/CardSuccessPopup.js







function CardSuccessPopup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardSuccessPopup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardSuccessPopup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardSuccessPopup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CardSuccessPopup_createSuper(Derived) { var hasNativeReflectConstruct = CardSuccessPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function CardSuccessPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var CardSuccessPopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CardSuccessPopup__Title",
  componentId: "sc-1fudq7f-0"
})(["color:", ";font-size:28px;text-align:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var CardSuccessPopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CardSuccessPopup__Content",
  componentId: "sc-1fudq7f-1"
})(["text-align:center;padding:70px 0;"]);
var BottomInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CardSuccessPopup__BottomInfo",
  componentId: "sc-1fudq7f-2"
})(["color:", ";font-size:11px;a{color:", ";}"], Dashboard_global_styles/* colors.paleGreen */.O9.paleGreen, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);

var CardSuccessPopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(CardSuccessPopup, _React$Component);

  var _super = CardSuccessPopup_createSuper(CardSuccessPopup);

  function CardSuccessPopup() {
    (0,classCallCheck/* default */.Z)(this, CardSuccessPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(CardSuccessPopup, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardSuccessPopup_Title, {
          children: "Thank you!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardSuccessPopup_Content, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return _this.props.redirectTo('/dashboard/classroom');
            },
            children: "Back to homepage"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomInfo, {
          children: ["Any questions? Simply email ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "mailto:sales@nightzookeeper.com",
            children: "sales@nightzookeeper.com"
          }), " or click on the chat icon at the bottom right of the screen."]
        })]
      });
    }
  }]);

  return CardSuccessPopup;
}(react.Component);

/* harmony default export */ var components_CardSuccessPopup = (function (props) {
  var router = useRouter();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardSuccessPopup, CardSuccessPopup_objectSpread(CardSuccessPopup_objectSpread({}, props), {}, {
    redirectTo: router.push
  }));
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/InvoiceSuccessPopup.js







function InvoiceSuccessPopup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InvoiceSuccessPopup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InvoiceSuccessPopup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InvoiceSuccessPopup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function InvoiceSuccessPopup_createSuper(Derived) { var hasNativeReflectConstruct = InvoiceSuccessPopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function InvoiceSuccessPopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var InvoiceSuccessPopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InvoiceSuccessPopup__Title",
  componentId: "sc-nsds98-0"
})(["color:", ";font-size:28px;text-align:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var InvoiceSuccessPopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InvoiceSuccessPopup__Content",
  componentId: "sc-nsds98-1"
})(["text-align:center;padding:50px 0;"]);
var InvoiceSuccessPopup_Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InvoiceSuccessPopup__Info",
  componentId: "sc-nsds98-2"
})(["color:", ";text-align:center;font-size:14px;padding:0 20px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var InvoiceSuccessPopup_BottomInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InvoiceSuccessPopup__BottomInfo",
  componentId: "sc-nsds98-3"
})(["color:", ";font-size:11px;a{color:", ";}"], Dashboard_global_styles/* colors.darkTeal */.O9.darkTeal, Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);

var InvoiceSuccessPopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(InvoiceSuccessPopup, _React$Component);

  var _super = InvoiceSuccessPopup_createSuper(InvoiceSuccessPopup);

  function InvoiceSuccessPopup() {
    (0,classCallCheck/* default */.Z)(this, InvoiceSuccessPopup);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(InvoiceSuccessPopup, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InvoiceSuccessPopup_Title, {
          children: "Thank you!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InvoiceSuccessPopup_Info, {
          children: "A member of our team will be in touch within 24 hours."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InvoiceSuccessPopup_Content, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return _this.props.redirectTo('/dashboard/classroom');
            },
            children: "Back to homepage"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InvoiceSuccessPopup_BottomInfo, {
          children: ["Any questions? Simply email ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "mailto:sales@nightzookeeper.com",
            children: "sales@nightzookeeper.com"
          }), " or click on the chat icon at the bottom right of the screen."]
        })]
      });
    }
  }]);

  return InvoiceSuccessPopup;
}(react.Component);

/* harmony default export */ var components_InvoiceSuccessPopup = (function (props) {
  var router = useRouter();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InvoiceSuccessPopup, InvoiceSuccessPopup_objectSpread(InvoiceSuccessPopup_objectSpread({}, props), {}, {
    redirectTo: router.push
  }));
});
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/stream-http/index.js
var stream_http = __webpack_require__(22321);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SelectPaymentTypePopup.js







function SelectPaymentTypePopup_createSuper(Derived) { var hasNativeReflectConstruct = SelectPaymentTypePopup_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SelectPaymentTypePopup_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var SelectPaymentTypePopup_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentTypePopup__Title",
  componentId: "sc-1c9n8t1-0"
})(["color:", ";font-size:22px;text-align:center;margin-bottom:15px;text-align:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var SelectPaymentTypePopup_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentTypePopup__Content",
  componentId: "sc-1c9n8t1-1"
})(["display:flex;text-align:center;justify-content:space-between;width:90%;margin:20px auto 0 auto;"]);
var SelectPaymentTypePopup_Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentTypePopup__Price",
  componentId: "sc-1c9n8t1-2"
})(["font-size:40px;color:", ";text-align:center;margin:8px 0 10px;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var Product = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectPaymentTypePopup__Product",
  componentId: "sc-1c9n8t1-3"
})(["font-size:12px;color:", ";text-align:center;"], Dashboard_global_styles/* colors.pink */.O9.pink);

var SelectPaymentTypePopup = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SelectPaymentTypePopup, _React$Component);

  var _super = SelectPaymentTypePopup_createSuper(SelectPaymentTypePopup);

  function SelectPaymentTypePopup(props) {
    (0,classCallCheck/* default */.Z)(this, SelectPaymentTypePopup);

    return _super.call(this, props);
  }

  (0,createClass/* default */.Z)(SelectPaymentTypePopup, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardPopup/* default */.Z, {
        onCancel: this.props.onCancel,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Product, {
          children: this.props.product.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentTypePopup_Price, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Currency/* default */.Z, {
            amount: this.props.plan.amount / 100,
            currency: this.props.plan.currency
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentTypePopup_Title, {
          children: "How would you like to pay?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectPaymentTypePopup_Content, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: this.props.onCardSelect,
            children: "Card"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return _this.props.onInvoiceSelect([{
                title: 'type',
                answer: 'Single class'
              }, {
                title: 'nbClasses',
                answer: 1
              }], _this.props.plan);
            },
            children: "Invoice"
          })]
        })]
      });
    }
  }]);

  return SelectPaymentTypePopup;
}(react.Component);

(0,defineProperty/* default */.Z)(SelectPaymentTypePopup, "defaultProps", {
  product: {},
  plan: {}
});


;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SubscribedHeading/SubscribedHeading.styles.js


var SubscribedHeading_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SubscribedHeadingstyles__Wrapper",
  componentId: "sc-u1fksx-0"
})(["background-color:white;", ";"], Dashboard_global_styles/* fonts.libreBaskerville */.Rq.libreBaskerville);
var SubscribedHeading_styles_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SubscribedHeadingstyles__Content",
  componentId: "sc-u1fksx-1"
})(["max-width:860px;margin:0 auto;display:flex;flex:1;justify-content:space-between;@media (max-width:880px){padding:30px 0px;justify-content:center;}"]);
var SubscribedHeading_styles_Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SubscribedHeadingstyles__Image",
  componentId: "sc-u1fksx-2"
})(["height:300px;width:300px;flex-shrink:0;background-position:center;background-repeat:no-repeat;background-size:cover;background-image:", ";@media (max-width:880px){display:none;}"], function (props) {
  return "url(".concat(props.src, ")");
});
var Information = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SubscribedHeadingstyles__Information",
  componentId: "sc-u1fksx-3"
})(["padding-top:30px;padding-right:30px;font-size:17px;"]);
var SubscribedHeading_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "SubscribedHeadingstyles__Title",
  componentId: "sc-u1fksx-4"
})(["color:", ";font-size:24px;"], Dashboard_global_styles/* colors.pink */.O9.pink);
var SubscribedHeading_styles_Text = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "SubscribedHeadingstyles__Text",
  componentId: "sc-u1fksx-5"
})(["> a{color:", ";}", ""], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple, function (props) {
  return (0,styled_components_browser_esm/* css */.iv)(["color:", ";font-size:", ";"], props.color || Dashboard_global_styles/* colors.pink */.O9.pink, props.small ? '14px' : '17px');
});
var SubscribedHeading_styles_List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SubscribedHeadingstyles__List",
  componentId: "sc-u1fksx-6"
})(["color:", ";width:100%;display:flex;flex-wrap:wrap;justify-content:space-between;margin-left:15px;padding:0;list-style-type:none;"], Dashboard_global_styles/* colors.darkPurple */.O9.darkPurple);
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "SubscribedHeadingstyles__Item",
  componentId: "sc-u1fksx-7"
})(["position:relative;width:50%;:before{position:absolute;left:-10px;top:calc(50% - 3px);height:6px;width:6px;border-radius:50%;background-color:", ";content:'';}"], Dashboard_global_styles/* colors.yellow */.O9.yellow);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/components/SubscribedHeading/SubscribedHeading.js








/* harmony default export */ var SubscribedHeading = (function (props) {
  if (props.subscription.custom) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SubscribedHeading_styles_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Information, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Title, {
            children: new Date(props.subscription.subscriptionEndDate) > Date.now() ? 'Thank you' : ''
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: new Date(props.subscription.subscriptionEndDate) > Date.now() ? /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Text, {
              children: "You're now a Night Zookeeper subscriber. Welcome to the community!"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Text, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: "Your custom subscription expired on {renewDate}.",
                id: "dashboard.customSubscriptionExpired",
                values: {
                  renewDate: /*#__PURE__*/(0,jsx_runtime.jsx)(react_intl_lib/* FormattedDate */.Ji, {
                    value: new Date(props.subscription.subscriptionEndDate),
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                  })
                }
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: new Date(props.subscription.subscriptionEndDate) > Date.now() ? /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Text, {
              color: Dashboard_global_styles/* colors.success */.O9.success,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: "You are on custom subscription plan which will renew on the {renewDate}.",
                id: "dashboard.customSubscriptionStatus.renewDate",
                values: {
                  renewDate: /*#__PURE__*/(0,jsx_runtime.jsx)(react_intl_lib/* FormattedDate */.Ji, {
                    value: new Date(props.subscription.subscriptionEndDate),
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                  })
                }
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Text, {
              color: Dashboard_global_styles/* colors.success */.O9.success,
              children: "We'd love you to join the community for another year!"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SubscribedHeading_styles_Text, {
              small: true,
              children: ["Any questions? Simply email", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: 'mailto:sales@nightzookeeper.com',
                children: "sales@nightzookeeper.com"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SubscribedHeading_styles_Text, {
              small: true,
              children: [' ', "or click on the chat icon at the bottom right of the screen."]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Image, {
          src: "".concat("/edu/assets", "/images/kids.jpeg")
        })]
      })
    });
  }

  if (new Date(props.subscription.subscriptionEndDate) < Date.now()) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components_TopBanner, {
      parent: props.parent
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SubscribedHeading_styles_Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Information, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Title, {
          children: "Thank you"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Text, {
            children: "You're now a Night Zookeeper subscriber. Welcome to the community!"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Text, {
            color: Dashboard_global_styles/* colors.success */.O9.success,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              defaultMessage: "You have a {productName} subscription which will renew on the {renewDate}.",
              id: "dashboard.subscriptionStatus.active",
              values: {
                productName: props.subscription.plan ? props.subscription.plan.product.name : '',
                renewDate: /*#__PURE__*/(0,jsx_runtime.jsx)(react_intl_lib/* FormattedDate */.Ji, {
                  value: props.subscription.subscriptionEndDate,
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                })
              }
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SubscribedHeading_styles_Text, {
            small: true,
            children: ["Any questions? Simply email", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: 'mailto:sales@nightzookeeper.com',
              children: "sales@nightzookeeper.com"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SubscribedHeading_styles_Text, {
            small: true,
            children: [' ', "or click on the chat icon at the bottom right of the screen."]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading_styles_Image, {
        src: "".concat("/edu/assets", "/images/kids.jpeg")
      })]
    })
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/Subscription.js








function Subscription_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Subscription_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Subscription_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Subscription_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function Subscription_createSuper(Derived) { var hasNativeReflectConstruct = Subscription_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function Subscription_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




















var Subscription_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Subscription__Wrapper",
  componentId: "sc-g10v8y-0"
})(["background-color:white;"]);

var Subscription = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Subscription, _React$Component);

  var _super = Subscription_createSuper(Subscription);

  function Subscription(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Subscription);

    _this = _super.call(this, props);
    _this.state = {
      selectedProduct: null
    };
    return _this;
  }

  (0,createClass/* default */.Z)(Subscription, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "selectProduct",
    value: function () {
      var _selectProduct = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(p) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState({
                  selectedProduct: p
                });

              case 2:
                this.props.modal.closeAll();
                this.displaySelectPaymentPlanPopup();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function selectProduct(_x) {
        return _selectProduct.apply(this, arguments);
      }

      return selectProduct;
    }()
  }, {
    key: "selectPlan",
    value: function () {
      var _selectPlan = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(p) {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setState({
                  selectedPlan: p
                });

              case 2:
                this.props.modal.closeAll();
                this.displaySelectPaymentTypePopup();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function selectPlan(_x2) {
        return _selectPlan.apply(this, arguments);
      }

      return selectPlan;
    }()
  }, {
    key: "displaySelectPaymentPlanPopup",
    value: function displaySelectPaymentPlanPopup() {
      if (this.state.selectedProduct && this.state.selectedProduct.plans) {
        this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentPlanPopup, {
          onSelect: this.selectPlan.bind(this),
          plans: this.state.selectedProduct.plans,
          onCancel: this.props.modal.closeAll
        }));
      }
    }
  }, {
    key: "displaySelectClassSizePopup",
    value: function displaySelectClassSizePopup() {
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(ClassSizePopup, {
        products: this.props.products,
        onCancel: this.props.modal.closeAll,
        onSubmit: this.selectProduct.bind(this)
      }));
    }
  }, {
    key: "displaySelectPaymentTypePopup",
    value: function displaySelectPaymentTypePopup() {
      this.props.modal.closeAll();

      if (this.state.selectedPlan.interval === 'month' || this.props.parent) {
        this.displayCardPaymentPopup();
        return;
      }

      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentTypePopup, {
        plan: this.state.selectedPlan,
        product: this.state.selectedProduct,
        onCancel: this.props.modal.closeAll,
        onCardSelect: this.displayCardPaymentPopup.bind(this),
        onInvoiceSelect: this.onRequestInvoice.bind(this)
      }));
    }
  }, {
    key: "displaySelectClassesNumberPopup",
    value: function displaySelectClassesNumberPopup() {
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(components_ClassesNumberPopup, {
        countryCode: this.props.countryCode,
        onCancel: this.props.modal.closeAll,
        onSubmit: this.onRequestInvoice.bind(this)
      }));
    }
  }, {
    key: "displaySelectSchoolsNumberPopup",
    value: function displaySelectSchoolsNumberPopup() {
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolsNumberPopup, {
        onCancel: this.props.modal.closeAll,
        onSubmit: this.onRequestInvoice.bind(this)
      }));
    }
  }, {
    key: "handleCheckoutSuccess",
    value: function handleCheckoutSuccess() {
      this.props.modal.closeAll();
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(components_CardSuccessPopup, {
        onCancel: this.props.modal.closeAll
      }));
    }
  }, {
    key: "onRequestInvoice",
    value: function onRequestInvoice(questions, plan) {
      var planToSend = {};

      if (plan) {
        planToSend = Subscription_objectSpread({}, plan);
        delete planToSend.__typename;
      }

      this.props.modal.closeAll();
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(components_InvoiceSuccessPopup, {
        onCancel: this.props.modal.closeAll
      }));
      this.props.onRequestInvoice(questions, planToSend);
    }
  }, {
    key: "displayCardPaymentPopup",
    value: function displayCardPaymentPopup() {
      this.props.modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutFormPopup, {
        parent: this.props.parent,
        onCancel: this.props.modal.closeAll,
        handleStripeToken: this.props.handleStripeToken,
        plan: this.state.selectedPlan,
        product: this.state.selectedProduct,
        onSuccess: this.handleCheckoutSuccess.bind(this),
        getDiscount: this.props.getDiscount,
        subscription: this.props.currentSubscription
      }));
    }
  }, {
    key: "renderPlanSelection",
    value: function renderPlanSelection() {
      var _this2 = this;

      var plans;
      var products = this.props.products;

      if (this.props.parent) {
        if (!products || products && products.length === 0) {
          return null;
        }

        plans = products[0].plans;
      }

      var isSubscribed = this.props.currentSubscription && new Date(this.props.currentSubscription.subscriptionEndDate) > Date.now();
      return this.props.parent ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPaymentPlan, {
        plans: plans,
        onSubmit: /*#__PURE__*/function () {
          var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(p) {
            return regenerator_default().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this2.setState({
                      selectedProduct: products[0]
                    });

                  case 2:
                    _this2.selectPlan(p);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x3) {
            return _ref.apply(this, arguments);
          };
        }()
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SelectPlan, {
        isSubscribed: isSubscribed,
        onSelectOneClass: this.displaySelectClassSizePopup.bind(this),
        onSelectMultipleClasses: this.displaySelectClassesNumberPopup.bind(this),
        onSelectWholeSchool: this.displaySelectClassesNumberPopup.bind(this),
        onSelectMultipleSchools: this.displaySelectSchoolsNumberPopup.bind(this)
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Subscription_Wrapper, {
        children: [this.props.currentSubscription ? /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribedHeading, {
          parent: this.props.parent,
          subscription: this.props.currentSubscription
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_TopBanner, {
          parent: this.props.parent
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_EngageSection, {})]
      });
    }
  }]);

  return Subscription;
}(react.Component);

/* harmony default export */ var Subscription_Subscription = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
    children: function children(modal) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Subscription, Subscription_objectSpread(Subscription_objectSpread({}, props), {}, {
        modal: modal
      }));
    }
  });
});
// EXTERNAL MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/graphql/queries/getPricingData.graphql
var getPricingData_graphql = __webpack_require__(5500);
var getPricingData_graphql_default = /*#__PURE__*/__webpack_require__.n(getPricingData_graphql);
// EXTERNAL MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/graphql/mutations/requestQuote.graphql
var requestQuote_graphql = __webpack_require__(61);
var requestQuote_graphql_default = /*#__PURE__*/__webpack_require__.n(requestQuote_graphql);
// EXTERNAL MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/graphql/mutations/subscribeToPlan.graphql
var subscribeToPlan_graphql = __webpack_require__(92621);
var subscribeToPlan_graphql_default = /*#__PURE__*/__webpack_require__.n(subscribeToPlan_graphql);
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/graphql/index.js


function graphql_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function graphql_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? graphql_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : graphql_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var graphql_queries = [{
  query: (getPricingData_graphql_default()),
  props: function props(_ref) {
    var data = _ref.data;

    if (data.loading || data.error) {
      return {
        loading: data.loading,
        error: data.error
      };
    }

    var me = data.me || {
      group: {}
    };
    var currentSubscription = me.subscription || false;
    var isCustom = me.school && !me.subscription || me.school && me.subscription && me.school.subscriptionEndDate > me.subscription.current_period_end * 1000 || me.school && me.subscription && me.school.subscriptionEndDate < me.subscription.current_period_end * 1000 && me.subscription.status !== 'active';
    return {
      loading: data.loading,
      error: data.error,
      parent: me.parent,
      countryCode: me.group.countryCode,
      trialEndDate: !me.school ? me.subscriptionEndDate : null,
      currentSubscription: graphql_objectSpread(graphql_objectSpread({}, me.subscription || {}), {}, {
        subscriptionEndDate: isCustom ? me.school.subscriptionEndDate : me.subscription ? me.subscription.current_period_end * 1000 : null,
        // Stripe UNIX timestamps
        discountPercentage: currentSubscription.discount ? currentSubscription.discount.coupon ? currentSubscription.discount.coupon.percent_off : null : null,
        custom: isCustom
      }),
      products: me.availableProducts || []
    };
  },
  options: {
    fetchPolicy: 'network-only'
  }
}];
var graphql_mutations = [{
  mutation: (subscribeToPlan_graphql_default()),
  props: function props(_ref2) {
    var mutate = _ref2.mutate;
    return {
      subscribeToPlan: function subscribeToPlan(stripeToken, planId, coupon) {
        return mutate({
          variables: {
            stripeToken: stripeToken,
            planId: planId,
            coupon: coupon
          }
        });
      }
    };
  }
}, {
  mutation: (requestQuote_graphql_default()),
  props: function props(_ref3) {
    var mutate = _ref3.mutate;
    return {
      requestQuote: function requestQuote(questions, plan) {
        return mutate({
          variables: {
            quote: {
              questions: questions.map(function (q) {
                return graphql_objectSpread(graphql_objectSpread({}, q), {}, {
                  answer: "".concat(q.answer)
                });
              }),
              plan: plan
            }
          }
        });
      }
    };
  }
}];
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/pages/Subscription/SubscriptionContainer.js









var SubscriptionContainer_templateObject;

function SubscriptionContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SubscriptionContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SubscriptionContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubscriptionContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function SubscriptionContainer_createSuper(Derived) { var hasNativeReflectConstruct = SubscriptionContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SubscriptionContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }












var SubscriptionContainer = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SubscriptionContainer, _React$Component);

  var _super = SubscriptionContainer_createSuper(SubscriptionContainer);

  function SubscriptionContainer() {
    (0,classCallCheck/* default */.Z)(this, SubscriptionContainer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(SubscriptionContainer, [{
    key: "handleStripeToken",
    value: function handleStripeToken(plan, token, coupon) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.props.subscribeToPlan(token.id, plan.id, coupon).then( /*#__PURE__*/function () {
          var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(r) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this.setState({
                      currentSubscription: r.data.subscribeToPlan
                    });

                  case 2:
                    return _context.abrupt("return", resolve(true));

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }())["catch"](function (e) {
          console.error(e);
          return reject(e);
        });
      });
    }
  }, {
    key: "getDiscount",
    value: function () {
      var _getDiscount = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client, couponId) {
        var _yield$client$query, data;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return client.query({
                  query: (0,lib/* default */.ZP)(SubscriptionContainer_templateObject || (SubscriptionContainer_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        query findDiscountCode($couponId: String) {\n          findDiscountCode(couponId: $couponId)\n        }\n      "]))),
                  variables: {
                    couponId: couponId
                  },
                  fetchPolicy: 'network-only'
                });

              case 2:
                _yield$client$query = _context2.sent;
                data = _yield$client$query.data;
                return _context2.abrupt("return", data.findDiscountCode);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getDiscount(_x2, _x3) {
        return _getDiscount.apply(this, arguments);
      }

      return getDiscount;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Loadable/* default */.Z, SubscriptionContainer_objectSpread(SubscriptionContainer_objectSpread({}, this.props), {}, {
        loadingComponent: /*#__PURE__*/(0,jsx_runtime.jsx)(DashboardSettings_styles/* LoaderWrapper */.sb, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
            bgColor: "#FFF",
            itemColor: Dashboard_global_styles/* colors.pink */.O9.pink,
            itemSize: 100
          })
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Subscription_Subscription, SubscriptionContainer_objectSpread(SubscriptionContainer_objectSpread({}, this.props), {}, {
          getDiscount: this.getDiscount.bind(this, this.props.client),
          handleStripeToken: this.handleStripeToken.bind(this),
          onRequestInvoice: this.props.requestQuote
        }))
      }));
    }
  }]);

  return SubscriptionContainer;
}(react.Component);

/* harmony default export */ var Subscription_SubscriptionContainer = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DataContainer/* default */.Z, {
    queries: graphql_queries,
    mutations: graphql_mutations,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriptionContainer, SubscriptionContainer_objectSpread({}, props))
  });
});
;// CONCATENATED MODULE: ./modules/dashboard/DashboardSettings/DashboardSettings.js






function DashboardSettings_createSuper(Derived) { var hasNativeReflectConstruct = DashboardSettings_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function DashboardSettings_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var DashboardSettings = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(DashboardSettings, _Component);

  var _super = DashboardSettings_createSuper(DashboardSettings);

  function DashboardSettings() {
    (0,classCallCheck/* default */.Z)(this, DashboardSettings);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DashboardSettings, [{
    key: "isActive",
    value: function isActive(path) {
      return location.pathname.split('/').indexOf(path) !== -1;
    }
  }, {
    key: "getNavbarItems",
    value: function getNavbarItems(currentUser) {
      var navbarItems = [{
        text: 'Your Class',
        to: "/dashboard/settings/your-class",
        selected: this.isActive('your-class')
      }, {
        text: 'Your Account',
        to: "/dashboard/settings/your-account",
        selected: this.isActive('your-account')
      }, {
        text: 'Subscription',
        to: "/dashboard/settings/subscription",
        selected: this.isActive('subscription')
      }, {
        text: 'Refer a Friend',
        to: "/dashboard/settings/refer",
        selected: this.isActive('refer')
      } // {
      //   text: 'Curriculum',
      //   to: `${match.path}/curriculum`,
      //   selected: this.isActive('curriculum')
      // }
      ];

      if (!currentUser.parent) {
        navbarItems.splice(3, 0, {
          text: 'School Account',
          to: "/dashboard/settings/school-account",
          selected: this.isActive('school-account')
        });
        navbarItems.pop();

        if (!currentUser.isUnderCustomSubscription) {
          navbarItems.push({
            text: 'Refer a Teacher',
            to: "/dashboard/settings/refer",
            selected: this.isActive('refer')
          });
        }
      }

      return navbarItems;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(CurrentUser/* CurrentUserConsumer */.s1, {
        children: function children(currentUser) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DashboardSettings_styles/* PageWrapper */.FE, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalContext/* default.Consumer */.Z.Consumer, {
              children: function children(modal) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {
                  items: _this.getNavbarItems(currentUser),
                  backLink: "/dashboard/classroom",
                  isSettings: true,
                  bgColor: Dashboard_global_styles/* colors.paleBlue */.O9.paleBlue,
                  modal: modal
                }, 'navbar');
              }
            }), _this.props.category === 'your-class' && /*#__PURE__*/(0,jsx_runtime.jsx)(YourClass_YourClassContainer, {}), _this.props.category === 'your-account' && /*#__PURE__*/(0,jsx_runtime.jsx)(YourAccount_YourAccountContainer, {}), _this.props.category === 'school-account' && /*#__PURE__*/(0,jsx_runtime.jsx)(SchoolAccount_SchoolAccountContainer, {
              ambassadorSignUp: _this.props.ambassadorSignUp
            }), _this.props.category === 'refer' && /*#__PURE__*/(0,jsx_runtime.jsx)(Referrals_ReferralsContainer, {
              ambassadorSignUp: _this.props.ambassadorSignUp
            }), _this.props.category === 'subscription' && /*#__PURE__*/(0,jsx_runtime.jsx)(Subscription_SubscriptionContainer, {})]
          }, 'page-wrapper');
        }
      });
    }
  }]);

  return DashboardSettings;
}(react.Component);



/***/ })

}]);